var xu = Object.defineProperty;
var Du = (t, e, r) => e in t ? xu(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var Ve = (t, e, r) => (Du(t, typeof e != "symbol" ? e + "" : e, r), r);
import { jsx as $, jsxs as Re, Fragment as Bn } from "react/jsx-runtime";
import Su, { createContext as nt, useContext as Ce, createElement as Le, forwardRef as Go, memo as Cu, useDebugValue as Pn, useMemo as Fe, useEffect as ie, useLayoutEffect as Tu, useRef as ee, useState as le, useCallback as N, useReducer as On, cloneElement as Mr, Suspense as ku } from "react";
import * as Ru from "@tanstack/react-query";
import { useSuspenseQuery as ju, dehydrate as Au, hydrate as Wu, QueryClientProvider as Iu, QueryClient as Nu } from "@tanstack/react-query";
import { I18nextProvider as Fu, useTranslation as Lu } from "react-i18next";
import "i18next";
import { createPortal as Hu } from "react-dom";
var Ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Me(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Jo = { exports: {} };
(function(t, e) {
  (function(a, n) {
    t.exports = n(Su);
  })(Ft, (r) => (
    /******/
    (() => {
      var a = {
        /***/
        "./node_modules/css-mediaquery/index.js": (
          /*!**********************************************!*\
            !*** ./node_modules/css-mediaquery/index.js ***!
            \**********************************************/
          /***/
          (s, i) => {
            i.match = f, i.parse = v;
            var l = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, d = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, m = /^(?:(min|max)-)?(.+)/, p = /(em|rem|px|cm|mm|in|pt|pc)?$/, c = /(dpi|dpcm|dppx)?$/;
            function f(g, b) {
              return v(g).some(function(E) {
                var O = E.inverse, T = E.type === "all" || b.type === E.type;
                if (T && O || !(T || O))
                  return !1;
                var S = E.expressions.every(function(P) {
                  var _ = P.feature, R = P.modifier, x = P.value, D = b[_];
                  if (!D)
                    return !1;
                  switch (_) {
                    case "orientation":
                    case "scan":
                      return D.toLowerCase() === x.toLowerCase();
                    case "width":
                    case "height":
                    case "device-width":
                    case "device-height":
                      x = w(x), D = w(D);
                      break;
                    case "resolution":
                      x = y(x), D = y(D);
                      break;
                    case "aspect-ratio":
                    case "device-aspect-ratio":
                    case /* Deprecated */
                    "device-pixel-ratio":
                      x = h(x), D = h(D);
                      break;
                    case "grid":
                    case "color":
                    case "color-index":
                    case "monochrome":
                      x = parseInt(x, 10) || 1, D = parseInt(D, 10) || 0;
                      break;
                  }
                  switch (R) {
                    case "min":
                      return D >= x;
                    case "max":
                      return D <= x;
                    default:
                      return D === x;
                  }
                });
                return S && !O || !S && O;
              });
            }
            function v(g) {
              return g.split(",").map(function(b) {
                b = b.trim();
                var E = b.match(l), O = E[1], T = E[2], S = E[3] || "", P = {};
                return P.inverse = !!O && O.toLowerCase() === "not", P.type = T ? T.toLowerCase() : "all", S = S.match(/\([^\)]+\)/g) || [], P.expressions = S.map(function(_) {
                  var R = _.match(d), x = R[1].toLowerCase().match(m);
                  return {
                    modifier: x[1],
                    feature: x[2],
                    value: R[2]
                  };
                }), P;
              });
            }
            function h(g) {
              var b = Number(g), E;
              return b || (E = g.match(/^(\d+)\s*\/\s*(\d+)$/), b = E[1] / E[2]), b;
            }
            function y(g) {
              var b = parseFloat(g), E = String(g).match(c)[1];
              switch (E) {
                case "dpcm":
                  return b / 2.54;
                case "dppx":
                  return b * 96;
                default:
                  return b;
              }
            }
            function w(g) {
              var b = parseFloat(g), E = String(g).match(p)[1];
              switch (E) {
                case "em":
                  return b * 16;
                case "rem":
                  return b * 16;
                case "cm":
                  return b * 96 / 2.54;
                case "mm":
                  return b * 96 / 2.54 / 10;
                case "in":
                  return b * 96;
                case "pt":
                  return b * 72;
                case "pc":
                  return b * 72 / 12;
                default:
                  return b;
              }
            }
          }
        ),
        /***/
        "./node_modules/hyphenate-style-name/index.js": (
          /*!****************************************************!*\
            !*** ./node_modules/hyphenate-style-name/index.js ***!
            \****************************************************/
          /***/
          (s, i, l) => {
            l.r(i), l.d(i, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var d = /[A-Z]/g, m = /^ms-/, p = {};
            function c(h) {
              return "-" + h.toLowerCase();
            }
            function f(h) {
              if (p.hasOwnProperty(h))
                return p[h];
              var y = h.replace(d, c);
              return p[h] = m.test(y) ? "-" + y : y;
            }
            const v = f;
          }
        ),
        /***/
        "./node_modules/matchmediaquery/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/matchmediaquery/index.js ***!
            \***********************************************/
          /***/
          (s, i, l) => {
            var d = l(
              /*! css-mediaquery */
              "./node_modules/css-mediaquery/index.js"
            ).match, m = typeof window < "u" ? window.matchMedia : null;
            function p(f, v, h) {
              var y = this;
              if (m && !h) {
                var w = m.call(window, f);
                this.matches = w.matches, this.media = w.media, w.addListener(E);
              } else
                this.matches = d(f, v), this.media = f;
              this.addListener = g, this.removeListener = b, this.dispose = O;
              function g(T) {
                w && w.addListener(T);
              }
              function b(T) {
                w && w.removeListener(T);
              }
              function E(T) {
                y.matches = T.matches, y.media = T.media;
              }
              function O() {
                w && w.removeListener(E);
              }
            }
            function c(f, v, h) {
              return new p(f, v, h);
            }
            s.exports = c;
          }
        ),
        /***/
        "./node_modules/object-assign/index.js": (
          /*!*********************************************!*\
            !*** ./node_modules/object-assign/index.js ***!
            \*********************************************/
          /***/
          (s) => {
            /*
            object-assign
            (c) Sindre Sorhus
            @license MIT
            */
            var i = Object.getOwnPropertySymbols, l = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
            function m(c) {
              if (c == null)
                throw new TypeError("Object.assign cannot be called with null or undefined");
              return Object(c);
            }
            function p() {
              try {
                if (!Object.assign)
                  return !1;
                var c = new String("abc");
                if (c[5] = "de", Object.getOwnPropertyNames(c)[0] === "5")
                  return !1;
                for (var f = {}, v = 0; v < 10; v++)
                  f["_" + String.fromCharCode(v)] = v;
                var h = Object.getOwnPropertyNames(f).map(function(w) {
                  return f[w];
                });
                if (h.join("") !== "0123456789")
                  return !1;
                var y = {};
                return "abcdefghijklmnopqrst".split("").forEach(function(w) {
                  y[w] = w;
                }), Object.keys(Object.assign({}, y)).join("") === "abcdefghijklmnopqrst";
              } catch {
                return !1;
              }
            }
            s.exports = p() ? Object.assign : function(c, f) {
              for (var v, h = m(c), y, w = 1; w < arguments.length; w++) {
                v = Object(arguments[w]);
                for (var g in v)
                  l.call(v, g) && (h[g] = v[g]);
                if (i) {
                  y = i(v);
                  for (var b = 0; b < y.length; b++)
                    d.call(v, y[b]) && (h[y[b]] = v[y[b]]);
                }
              }
              return h;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/checkPropTypes.js": (
          /*!***************************************************!*\
            !*** ./node_modules/prop-types/checkPropTypes.js ***!
            \***************************************************/
          /***/
          (s, i, l) => {
            var d = function() {
            };
            {
              var m = l(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), p = {}, c = l(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              );
              d = function(v) {
                var h = "Warning: " + v;
                typeof console < "u" && console.error(h);
                try {
                  throw new Error(h);
                } catch {
                }
              };
            }
            function f(v, h, y, w, g) {
              for (var b in v)
                if (c(v, b)) {
                  var E;
                  try {
                    if (typeof v[b] != "function") {
                      var O = Error(
                        (w || "React class") + ": " + y + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                      );
                      throw O.name = "Invariant Violation", O;
                    }
                    E = v[b](h, b, w, y, null, m);
                  } catch (S) {
                    E = S;
                  }
                  if (E && !(E instanceof Error) && d(
                    (w || "React class") + ": type specification of " + y + " `" + b + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof E + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                  ), E instanceof Error && !(E.message in p)) {
                    p[E.message] = !0;
                    var T = g ? g() : "";
                    d(
                      "Failed " + y + " type: " + E.message + (T ?? "")
                    );
                  }
                }
            }
            f.resetWarningCache = function() {
              p = {};
            }, s.exports = f;
          }
        ),
        /***/
        "./node_modules/prop-types/factoryWithTypeCheckers.js": (
          /*!************************************************************!*\
            !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
            \************************************************************/
          /***/
          (s, i, l) => {
            var d = l(
              /*! react-is */
              "./node_modules/react-is/index.js"
            ), m = l(
              /*! object-assign */
              "./node_modules/object-assign/index.js"
            ), p = l(
              /*! ./lib/ReactPropTypesSecret */
              "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
            ), c = l(
              /*! ./lib/has */
              "./node_modules/prop-types/lib/has.js"
            ), f = l(
              /*! ./checkPropTypes */
              "./node_modules/prop-types/checkPropTypes.js"
            ), v = function() {
            };
            v = function(y) {
              var w = "Warning: " + y;
              typeof console < "u" && console.error(w);
              try {
                throw new Error(w);
              } catch {
              }
            };
            function h() {
              return null;
            }
            s.exports = function(y, w) {
              var g = typeof Symbol == "function" && Symbol.iterator, b = "@@iterator";
              function E(k) {
                var W = k && (g && k[g] || k[b]);
                if (typeof W == "function")
                  return W;
              }
              var O = "<<anonymous>>", T = {
                array: R("array"),
                bigint: R("bigint"),
                bool: R("boolean"),
                func: R("function"),
                number: R("number"),
                object: R("object"),
                string: R("string"),
                symbol: R("symbol"),
                any: x(),
                arrayOf: D,
                element: I(),
                elementType: C(),
                instanceOf: A,
                node: de(),
                objectOf: J,
                oneOf: V,
                oneOfType: Z,
                shape: ne,
                exact: ve
              };
              function S(k, W) {
                return k === W ? k !== 0 || 1 / k === 1 / W : k !== k && W !== W;
              }
              function P(k, W) {
                this.message = k, this.data = W && typeof W == "object" ? W : {}, this.stack = "";
              }
              P.prototype = Error.prototype;
              function _(k) {
                var W = {}, K = 0;
                function z(G, Y, q, X, oe, U, j) {
                  if (X = X || O, U = U || q, j !== p) {
                    if (w) {
                      var se = new Error(
                        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                      );
                      throw se.name = "Invariant Violation", se;
                    } else if (typeof console < "u") {
                      var we = X + ":" + q;
                      !W[we] && // Avoid spamming the console because they are often not actionable except for lib authors
                      K < 3 && (v(
                        "You are manually calling a React.PropTypes validation function for the `" + U + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                      ), W[we] = !0, K++);
                    }
                  }
                  return Y[q] == null ? G ? Y[q] === null ? new P("The " + oe + " `" + U + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new P("The " + oe + " `" + U + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : k(Y, q, X, oe, U);
                }
                var H = z.bind(null, !1);
                return H.isRequired = z.bind(null, !0), H;
              }
              function R(k) {
                function W(K, z, H, G, Y, q) {
                  var X = K[z], oe = Q(X);
                  if (oe !== k) {
                    var U = be(X);
                    return new P(
                      "Invalid " + G + " `" + Y + "` of type " + ("`" + U + "` supplied to `" + H + "`, expected ") + ("`" + k + "`."),
                      { expectedType: k }
                    );
                  }
                  return null;
                }
                return _(W);
              }
              function x() {
                return _(h);
              }
              function D(k) {
                function W(K, z, H, G, Y) {
                  if (typeof k != "function")
                    return new P("Property `" + Y + "` of component `" + H + "` has invalid PropType notation inside arrayOf.");
                  var q = K[z];
                  if (!Array.isArray(q)) {
                    var X = Q(q);
                    return new P("Invalid " + G + " `" + Y + "` of type " + ("`" + X + "` supplied to `" + H + "`, expected an array."));
                  }
                  for (var oe = 0; oe < q.length; oe++) {
                    var U = k(q, oe, H, G, Y + "[" + oe + "]", p);
                    if (U instanceof Error)
                      return U;
                  }
                  return null;
                }
                return _(W);
              }
              function I() {
                function k(W, K, z, H, G) {
                  var Y = W[K];
                  if (!y(Y)) {
                    var q = Q(Y);
                    return new P("Invalid " + H + " `" + G + "` of type " + ("`" + q + "` supplied to `" + z + "`, expected a single ReactElement."));
                  }
                  return null;
                }
                return _(k);
              }
              function C() {
                function k(W, K, z, H, G) {
                  var Y = W[K];
                  if (!d.isValidElementType(Y)) {
                    var q = Q(Y);
                    return new P("Invalid " + H + " `" + G + "` of type " + ("`" + q + "` supplied to `" + z + "`, expected a single ReactElement type."));
                  }
                  return null;
                }
                return _(k);
              }
              function A(k) {
                function W(K, z, H, G, Y) {
                  if (!(K[z] instanceof k)) {
                    var q = k.name || O, X = Ee(K[z]);
                    return new P("Invalid " + G + " `" + Y + "` of type " + ("`" + X + "` supplied to `" + H + "`, expected ") + ("instance of `" + q + "`."));
                  }
                  return null;
                }
                return _(W);
              }
              function V(k) {
                if (!Array.isArray(k))
                  return arguments.length > 1 ? v(
                    "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                  ) : v("Invalid argument supplied to oneOf, expected an array."), h;
                function W(K, z, H, G, Y) {
                  for (var q = K[z], X = 0; X < k.length; X++)
                    if (S(q, k[X]))
                      return null;
                  var oe = JSON.stringify(k, function(j, se) {
                    var we = be(se);
                    return we === "symbol" ? String(se) : se;
                  });
                  return new P("Invalid " + G + " `" + Y + "` of value `" + String(q) + "` " + ("supplied to `" + H + "`, expected one of " + oe + "."));
                }
                return _(W);
              }
              function J(k) {
                function W(K, z, H, G, Y) {
                  if (typeof k != "function")
                    return new P("Property `" + Y + "` of component `" + H + "` has invalid PropType notation inside objectOf.");
                  var q = K[z], X = Q(q);
                  if (X !== "object")
                    return new P("Invalid " + G + " `" + Y + "` of type " + ("`" + X + "` supplied to `" + H + "`, expected an object."));
                  for (var oe in q)
                    if (c(q, oe)) {
                      var U = k(q, oe, H, G, Y + "." + oe, p);
                      if (U instanceof Error)
                        return U;
                    }
                  return null;
                }
                return _(W);
              }
              function Z(k) {
                if (!Array.isArray(k))
                  return v("Invalid argument supplied to oneOfType, expected an instance of array."), h;
                for (var W = 0; W < k.length; W++) {
                  var K = k[W];
                  if (typeof K != "function")
                    return v(
                      "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ge(K) + " at index " + W + "."
                    ), h;
                }
                function z(H, G, Y, q, X) {
                  for (var oe = [], U = 0; U < k.length; U++) {
                    var j = k[U], se = j(H, G, Y, q, X, p);
                    if (se == null)
                      return null;
                    se.data && c(se.data, "expectedType") && oe.push(se.data.expectedType);
                  }
                  var we = oe.length > 0 ? ", expected one of type [" + oe.join(", ") + "]" : "";
                  return new P("Invalid " + q + " `" + X + "` supplied to " + ("`" + Y + "`" + we + "."));
                }
                return _(z);
              }
              function de() {
                function k(W, K, z, H, G) {
                  return F(W[K]) ? null : new P("Invalid " + H + " `" + G + "` supplied to " + ("`" + z + "`, expected a ReactNode."));
                }
                return _(k);
              }
              function ae(k, W, K, z, H) {
                return new P(
                  (k || "React class") + ": " + W + " type `" + K + "." + z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + H + "`."
                );
              }
              function ne(k) {
                function W(K, z, H, G, Y) {
                  var q = K[z], X = Q(q);
                  if (X !== "object")
                    return new P("Invalid " + G + " `" + Y + "` of type `" + X + "` " + ("supplied to `" + H + "`, expected `object`."));
                  for (var oe in k) {
                    var U = k[oe];
                    if (typeof U != "function")
                      return ae(H, G, Y, oe, be(U));
                    var j = U(q, oe, H, G, Y + "." + oe, p);
                    if (j)
                      return j;
                  }
                  return null;
                }
                return _(W);
              }
              function ve(k) {
                function W(K, z, H, G, Y) {
                  var q = K[z], X = Q(q);
                  if (X !== "object")
                    return new P("Invalid " + G + " `" + Y + "` of type `" + X + "` " + ("supplied to `" + H + "`, expected `object`."));
                  var oe = m({}, K[z], k);
                  for (var U in oe) {
                    var j = k[U];
                    if (c(k, U) && typeof j != "function")
                      return ae(H, G, Y, U, be(j));
                    if (!j)
                      return new P(
                        "Invalid " + G + " `" + Y + "` key `" + U + "` supplied to `" + H + "`.\nBad object: " + JSON.stringify(K[z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(k), null, "  ")
                      );
                    var se = j(q, U, H, G, Y + "." + U, p);
                    if (se)
                      return se;
                  }
                  return null;
                }
                return _(W);
              }
              function F(k) {
                switch (typeof k) {
                  case "number":
                  case "string":
                  case "undefined":
                    return !0;
                  case "boolean":
                    return !k;
                  case "object":
                    if (Array.isArray(k))
                      return k.every(F);
                    if (k === null || y(k))
                      return !0;
                    var W = E(k);
                    if (W) {
                      var K = W.call(k), z;
                      if (W !== k.entries) {
                        for (; !(z = K.next()).done; )
                          if (!F(z.value))
                            return !1;
                      } else
                        for (; !(z = K.next()).done; ) {
                          var H = z.value;
                          if (H && !F(H[1]))
                            return !1;
                        }
                    } else
                      return !1;
                    return !0;
                  default:
                    return !1;
                }
              }
              function B(k, W) {
                return k === "symbol" ? !0 : W ? W["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && W instanceof Symbol : !1;
              }
              function Q(k) {
                var W = typeof k;
                return Array.isArray(k) ? "array" : k instanceof RegExp ? "object" : B(W, k) ? "symbol" : W;
              }
              function be(k) {
                if (typeof k > "u" || k === null)
                  return "" + k;
                var W = Q(k);
                if (W === "object") {
                  if (k instanceof Date)
                    return "date";
                  if (k instanceof RegExp)
                    return "regexp";
                }
                return W;
              }
              function ge(k) {
                var W = be(k);
                switch (W) {
                  case "array":
                  case "object":
                    return "an " + W;
                  case "boolean":
                  case "date":
                  case "regexp":
                    return "a " + W;
                  default:
                    return W;
                }
              }
              function Ee(k) {
                return !k.constructor || !k.constructor.name ? O : k.constructor.name;
              }
              return T.checkPropTypes = f, T.resetWarningCache = f.resetWarningCache, T.PropTypes = T, T;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/index.js": (
          /*!******************************************!*\
            !*** ./node_modules/prop-types/index.js ***!
            \******************************************/
          /***/
          (s, i, l) => {
            {
              var d = l(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), m = !0;
              s.exports = l(
                /*! ./factoryWithTypeCheckers */
                "./node_modules/prop-types/factoryWithTypeCheckers.js"
              )(d.isElement, m);
            }
          }
        ),
        /***/
        "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
            \*************************************************************/
          /***/
          (s) => {
            var i = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            s.exports = i;
          }
        ),
        /***/
        "./node_modules/prop-types/lib/has.js": (
          /*!********************************************!*\
            !*** ./node_modules/prop-types/lib/has.js ***!
            \********************************************/
          /***/
          (s) => {
            s.exports = Function.call.bind(Object.prototype.hasOwnProperty);
          }
        ),
        /***/
        "./node_modules/react-is/cjs/react-is.development.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/react-is/cjs/react-is.development.js ***!
            \***********************************************************/
          /***/
          (s, i) => {
            /** @license React v16.13.1
             * react-is.development.js
             *
             * Copyright (c) Facebook, Inc. and its affiliates.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */
            (function() {
              var l = typeof Symbol == "function" && Symbol.for, d = l ? Symbol.for("react.element") : 60103, m = l ? Symbol.for("react.portal") : 60106, p = l ? Symbol.for("react.fragment") : 60107, c = l ? Symbol.for("react.strict_mode") : 60108, f = l ? Symbol.for("react.profiler") : 60114, v = l ? Symbol.for("react.provider") : 60109, h = l ? Symbol.for("react.context") : 60110, y = l ? Symbol.for("react.async_mode") : 60111, w = l ? Symbol.for("react.concurrent_mode") : 60111, g = l ? Symbol.for("react.forward_ref") : 60112, b = l ? Symbol.for("react.suspense") : 60113, E = l ? Symbol.for("react.suspense_list") : 60120, O = l ? Symbol.for("react.memo") : 60115, T = l ? Symbol.for("react.lazy") : 60116, S = l ? Symbol.for("react.block") : 60121, P = l ? Symbol.for("react.fundamental") : 60117, _ = l ? Symbol.for("react.responder") : 60118, R = l ? Symbol.for("react.scope") : 60119;
              function x(j) {
                return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                j === p || j === w || j === f || j === c || j === b || j === E || typeof j == "object" && j !== null && (j.$$typeof === T || j.$$typeof === O || j.$$typeof === v || j.$$typeof === h || j.$$typeof === g || j.$$typeof === P || j.$$typeof === _ || j.$$typeof === R || j.$$typeof === S);
              }
              function D(j) {
                if (typeof j == "object" && j !== null) {
                  var se = j.$$typeof;
                  switch (se) {
                    case d:
                      var we = j.type;
                      switch (we) {
                        case y:
                        case w:
                        case p:
                        case f:
                        case c:
                        case b:
                          return we;
                        default:
                          var Ie = we && we.$$typeof;
                          switch (Ie) {
                            case h:
                            case g:
                            case T:
                            case O:
                            case v:
                              return Ie;
                            default:
                              return se;
                          }
                      }
                    case m:
                      return se;
                  }
                }
              }
              var I = y, C = w, A = h, V = v, J = d, Z = g, de = p, ae = T, ne = O, ve = m, F = f, B = c, Q = b, be = !1;
              function ge(j) {
                return be || (be = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Ee(j) || D(j) === y;
              }
              function Ee(j) {
                return D(j) === w;
              }
              function k(j) {
                return D(j) === h;
              }
              function W(j) {
                return D(j) === v;
              }
              function K(j) {
                return typeof j == "object" && j !== null && j.$$typeof === d;
              }
              function z(j) {
                return D(j) === g;
              }
              function H(j) {
                return D(j) === p;
              }
              function G(j) {
                return D(j) === T;
              }
              function Y(j) {
                return D(j) === O;
              }
              function q(j) {
                return D(j) === m;
              }
              function X(j) {
                return D(j) === f;
              }
              function oe(j) {
                return D(j) === c;
              }
              function U(j) {
                return D(j) === b;
              }
              i.AsyncMode = I, i.ConcurrentMode = C, i.ContextConsumer = A, i.ContextProvider = V, i.Element = J, i.ForwardRef = Z, i.Fragment = de, i.Lazy = ae, i.Memo = ne, i.Portal = ve, i.Profiler = F, i.StrictMode = B, i.Suspense = Q, i.isAsyncMode = ge, i.isConcurrentMode = Ee, i.isContextConsumer = k, i.isContextProvider = W, i.isElement = K, i.isForwardRef = z, i.isFragment = H, i.isLazy = G, i.isMemo = Y, i.isPortal = q, i.isProfiler = X, i.isStrictMode = oe, i.isSuspense = U, i.isValidElementType = x, i.typeOf = D;
            })();
          }
        ),
        /***/
        "./node_modules/react-is/index.js": (
          /*!****************************************!*\
            !*** ./node_modules/react-is/index.js ***!
            \****************************************/
          /***/
          (s, i, l) => {
            s.exports = l(
              /*! ./cjs/react-is.development.js */
              "./node_modules/react-is/cjs/react-is.development.js"
            );
          }
        ),
        /***/
        "./node_modules/shallow-equal/dist/index.esm.js": (
          /*!******************************************************!*\
            !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
            \******************************************************/
          /***/
          (s, i, l) => {
            l.r(i), l.d(i, {
              /* harmony export */
              shallowEqualArrays: () => (
                /* binding */
                m
              ),
              /* harmony export */
              shallowEqualObjects: () => (
                /* binding */
                d
              )
              /* harmony export */
            });
            function d(p, c) {
              if (p === c)
                return !0;
              if (!p || !c)
                return !1;
              var f = Object.keys(p), v = Object.keys(c), h = f.length;
              if (v.length !== h)
                return !1;
              for (var y = 0; y < h; y++) {
                var w = f[y];
                if (p[w] !== c[w] || !Object.prototype.hasOwnProperty.call(c, w))
                  return !1;
              }
              return !0;
            }
            function m(p, c) {
              if (p === c)
                return !0;
              if (!p || !c)
                return !1;
              var f = p.length;
              if (c.length !== f)
                return !1;
              for (var v = 0; v < f; v++)
                if (p[v] !== c[v])
                  return !1;
              return !0;
            }
          }
        ),
        /***/
        "./src/Component.ts": (
          /*!**************************!*\
            !*** ./src/Component.ts ***!
            \**************************/
          /***/
          function(s, i, l) {
            var d = this && this.__rest || function(f, v) {
              var h = {};
              for (var y in f)
                Object.prototype.hasOwnProperty.call(f, y) && v.indexOf(y) < 0 && (h[y] = f[y]);
              if (f != null && typeof Object.getOwnPropertySymbols == "function")
                for (var w = 0, y = Object.getOwnPropertySymbols(f); w < y.length; w++)
                  v.indexOf(y[w]) < 0 && Object.prototype.propertyIsEnumerable.call(f, y[w]) && (h[y[w]] = f[y[w]]);
              return h;
            }, m = this && this.__importDefault || function(f) {
              return f && f.__esModule ? f : { default: f };
            };
            Object.defineProperty(i, "__esModule", { value: !0 });
            var p = m(l(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            )), c = function(f) {
              var v = f.children, h = f.device, y = f.onChange, w = d(f, ["children", "device", "onChange"]), g = (0, p.default)(w, h, y);
              return typeof v == "function" ? v(g) : g ? v : null;
            };
            i.default = c;
          }
        ),
        /***/
        "./src/Context.ts": (
          /*!************************!*\
            !*** ./src/Context.ts ***!
            \************************/
          /***/
          (s, i, l) => {
            Object.defineProperty(i, "__esModule", { value: !0 });
            var d = l(
              /*! react */
              "react"
            ), m = (0, d.createContext)(void 0);
            i.default = m;
          }
        ),
        /***/
        "./src/index.ts": (
          /*!**********************!*\
            !*** ./src/index.ts ***!
            \**********************/
          /***/
          function(s, i, l) {
            var d = this && this.__importDefault || function(v) {
              return v && v.__esModule ? v : { default: v };
            };
            Object.defineProperty(i, "__esModule", { value: !0 }), i.Context = i.toQuery = i.useMediaQuery = i.default = void 0;
            var m = d(l(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            ));
            i.useMediaQuery = m.default;
            var p = d(l(
              /*! ./Component */
              "./src/Component.ts"
            ));
            i.default = p.default;
            var c = d(l(
              /*! ./toQuery */
              "./src/toQuery.ts"
            ));
            i.toQuery = c.default;
            var f = d(l(
              /*! ./Context */
              "./src/Context.ts"
            ));
            i.Context = f.default;
          }
        ),
        /***/
        "./src/mediaQuery.ts": (
          /*!***************************!*\
            !*** ./src/mediaQuery.ts ***!
            \***************************/
          /***/
          function(s, i, l) {
            var d = this && this.__assign || function() {
              return d = Object.assign || function(b) {
                for (var E, O = 1, T = arguments.length; O < T; O++) {
                  E = arguments[O];
                  for (var S in E)
                    Object.prototype.hasOwnProperty.call(E, S) && (b[S] = E[S]);
                }
                return b;
              }, d.apply(this, arguments);
            }, m = this && this.__rest || function(b, E) {
              var O = {};
              for (var T in b)
                Object.prototype.hasOwnProperty.call(b, T) && E.indexOf(T) < 0 && (O[T] = b[T]);
              if (b != null && typeof Object.getOwnPropertySymbols == "function")
                for (var S = 0, T = Object.getOwnPropertySymbols(b); S < T.length; S++)
                  E.indexOf(T[S]) < 0 && Object.prototype.propertyIsEnumerable.call(b, T[S]) && (O[T[S]] = b[T[S]]);
              return O;
            }, p = this && this.__importDefault || function(b) {
              return b && b.__esModule ? b : { default: b };
            };
            Object.defineProperty(i, "__esModule", { value: !0 });
            var c = p(l(
              /*! prop-types */
              "./node_modules/prop-types/index.js"
            )), f = c.default.oneOfType([
              c.default.string,
              c.default.number
            ]), v = {
              all: c.default.bool,
              grid: c.default.bool,
              aural: c.default.bool,
              braille: c.default.bool,
              handheld: c.default.bool,
              print: c.default.bool,
              projection: c.default.bool,
              screen: c.default.bool,
              tty: c.default.bool,
              tv: c.default.bool,
              embossed: c.default.bool
            }, h = {
              orientation: c.default.oneOf([
                "portrait",
                "landscape"
              ]),
              scan: c.default.oneOf([
                "progressive",
                "interlace"
              ]),
              aspectRatio: c.default.string,
              deviceAspectRatio: c.default.string,
              height: f,
              deviceHeight: f,
              width: f,
              deviceWidth: f,
              color: c.default.bool,
              colorIndex: c.default.bool,
              monochrome: c.default.bool,
              resolution: f,
              type: Object.keys(v)
            };
            h.type;
            var y = m(
              h,
              ["type"]
            ), w = d({ minAspectRatio: c.default.string, maxAspectRatio: c.default.string, minDeviceAspectRatio: c.default.string, maxDeviceAspectRatio: c.default.string, minHeight: f, maxHeight: f, minDeviceHeight: f, maxDeviceHeight: f, minWidth: f, maxWidth: f, minDeviceWidth: f, maxDeviceWidth: f, minColor: c.default.number, maxColor: c.default.number, minColorIndex: c.default.number, maxColorIndex: c.default.number, minMonochrome: c.default.number, maxMonochrome: c.default.number, minResolution: f, maxResolution: f }, y), g = d(d({}, v), w);
            i.default = {
              all: g,
              types: v,
              matchers: h,
              features: w
            };
          }
        ),
        /***/
        "./src/toQuery.ts": (
          /*!************************!*\
            !*** ./src/toQuery.ts ***!
            \************************/
          /***/
          function(s, i, l) {
            var d = this && this.__importDefault || function(y) {
              return y && y.__esModule ? y : { default: y };
            };
            Object.defineProperty(i, "__esModule", { value: !0 });
            var m = d(l(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), p = d(l(
              /*! ./mediaQuery */
              "./src/mediaQuery.ts"
            )), c = function(y) {
              return "not ".concat(y);
            }, f = function(y, w) {
              var g = (0, m.default)(y);
              return typeof w == "number" && (w = "".concat(w, "px")), w === !0 ? g : w === !1 ? c(g) : "(".concat(g, ": ").concat(w, ")");
            }, v = function(y) {
              return y.join(" and ");
            }, h = function(y) {
              var w = [];
              return Object.keys(p.default.all).forEach(function(g) {
                var b = y[g];
                b != null && w.push(f(g, b));
              }), v(w);
            };
            i.default = h;
          }
        ),
        /***/
        "./src/useMediaQuery.ts": (
          /*!******************************!*\
            !*** ./src/useMediaQuery.ts ***!
            \******************************/
          /***/
          function(s, i, l) {
            var d = this && this.__importDefault || function(P) {
              return P && P.__esModule ? P : { default: P };
            };
            Object.defineProperty(i, "__esModule", { value: !0 });
            var m = l(
              /*! react */
              "react"
            ), p = d(l(
              /*! matchmediaquery */
              "./node_modules/matchmediaquery/index.js"
            )), c = d(l(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), f = l(
              /*! shallow-equal */
              "./node_modules/shallow-equal/dist/index.esm.js"
            ), v = d(l(
              /*! ./toQuery */
              "./src/toQuery.ts"
            )), h = d(l(
              /*! ./Context */
              "./src/Context.ts"
            )), y = function(P) {
              return P.query || (0, v.default)(P);
            }, w = function(P) {
              if (P) {
                var _ = Object.keys(P);
                return _.reduce(function(R, x) {
                  return R[(0, c.default)(x)] = P[x], R;
                }, {});
              }
            }, g = function() {
              var P = (0, m.useRef)(!1);
              return (0, m.useEffect)(function() {
                P.current = !0;
              }, []), P.current;
            }, b = function(P) {
              var _ = (0, m.useContext)(h.default), R = function() {
                return w(P) || w(_);
              }, x = (0, m.useState)(R), D = x[0], I = x[1];
              return (0, m.useEffect)(function() {
                var C = R();
                (0, f.shallowEqualObjects)(D, C) || I(C);
              }, [P, _]), D;
            }, E = function(P) {
              var _ = function() {
                return y(P);
              }, R = (0, m.useState)(_), x = R[0], D = R[1];
              return (0, m.useEffect)(function() {
                var I = _();
                x !== I && D(I);
              }, [P]), x;
            }, O = function(P, _) {
              var R = function() {
                return (0, p.default)(P, _ || {}, !!_);
              }, x = (0, m.useState)(R), D = x[0], I = x[1], C = g();
              return (0, m.useEffect)(function() {
                if (C) {
                  var A = R();
                  return I(A), function() {
                    A && A.dispose();
                  };
                }
              }, [P, _]), D;
            }, T = function(P) {
              var _ = (0, m.useState)(P.matches), R = _[0], x = _[1];
              return (0, m.useEffect)(function() {
                var D = function(I) {
                  x(I.matches);
                };
                return P.addListener(D), x(P.matches), function() {
                  P.removeListener(D);
                };
              }, [P]), R;
            }, S = function(P, _, R) {
              var x = b(_), D = E(P);
              if (!D)
                throw new Error("Invalid or missing MediaQuery!");
              var I = O(D, x), C = T(I), A = g();
              return (0, m.useEffect)(function() {
                A && R && R(C);
              }, [C]), (0, m.useEffect)(function() {
                return function() {
                  I && I.dispose();
                };
              }, []), C;
            };
            i.default = S;
          }
        ),
        /***/
        react: (
          /*!**************************************************************************************!*\
            !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
            \**************************************************************************************/
          /***/
          (s) => {
            s.exports = r;
          }
        )
        /******/
      }, n = {};
      function o(s) {
        var i = n[s];
        if (i !== void 0)
          return i.exports;
        var l = n[s] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return a[s].call(l.exports, l, l.exports, o), l.exports;
      }
      o.d = (s, i) => {
        for (var l in i)
          o.o(i, l) && !o.o(s, l) && Object.defineProperty(s, l, { enumerable: !0, get: i[l] });
      }, o.o = (s, i) => Object.prototype.hasOwnProperty.call(s, i), o.r = (s) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
      };
      var u = o("./src/index.ts");
      return u;
    })()
  ));
})(Jo);
var $u = Jo.exports;
function zu(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function qn(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    e && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function M(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qn(Object(r), !0).forEach(function(a) {
      zu(t, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qn(Object(r)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return t;
}
function te(t, e) {
  if (t == null)
    return {};
  var r = {}, a = Object.keys(t), n, o;
  for (o = 0; o < a.length; o++)
    n = a[o], !(e.indexOf(n) >= 0) && (r[n] = t[n]);
  return r;
}
function Yu(t, e) {
  if (t) {
    if (typeof t == "string")
      return Un(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Un(t, e);
  }
}
function Un(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, a = new Array(e); r < e; r++)
    a[r] = t[r];
  return a;
}
function ht(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = Yu(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var a = 0;
      return function() {
        return a >= t.length ? {
          done: !0
        } : {
          done: !1,
          value: t[a++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = t[Symbol.iterator](), r.next.bind(r);
}
var xn = /* @__PURE__ */ nt({});
function Bu(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function Kn(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    e && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function Pt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Kn(Object(r), !0).forEach(function(a) {
      Bu(t, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Kn(Object(r)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return t;
}
function Wr(t, e) {
  if (t == null)
    return {};
  var r = {}, a = Object.keys(t), n, o;
  for (o = 0; o < a.length; o++)
    n = a[o], !(e.indexOf(n) >= 0) && (r[n] = t[n]);
  return r;
}
function qu(t, e) {
  if (t) {
    if (typeof t == "string")
      return Xn(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Xn(t, e);
  }
}
function Xn(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, a = new Array(e); r < e; r++)
    a[r] = t[r];
  return a;
}
function Vn(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = qu(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var a = 0;
      return function() {
        return a >= t.length ? {
          done: !0
        } : {
          done: !1,
          value: t[a++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = t[Symbol.iterator](), r.next.bind(r);
}
function Uu(t) {
  return typeof t == "function";
}
var kt = function(e, r, a) {
  a === void 0 && (a = r.children);
  var n = Ce(xn);
  if (n.useCreateElement)
    return n.useCreateElement(e, r, a);
  if (typeof e == "string" && Uu(a)) {
    r.children;
    var o = Wr(r, ["children"]);
    return a(o);
  }
  return /* @__PURE__ */ Le(e, r, a);
};
function Ku(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function Qn(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    e && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function tt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Qn(Object(r), !0).forEach(function(a) {
      Ku(t, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Qn(Object(r)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return t;
}
function Xu(t, e) {
  if (t == null)
    return {};
  var r = {}, a = Object.keys(t), n, o;
  for (o = 0; o < a.length; o++)
    n = a[o], !(e.indexOf(n) >= 0) && (r[n] = t[n]);
  return r;
}
function Vu(t, e) {
  if (t) {
    if (typeof t == "string")
      return Gn(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Gn(t, e);
  }
}
function Gn(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, a = new Array(e); r < e; r++)
    a[r] = t[r];
  return a;
}
function Qu(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = Vu(t)) || e && t && typeof t.length == "number") {
      r && (t = r);
      var a = 0;
      return function() {
        return a >= t.length ? {
          done: !0
        } : {
          done: !1,
          value: t[a++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = t[Symbol.iterator](), r.next.bind(r);
}
function Dn(t) {
  return typeof t == "object" && t != null;
}
function Ir(t) {
  var e;
  if (!Dn(t))
    return !1;
  var r = Object.getPrototypeOf(t);
  return r == null ? !0 : ((e = r.constructor) === null || e === void 0 ? void 0 : e.toString()) === Object.toString();
}
function Jn(t, e) {
  for (var r = Object.keys(t), a = {}, n = {}, o = 0, u = r; o < u.length; o++) {
    var s = u[o];
    e.indexOf(s) >= 0 ? a[s] = t[s] : n[s] = t[s];
  }
  return [a, n];
}
function Zn(t, e) {
  if (e === void 0 && (e = []), !Ir(t.state))
    return Jn(t, e);
  var r = Jn(t, [].concat(e, ["state"])), a = r[0], n = r[1], o = a.state, u = Xu(a, ["state"]);
  return [tt(tt({}, o), u), n];
}
function Bt(t, e) {
  if (t === e)
    return !0;
  if (!t || !e || typeof t != "object" || typeof e != "object")
    return !1;
  var r = Object.keys(t), a = Object.keys(e), n = r.length;
  if (a.length !== n)
    return !1;
  for (var o = 0, u = r; o < u.length; o++) {
    var s = u[o];
    if (t[s] !== e[s])
      return !1;
  }
  return !0;
}
function eo(t) {
  return t.name === "normalizePropsAreEqualInner" ? t : function(r, a) {
    return !Ir(r.state) || !Ir(a.state) ? t(r, a) : t(tt(tt({}, r.state), r), tt(tt({}, a.state), a));
  };
}
function Gu(t) {
  return /* @__PURE__ */ Go(t);
}
function Ju(t, e) {
  return /* @__PURE__ */ Cu(t, e);
}
function he(t) {
  var e = t.as, r = t.useHook, a = t.memo, n = t.propsAreEqual, o = n === void 0 ? r == null ? void 0 : r.unstable_propsAreEqual : n, u = t.keys, s = u === void 0 ? (r == null ? void 0 : r.__keys) || [] : u, i = t.useCreateElement, l = i === void 0 ? kt : i, d = function(p, c) {
    var f = p.as, v = f === void 0 ? e : f, h = Wr(p, ["as"]);
    if (r) {
      var y, w = Zn(h, s), g = w[0], b = w[1], E = r(g, Pt({
        ref: c
      }, b)), O = E.wrapElement, T = Wr(E, ["wrapElement"]), S = ((y = v.render) === null || y === void 0 ? void 0 : y.__keys) || v.__keys, P = S && Zn(h, S)[0], _ = P ? Pt(Pt({}, T), P) : T, R = l(v, _);
      return O ? O(R) : R;
    }
    return l(v, Pt({
      ref: c
    }, h));
  };
  return process.env.NODE_ENV !== "production" && r && (d.displayName = r.name.replace(/^(unstable_)?use/, "")), d = Gu(d), a && (d = Ju(d, o && eo(o))), d.__keys = s, d.unstable_propsAreEqual = eo(o || Bt), d;
}
function Zo(t, e) {
  Pn(t);
  var r = Ce(xn);
  return r[t] != null ? r[t] : e;
}
function Zu(t, e, r) {
  e === void 0 && (e = {}), r === void 0 && (r = {});
  var a = "use" + t + "Props";
  Pn(a);
  var n = Zo(a);
  return n ? n(e, r) : r;
}
function es(t, e, r) {
  e === void 0 && (e = {}), r === void 0 && (r = {});
  var a = "use" + t + "Options";
  Pn(a);
  var n = Zo(a);
  return n ? Pt(Pt({}, e), n(e, r)) : e;
}
function ts(t) {
  return Array.isArray(t) ? t : typeof t < "u" ? [t] : [];
}
function pe(t) {
  var e, r, a = ts(t.compose), n = function(i, l) {
    if (t.useOptions && (i = t.useOptions(i, l)), t.name && (i = es(t.name, i, l)), t.compose)
      for (var d = Vn(a), m; !(m = d()).done; ) {
        var p = m.value;
        i = p.__useOptions(i, l);
      }
    return i;
  }, o = function(i, l, d) {
    if (i === void 0 && (i = {}), l === void 0 && (l = {}), d === void 0 && (d = !1), d || (i = n(i, l)), t.useProps && (l = t.useProps(i, l)), t.name && (l = Zu(t.name, i, l)), t.compose)
      if (t.useComposeOptions && (i = t.useComposeOptions(i, l)), t.useComposeProps)
        l = t.useComposeProps(i, l);
      else
        for (var m = Vn(a), p; !(p = m()).done; ) {
          var c = p.value;
          l = c(i, l, !0);
        }
    var f = {}, v = l || {};
    for (var h in v)
      v[h] !== void 0 && (f[h] = v[h]);
    return f;
  };
  o.__useOptions = n;
  var u = a.reduce(function(s, i) {
    return s.push.apply(s, i.__keys || []), s;
  }, []);
  return o.__keys = [].concat(u, ((e = t.useState) === null || e === void 0 ? void 0 : e.__keys) || [], t.keys || []), o.unstable_propsAreEqual = t.propsAreEqual || ((r = a[0]) === null || r === void 0 ? void 0 : r.unstable_propsAreEqual) || Bt, process.env.NODE_ENV !== "production" && t.name && Object.defineProperty(o, "name", {
    value: "use" + t.name
  }), o;
}
function to(t, e) {
  e === void 0 && (e = null), t && (typeof t == "function" ? t(e) : t.current = e);
}
function qe(t, e) {
  return Fe(function() {
    return t == null && e == null ? null : function(r) {
      to(t, r), to(e, r);
    };
  }, [t, e]);
}
var rs = ["button", "color", "file", "image", "reset", "submit"];
function pr(t) {
  if (t.tagName === "BUTTON")
    return !0;
  if (t.tagName === "INPUT") {
    var e = t;
    return rs.indexOf(e.type) !== -1;
  }
  return !1;
}
function ei(t) {
  for (var e = [], r = Qu(t), a; !(a = r()).done; ) {
    var n = a.value;
    Array.isArray(n) ? e.push.apply(e, ei(n)) : e.push(n);
  }
  return e;
}
function De(t) {
  if (process.env.NODE_ENV !== "production") {
    var e;
    if (!t)
      return;
    for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
      a[n - 1] = arguments[n];
    var o = ei(a.map(function(u) {
      return [u, `
`];
    }));
    (e = console).warn.apply(e, o.slice(0, -1));
    try {
      throw Error(o.join(""));
    } catch {
    }
  }
}
function as(t) {
  return Dn(t) && "current" in t;
}
function Vt(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), a = 1; a < e; a++)
    r[a - 1] = arguments[a];
  process.env.NODE_ENV !== "production" && ie(function() {
    process.env.NODE_ENV !== "production" && De.apply(void 0, [t].concat(r.map(function(n) {
      return as(n) ? n.current : n;
    })));
  }, [t]);
}
function ye(t) {
  return t ? t.ownerDocument || t : document;
}
var Nr;
try {
  Nr = window;
} catch {
}
function ti(t) {
  return t && ye(t).defaultView || Nr;
}
function ns() {
  var t = ti();
  return !!(typeof t < "u" && t.document && t.document.createElement);
}
var Rt = ns(), ot = Rt ? Tu : ie;
function re(t) {
  var e = ee(t);
  return ot(function() {
    e.current = t;
  }), e;
}
function Ne(t) {
  return t.target === t.currentTarget;
}
function jt(t) {
  var e = ye(t), r = e.activeElement;
  return r != null && r.nodeName ? r : null;
}
function He(t, e) {
  return t === e || t.contains(e);
}
function Qt(t) {
  var e = jt(t);
  if (!e)
    return !1;
  if (He(t, e))
    return !0;
  var r = e.getAttribute("aria-activedescendant");
  return r ? r === t.id ? !0 : !!t.querySelector("#" + r) : !1;
}
function Sn(t) {
  return !He(t.currentTarget, t.target);
}
function lt(t) {
  return Rt ? window.navigator.userAgent.indexOf(t) !== -1 : !1;
}
function ri(t, e) {
  return "matches" in t ? t.matches(e) : "msMatchesSelector" in t ? t.msMatchesSelector(e) : t.webkitMatchesSelector(e);
}
function ai(t, e) {
  if ("closest" in t)
    return t.closest(e);
  do {
    if (ri(t, e))
      return t;
    t = t.parentElement || t.parentNode;
  } while (t !== null && t.nodeType === 1);
  return null;
}
var ni = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function os(t) {
  var e = t;
  return e.offsetWidth > 0 || e.offsetHeight > 0 || t.getClientRects().length > 0;
}
function is(t) {
  var e = parseInt(t.getAttribute("tabindex") || "0", 10);
  return e < 0;
}
function oi(t) {
  return ri(t, ni) && os(t);
}
function Fr(t) {
  return oi(t) && !is(t);
}
function ii(t, e) {
  var r = Array.from(t.querySelectorAll(ni)), a = r.filter(Fr);
  return Fr(t) && a.unshift(t), !a.length && e ? r : a;
}
function ui(t, e) {
  var r = ii(t, e), a = r[0];
  return a || null;
}
function us(t, e) {
  var r = ii(t, e);
  return r[r.length - 1] || null;
}
var ss = ["unstable_system"], Gt = pe({
  name: "Role",
  keys: ss,
  propsAreEqual: function(e, r) {
    var a = e.unstable_system, n = te(e, ["unstable_system"]), o = r.unstable_system, u = te(r, ["unstable_system"]);
    return a !== o && !Bt(a, o) ? !1 : Bt(n, u);
  }
});
he({
  as: "div",
  useHook: Gt
});
var ls = ["disabled", "focusable"], ds = lt("Mac") && !lt("Chrome") && (lt("Safari") || lt("Firefox"));
function ro(t) {
  !Qt(t) && oi(t) && t.focus();
}
function cs(t) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"].includes(t.tagName);
}
function fs(t) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA"].includes(t.tagName);
}
function ms(t, e, r, a) {
  return t ? e && !r ? -1 : void 0 : e ? a : a || 0;
}
function _r(t, e) {
  return N(function(r) {
    var a;
    (a = t.current) === null || a === void 0 || a.call(t, r), !r.defaultPrevented && e && (r.stopPropagation(), r.preventDefault());
  }, [t, e]);
}
var lr = pe({
  name: "Tabbable",
  compose: Gt,
  keys: ls,
  useOptions: function(e, r) {
    var a = r.disabled;
    return M({
      disabled: a
    }, e);
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.tabIndex, o = r.onClickCapture, u = r.onMouseDownCapture, s = r.onMouseDown, i = r.onKeyPressCapture, l = r.style, d = te(r, ["ref", "tabIndex", "onClickCapture", "onMouseDownCapture", "onMouseDown", "onKeyPressCapture", "style"]), m = ee(null), p = re(o), c = re(u), f = re(s), v = re(i), h = !!e.disabled && !e.focusable, y = le(!0), w = y[0], g = y[1], b = le(!0), E = b[0], O = b[1], T = e.disabled ? M({
      pointerEvents: "none"
    }, l) : l;
    ot(function() {
      var x = m.current;
      if (!x) {
        process.env.NODE_ENV !== "production" && De(!0, "Can't determine if the element is a native tabbable element because `ref` wasn't passed to the component.", "See https://reakit.io/docs/tabbable");
        return;
      }
      cs(x) || g(!1), fs(x) || O(!1);
    }, []);
    var S = _r(p, e.disabled), P = _r(c, e.disabled), _ = _r(v, e.disabled), R = N(function(x) {
      var D;
      (D = f.current) === null || D === void 0 || D.call(f, x);
      var I = x.currentTarget;
      if (!x.defaultPrevented && ds && !Sn(x) && pr(I)) {
        var C = requestAnimationFrame(function() {
          I.removeEventListener("mouseup", A, !0), ro(I);
        }), A = function() {
          cancelAnimationFrame(C), ro(I);
        };
        I.addEventListener("mouseup", A, {
          once: !0,
          capture: !0
        });
      }
    }, []);
    return M({
      ref: qe(m, a),
      style: T,
      tabIndex: ms(h, w, E, n),
      disabled: h && E ? !0 : void 0,
      "aria-disabled": e.disabled ? !0 : void 0,
      onClickCapture: S,
      onMouseDownCapture: P,
      onMouseDown: R,
      onKeyPressCapture: _
    }, d);
  }
});
he({
  as: "div",
  useHook: lr
});
var vs = ["unstable_clickOnEnter", "unstable_clickOnSpace"];
function hs(t) {
  var e = t.currentTarget;
  return t.isTrusted ? pr(e) || e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.tagName === "A" || e.tagName === "SELECT" : !1;
}
var Lt = pe({
  name: "Clickable",
  compose: lr,
  keys: vs,
  useOptions: function(e) {
    var r = e.unstable_clickOnEnter, a = r === void 0 ? !0 : r, n = e.unstable_clickOnSpace, o = n === void 0 ? !0 : n, u = te(e, ["unstable_clickOnEnter", "unstable_clickOnSpace"]);
    return M({
      unstable_clickOnEnter: a,
      unstable_clickOnSpace: o
    }, u);
  },
  useProps: function(e, r) {
    var a = r.onKeyDown, n = r.onKeyUp, o = te(r, ["onKeyDown", "onKeyUp"]), u = le(!1), s = u[0], i = u[1], l = re(a), d = re(n), m = N(function(c) {
      var f;
      if ((f = l.current) === null || f === void 0 || f.call(l, c), !c.defaultPrevented && !e.disabled && !c.metaKey && Ne(c)) {
        var v = e.unstable_clickOnEnter && c.key === "Enter", h = e.unstable_clickOnSpace && c.key === " ";
        if (v || h) {
          if (hs(c))
            return;
          c.preventDefault(), v ? c.currentTarget.click() : h && i(!0);
        }
      }
    }, [e.disabled, e.unstable_clickOnEnter, e.unstable_clickOnSpace]), p = N(function(c) {
      var f;
      if ((f = d.current) === null || f === void 0 || f.call(d, c), !c.defaultPrevented && !e.disabled && !c.metaKey) {
        var v = e.unstable_clickOnSpace && c.key === " ";
        s && v && (i(!1), c.currentTarget.click());
      }
    }, [e.disabled, e.unstable_clickOnSpace, s]);
    return M({
      "data-active": s || void 0,
      onKeyDown: m,
      onKeyUp: p
    }, o);
  }
});
he({
  as: "button",
  memo: !0,
  useHook: Lt
});
var ps = [], si = pe({
  name: "Button",
  compose: Lt,
  keys: ps,
  useProps: function(e, r) {
    var a = r.ref, n = te(r, ["ref"]), o = ee(null), u = le(void 0), s = u[0], i = u[1], l = le("button"), d = l[0], m = l[1];
    return ie(function() {
      var p = o.current;
      if (!p) {
        process.env.NODE_ENV !== "production" && De(!0, "Can't determine whether the element is a native button because `ref` wasn't passed to the component", "See https://reakit.io/docs/button");
        return;
      }
      pr(p) || (p.tagName !== "A" && i("button"), m(void 0));
    }, []), M({
      ref: qe(o, a),
      role: s,
      type: d
    }, n);
  }
});
he({
  as: "button",
  memo: !0,
  useHook: si
});
function bs(t, e) {
  return e === -1 ? t : [].concat(t.slice(0, e), t.slice(e + 1));
}
function li(t, e, r) {
  if (typeof Event == "function")
    return new Event(e, r);
  var a = ye(t).createEvent("Event");
  return a.initEvent(e, r == null ? void 0 : r.bubbles, r == null ? void 0 : r.cancelable), a;
}
function pt(t) {
  var e = le(t), r = e[0];
  return r;
}
function di(t, e) {
  var r = ee(!1);
  ie(function() {
    if (r.current)
      return t();
    r.current = !0;
  }, e);
}
function ao(t, e, r) {
  return r === void 0 && (r = {}), typeof FocusEvent == "function" ? new FocusEvent(e, r) : li(t, e, r);
}
function Er(t, e) {
  var r = ao(t, "blur", e), a = t.dispatchEvent(r), n = tt(tt({}, e), {}, {
    bubbles: !0
  });
  return t.dispatchEvent(ao(t, "focusout", n)), a;
}
function gs(t, e, r) {
  if (r === void 0 && (r = {}), typeof KeyboardEvent == "function")
    return new KeyboardEvent(e, r);
  var a = ye(t).createEvent("KeyboardEvent");
  return a.initKeyboardEvent(e, r.bubbles, r.cancelable, ti(t), r.key, r.location, r.ctrlKey, r.altKey, r.shiftKey, r.metaKey), a;
}
function ys(t, e, r) {
  return t.dispatchEvent(gs(t, e, r));
}
var ws = Rt && "msCrypto" in window;
function ci(t) {
  if (ws) {
    var e = jt(t.currentTarget);
    return e;
  }
  return t.relatedTarget;
}
function dr(t) {
  for (var e = [[]], r = function() {
    var u = n.value, s = e.find(function(i) {
      return !i[0] || i[0].groupId === u.groupId;
    });
    s ? s.push(u) : e.push([u]);
  }, a = ht(t), n; !(n = a()).done; )
    r();
  return e;
}
function Lr(t) {
  for (var e = [], r = ht(t), a; !(a = r()).done; ) {
    var n = a.value;
    e.push.apply(e, n);
  }
  return e;
}
function _t(t) {
  return t.slice().reverse();
}
function Qe(t, e) {
  return e ? t.find(function(r) {
    return !r.disabled && r.id !== e;
  }) : t.find(function(r) {
    return !r.disabled;
  });
}
function st(t, e) {
  var r;
  return e || e === null ? e : t.currentId || t.currentId === null ? t.currentId : (r = Qe(t.items || [])) === null || r === void 0 ? void 0 : r.id;
}
function fi(t, e) {
  if (e)
    return t == null ? void 0 : t.find(function(r) {
      return r.id === e && !r.disabled;
    });
}
var Ms = ["baseId", "unstable_idCountRef", "setBaseId", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget"], mi = Ms, _s = mi, Es = _s;
function vi(t) {
  t.userFocus = !0, t.focus(), t.userFocus = !1;
}
function Ps(t) {
  return !!t.userFocus;
}
function no(t, e) {
  t.userFocus = e;
}
var Os = Rt && "msCrypto" in window;
function xs(t) {
  return !(!Ne(t) || t.metaKey || t.key === "Tab");
}
function oo(t, e, r) {
  var a = re(r);
  return N(function(n) {
    var o;
    if ((o = a.current) === null || o === void 0 || o.call(a, n), !n.defaultPrevented && t && xs(n)) {
      var u = e == null ? void 0 : e.ref.current;
      u && (ys(u, n.type, n) || n.preventDefault(), n.currentTarget.contains(u) && n.stopPropagation());
    }
  }, [t, e]);
}
function Ds(t) {
  var e = ee(null);
  return ie(function() {
    var r = ye(t.current), a = function(o) {
      var u = o.target;
      e.current = u;
    };
    return r.addEventListener("focus", a, !0), function() {
      r.removeEventListener("focus", a, !0);
    };
  }, []), e;
}
function Ss(t) {
  return Qe(Lr(_t(dr(t))));
}
function Pr(t, e) {
  return t == null ? void 0 : t.some(function(r) {
    return !!e && r.ref.current === e;
  });
}
function Cs(t) {
  var e = re(t), r = On(function(o) {
    return o + 1;
  }, 0), a = r[0], n = r[1];
  return ie(function() {
    var o, u = (o = e.current) === null || o === void 0 ? void 0 : o.ref.current;
    a && u && vi(u);
  }, [a]), n;
}
var hi = pe({
  name: "Composite",
  compose: [lr],
  keys: mi,
  useOptions: function(e) {
    return M(M({}, e), {}, {
      currentId: st(e)
    });
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.onFocusCapture, o = r.onFocus, u = r.onBlurCapture, s = r.onKeyDown, i = r.onKeyDownCapture, l = r.onKeyUpCapture, d = te(r, ["ref", "onFocusCapture", "onFocus", "onBlurCapture", "onKeyDown", "onKeyDownCapture", "onKeyUpCapture"]), m = ee(null), p = fi(e.items, e.currentId), c = ee(null), f = re(n), v = re(o), h = re(u), y = re(s), w = Cs(p), g = Os ? Ds(m) : void 0;
    ie(function() {
      var _ = m.current;
      e.unstable_moves && !p && (process.env.NODE_ENV !== "production" && De(!_, "Can't focus composite component because `ref` wasn't passed to component.", "See https://reakit.io/docs/composite"), _ == null || _.focus());
    }, [e.unstable_moves, p]);
    var b = oo(e.unstable_virtual, p, i), E = oo(e.unstable_virtual, p, l), O = N(function(_) {
      var R;
      if ((R = f.current) === null || R === void 0 || R.call(f, _), !_.defaultPrevented && e.unstable_virtual) {
        var x = (g == null ? void 0 : g.current) || _.relatedTarget, D = Pr(e.items, x);
        Ne(_) && D && (_.stopPropagation(), c.current = x);
      }
    }, [e.unstable_virtual, e.items]), T = N(function(_) {
      var R;
      if ((R = v.current) === null || R === void 0 || R.call(v, _), !_.defaultPrevented) {
        if (e.unstable_virtual)
          Ne(_) && w();
        else if (Ne(_)) {
          var x;
          (x = e.setCurrentId) === null || x === void 0 || x.call(e, null);
        }
      }
    }, [e.unstable_virtual, e.setCurrentId]), S = N(function(_) {
      var R;
      if ((R = h.current) === null || R === void 0 || R.call(h, _), !_.defaultPrevented && e.unstable_virtual) {
        var x = (p == null ? void 0 : p.ref.current) || null, D = ci(_), I = Pr(e.items, D);
        if (Ne(_) && I)
          D === x ? c.current && c.current !== D && Er(c.current, _) : x && Er(x, _), _.stopPropagation();
        else {
          var C = Pr(e.items, _.target);
          !C && x && Er(x, _);
        }
      }
    }, [e.unstable_virtual, e.items, p]), P = N(function(_) {
      var R, x;
      if ((R = y.current) === null || R === void 0 || R.call(y, _), !_.defaultPrevented && e.currentId === null && Ne(_)) {
        var D = e.orientation !== "horizontal", I = e.orientation !== "vertical", C = !!((x = e.groups) !== null && x !== void 0 && x.length), A = function() {
          if (C) {
            var de = Ss(e.items);
            if (de != null && de.id) {
              var ae;
              (ae = e.move) === null || ae === void 0 || ae.call(e, de.id);
            }
          } else {
            var ne;
            (ne = e.last) === null || ne === void 0 || ne.call(e);
          }
        }, V = {
          ArrowUp: (C || D) && A,
          ArrowRight: (C || I) && e.first,
          ArrowDown: (C || D) && e.first,
          ArrowLeft: (C || I) && e.last,
          Home: e.first,
          End: e.last,
          PageUp: e.first,
          PageDown: e.last
        }, J = V[_.key];
        J && (_.preventDefault(), J());
      }
    }, [e.currentId, e.orientation, e.groups, e.items, e.move, e.last, e.first]);
    return M({
      ref: qe(m, a),
      id: e.baseId,
      onFocus: T,
      onFocusCapture: O,
      onBlurCapture: S,
      onKeyDownCapture: b,
      onKeyDown: P,
      onKeyUpCapture: E,
      "aria-activedescendant": e.unstable_virtual && (p == null ? void 0 : p.id) || void 0
    }, d);
  },
  useComposeProps: function(e, r) {
    r = Gt(e, r, !0);
    var a = lr(e, r, !0);
    return e.unstable_virtual || e.currentId === null ? M({
      tabIndex: 0
    }, a) : M(M({}, r), {}, {
      ref: a.ref
    });
  }
});
he({
  as: "div",
  useHook: hi,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Vt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/composite"), kt(e, r, a);
  }
});
function io(t) {
  try {
    var e = t instanceof HTMLInputElement && t.selectionStart !== null, r = t.tagName === "TEXTAREA", a = t.contentEditable === "true";
    return e || r || a || !1;
  } catch {
    return !1;
  }
}
function Ts(t) {
  var e = jt(t);
  if (!e)
    return !1;
  if (e === t)
    return !0;
  var r = e.getAttribute("aria-activedescendant");
  return r ? r === t.id : !1;
}
function qt(t, e) {
  var r = e === void 0 ? {} : e, a = r.preventScroll, n = r.isActive, o = n === void 0 ? Ts : n;
  return o(t) || (t.focus({
    preventScroll: a
  }), o(t)) ? -1 : requestAnimationFrame(function() {
    t.focus({
      preventScroll: a
    });
  });
}
var pi = "id";
function ks(t) {
  return t === void 0 && (t = pi), (t ? t + "-" : "") + Math.random().toString(32).substr(2, 6);
}
var Cn = /* @__PURE__ */ nt(ks);
function Rs(t) {
  var e = t.children, r = t.prefix, a = r === void 0 ? pi : r, n = ee(0), o = N(function(u) {
    return u === void 0 && (u = a), (u ? u + "-" : "") + ++n.current;
  }, [a]);
  return /* @__PURE__ */ Le(Cn.Provider, {
    value: o
  }, e);
}
var js = ["baseId", "unstable_idCountRef", "setBaseId"], As = [].concat(js, ["id"]), bi = pe({
  keys: As,
  useOptions: function(e, r) {
    var a = Ce(Cn), n = le(function() {
      return e.unstable_idCountRef ? (e.unstable_idCountRef.current += 1, "-" + e.unstable_idCountRef.current) : e.baseId ? "-" + a("") : "";
    }), o = n[0], u = Fe(function() {
      return e.baseId || a();
    }, [e.baseId, a]), s = r.id || e.id || "" + u + o;
    return M(M({}, e), {}, {
      id: s
    });
  },
  useProps: function(e, r) {
    return M({
      id: e.id
    }, r);
  }
});
he({
  as: "div",
  useHook: bi
});
function Ws(t, e, r) {
  return t.dispatchEvent(li(t, e, r));
}
function uo(t, e) {
  if (t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement) {
    var r, a = Object.getPrototypeOf(t), n = (r = Object.getOwnPropertyDescriptor(a, "value")) === null || r === void 0 ? void 0 : r.set;
    n && (n.call(t, e), Ws(t, "input", {
      bubbles: !0
    }));
  }
}
function Or(t) {
  return t.querySelector("[data-composite-item-widget]");
}
function Is(t) {
  return Fe(function() {
    var e;
    return (e = t.items) === null || e === void 0 ? void 0 : e.find(function(r) {
      return t.id && r.id === t.id;
    });
  }, [t.items, t.id]);
}
function Ns(t, e) {
  if (Ne(t))
    return !1;
  for (var r = ht(e), a; !(a = r()).done; ) {
    var n = a.value;
    if (n.ref.current === t.target)
      return !0;
  }
  return !1;
}
var Hr = pe({
  name: "CompositeItem",
  compose: [Lt, bi],
  keys: Es,
  propsAreEqual: function(e, r) {
    if (!r.id || e.id !== r.id)
      return Lt.unstable_propsAreEqual(e, r);
    var a = e.currentId, n = e.unstable_moves, o = te(e, ["currentId", "unstable_moves"]), u = r.currentId, s = r.unstable_moves, i = te(r, ["currentId", "unstable_moves"]);
    if (u !== a) {
      if (r.id === u || r.id === a)
        return !1;
    } else if (n !== s)
      return !1;
    return Lt.unstable_propsAreEqual(o, i);
  },
  useOptions: function(e) {
    return M(M({}, e), {}, {
      id: e.id,
      currentId: st(e),
      unstable_clickOnSpace: e.unstable_hasActiveWidget ? !1 : e.unstable_clickOnSpace
    });
  },
  useProps: function(e, r) {
    var a, n = r.ref, o = r.tabIndex, u = o === void 0 ? 0 : o, s = r.onMouseDown, i = r.onFocus, l = r.onBlurCapture, d = r.onKeyDown, m = r.onClick, p = te(r, ["ref", "tabIndex", "onMouseDown", "onFocus", "onBlurCapture", "onKeyDown", "onClick"]), c = ee(null), f = e.id, v = e.disabled && !e.focusable, h = e.currentId === f, y = re(h), w = ee(!1), g = Is(e), b = re(s), E = re(i), O = re(l), T = re(d), S = re(m), P = !e.unstable_virtual && !e.unstable_hasActiveWidget && h || // We don't want to set tabIndex="-1" when using CompositeItem as a
    // standalone component, without state props.
    !((a = e.items) !== null && a !== void 0 && a.length);
    ie(function() {
      var C;
      if (f)
        return (C = e.registerItem) === null || C === void 0 || C.call(e, {
          id: f,
          ref: c,
          disabled: !!v
        }), function() {
          var A;
          (A = e.unregisterItem) === null || A === void 0 || A.call(e, f);
        };
    }, [f, v, e.registerItem, e.unregisterItem]), ie(function() {
      var C = c.current;
      if (!C) {
        process.env.NODE_ENV !== "production" && De(!0, "Can't focus composite item component because `ref` wasn't passed to component.", "See https://reakit.io/docs/composite");
        return;
      }
      e.unstable_moves && y.current && vi(C);
    }, [e.unstable_moves]);
    var _ = N(function(C) {
      var A;
      (A = b.current) === null || A === void 0 || A.call(b, C), no(C.currentTarget, !0);
    }, []), R = N(function(C) {
      var A, V, J = Ps(C.currentTarget);
      if (no(C.currentTarget, !1), (A = E.current) === null || A === void 0 || A.call(E, C), !C.defaultPrevented && !Sn(C) && f && !Ns(C, e.items) && ((V = e.setCurrentId) === null || V === void 0 || V.call(e, f), J && e.unstable_virtual && e.baseId && Ne(C))) {
        var Z = C.target, de = ye(Z).getElementById(e.baseId);
        de && (w.current = !0, qt(de));
      }
    }, [f, e.items, e.setCurrentId, e.unstable_virtual, e.baseId]), x = N(function(C) {
      var A;
      (A = O.current) === null || A === void 0 || A.call(O, C), !C.defaultPrevented && e.unstable_virtual && w.current && (w.current = !1, C.preventDefault(), C.stopPropagation());
    }, [e.unstable_virtual]), D = N(function(C) {
      var A;
      if (Ne(C)) {
        var V = e.orientation !== "horizontal", J = e.orientation !== "vertical", Z = !!(g != null && g.groupId), de = {
          ArrowUp: (Z || V) && e.up,
          ArrowRight: (Z || J) && e.next,
          ArrowDown: (Z || V) && e.down,
          ArrowLeft: (Z || J) && e.previous,
          Home: function() {
            if (!Z || C.ctrlKey) {
              var B;
              (B = e.first) === null || B === void 0 || B.call(e);
            } else {
              var Q;
              (Q = e.previous) === null || Q === void 0 || Q.call(e, !0);
            }
          },
          End: function() {
            if (!Z || C.ctrlKey) {
              var B;
              (B = e.last) === null || B === void 0 || B.call(e);
            } else {
              var Q;
              (Q = e.next) === null || Q === void 0 || Q.call(e, !0);
            }
          },
          PageUp: function() {
            if (Z) {
              var B;
              (B = e.up) === null || B === void 0 || B.call(e, !0);
            } else {
              var Q;
              (Q = e.first) === null || Q === void 0 || Q.call(e);
            }
          },
          PageDown: function() {
            if (Z) {
              var B;
              (B = e.down) === null || B === void 0 || B.call(e, !0);
            } else {
              var Q;
              (Q = e.last) === null || Q === void 0 || Q.call(e);
            }
          }
        }, ae = de[C.key];
        if (ae) {
          C.preventDefault(), ae();
          return;
        }
        if ((A = T.current) === null || A === void 0 || A.call(T, C), !C.defaultPrevented) {
          if (C.key.length === 1 && C.key !== " ") {
            var ne = Or(C.currentTarget);
            ne && io(ne) && (ne.focus(), uo(ne, ""));
          } else if (C.key === "Delete" || C.key === "Backspace") {
            var ve = Or(C.currentTarget);
            ve && io(ve) && (C.preventDefault(), uo(ve, ""));
          }
        }
      }
    }, [e.orientation, g, e.up, e.next, e.down, e.previous, e.first, e.last]), I = N(function(C) {
      var A;
      if ((A = S.current) === null || A === void 0 || A.call(S, C), !C.defaultPrevented) {
        var V = C.currentTarget, J = Or(V);
        J && !Qt(J) && J.focus();
      }
    }, []);
    return M({
      ref: qe(c, n),
      id: f,
      tabIndex: P ? u : -1,
      "aria-selected": e.unstable_virtual && h ? !0 : void 0,
      onMouseDown: _,
      onFocus: R,
      onBlurCapture: x,
      onKeyDown: D,
      onClick: I
    }, p);
  }
});
he({
  as: "button",
  memo: !0,
  useHook: Hr
});
function Fs(t) {
  return typeof t == "function";
}
function Je(t, e) {
  return Fs(t) ? t(e) : t;
}
function gi(t) {
  t === void 0 && (t = {});
  var e = pt(t), r = e.baseId, a = Ce(Cn), n = ee(0), o = le(function() {
    return r || a();
  }), u = o[0], s = o[1];
  return {
    baseId: u,
    setBaseId: s,
    unstable_idCountRef: n
  };
}
function yi(t, e) {
  return !!(e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_PRECEDING);
}
function so(t, e) {
  return t.findIndex(function(r) {
    return !r.ref.current || !e.ref.current ? !1 : yi(e.ref.current, r.ref.current);
  });
}
function wi(t) {
  for (var e = 0, r = ht(t), a; !(a = r()).done; ) {
    var n = a.value.length;
    n > e && (e = n);
  }
  return e;
}
function lo(t) {
  for (var e = dr(t), r = wi(e), a = [], n = 0; n < r; n += 1)
    for (var o = ht(e), u; !(u = o()).done; ) {
      var s = u.value;
      s[n] && a.push(M(M({}, s[n]), {}, {
        // If there's no groupId, it means that it's not a grid composite,
        // but a single row instead. So, instead of verticalizing it, that
        // is, assigning a different groupId based on the column index, we
        // keep it undefined so they will be part of the same group.
        // It's useful when using up/down on one-dimensional composites.
        groupId: s[n].groupId ? "" + n : void 0
      }));
    }
  return a;
}
function Ls(t) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: !0,
    ref: {
      current: null
    },
    groupId: t
  };
}
function co(t, e, r) {
  for (var a = wi(t), n = ht(t), o; !(o = n()).done; )
    for (var u = o.value, s = 0; s < a; s += 1) {
      var i = u[s];
      if (!i || r && i.disabled) {
        var l = s === 0, d = l && r ? Qe(u) : u[s - 1];
        u[s] = d && e !== (d == null ? void 0 : d.id) && r ? d : Ls(d == null ? void 0 : d.groupId);
      }
    }
  return t;
}
var Hs = {
  id: null,
  ref: {
    current: null
  }
};
function $s(t, e, r) {
  var a = t.findIndex(function(n) {
    return n.id === e;
  });
  return [].concat(t.slice(a + 1), r ? [Hs] : [], t.slice(0, a));
}
function xr(t, e) {
  return t.filter(function(r) {
    return r.groupId === e;
  });
}
var zs = {
  horizontal: "vertical",
  vertical: "horizontal"
};
function Ys(t) {
  return t && zs[t];
}
function fo(t, e, r) {
  return r in t ? [].concat(t.slice(0, r), [e], t.slice(r)) : [].concat(t, [e]);
}
function $r(t) {
  var e = t.map(function(a, n) {
    return [n, a];
  }), r = !1;
  return e.sort(function(a, n) {
    var o = a[0], u = a[1], s = n[0], i = n[1], l = u.ref.current, d = i.ref.current;
    return !l || !d ? 0 : yi(l, d) ? (o > s && (r = !0), -1) : (o < s && (r = !0), 1);
  }), r ? e.map(function(a) {
    a[0];
    var n = a[1];
    return n;
  }) : t;
}
function Mi(t, e) {
  var r = $r(t);
  t !== r && e(r);
}
function Bs(t) {
  for (var e, r = t[0], a = t.slice(1), n = r == null || (e = r.ref.current) === null || e === void 0 ? void 0 : e.parentElement, o = function() {
    var i = n;
    if (a.every(function(l) {
      return i.contains(l.ref.current);
    }))
      return {
        v: n
      };
    n = n.parentElement;
  }; n; ) {
    var u = o();
    if (typeof u == "object")
      return u.v;
  }
  return ye(n).body;
}
function qs(t, e) {
  var r = ee([]);
  ie(function() {
    for (var a = function() {
      var d = !!r.current.length;
      d && Mi(t, e), r.current = t;
    }, n = Bs(t), o = new IntersectionObserver(a, {
      root: n
    }), u = ht(t), s; !(s = u()).done; ) {
      var i = s.value;
      i.ref.current && o.observe(i.ref.current);
    }
    return function() {
      o.disconnect();
    };
  }, [t]);
}
function Us(t, e) {
  ie(function() {
    var r = function() {
      return Mi(t, e);
    }, a = setTimeout(r, 250);
    return function() {
      return clearTimeout(a);
    };
  });
}
function Ks(t, e) {
  typeof IntersectionObserver == "function" ? qs(t, e) : Us(t, e);
}
function Se(t, e) {
  var r = t.unstable_virtual, a = t.rtl, n = t.orientation, o = t.items, u = t.groups, s = t.currentId, i = t.loop, l = t.wrap, d = t.pastIds, m = t.shift, p = t.unstable_moves, c = t.unstable_includesBaseElement, f = t.initialVirtual, v = t.initialRTL, h = t.initialOrientation, y = t.initialCurrentId, w = t.initialLoop, g = t.initialWrap, b = t.initialShift, E = t.hasSetCurrentId;
  switch (e.type) {
    case "registerGroup": {
      var O = e.group;
      if (u.length === 0)
        return M(M({}, t), {}, {
          groups: [O]
        });
      var T = so(u, O);
      return M(M({}, t), {}, {
        groups: fo(u, O, T)
      });
    }
    case "unregisterGroup": {
      var S = e.id, P = u.filter(function(ke) {
        return ke.id !== S;
      });
      return P.length === u.length ? t : M(M({}, t), {}, {
        groups: P
      });
    }
    case "registerItem": {
      var _ = e.item, R = u.find(function(ke) {
        var wr;
        return (wr = ke.ref.current) === null || wr === void 0 ? void 0 : wr.contains(_.ref.current);
      }), x = M({
        groupId: R == null ? void 0 : R.id
      }, _), D = so(o, x), I = M(M({}, t), {}, {
        items: fo(o, x, D)
      });
      if (!E && !p && y === void 0) {
        var C;
        return M(M({}, I), {}, {
          currentId: (C = Qe(I.items)) === null || C === void 0 ? void 0 : C.id
        });
      }
      return I;
    }
    case "unregisterItem": {
      var A = e.id, V = o.filter(function(ke) {
        return ke.id !== A;
      });
      if (V.length === o.length)
        return t;
      var J = d.filter(function(ke) {
        return ke !== A;
      }), Z = M(M({}, t), {}, {
        pastIds: J,
        items: V
      });
      if (s && s === A) {
        var de = c ? null : st(M(M({}, Z), {}, {
          currentId: J[0]
        }));
        return M(M({}, Z), {}, {
          currentId: de
        });
      }
      return Z;
    }
    case "move": {
      var ae = e.id;
      if (ae === void 0)
        return t;
      var ne = d.filter(function(ke) {
        return ke !== s && ke !== ae;
      }), ve = s ? [s].concat(ne) : ne, F = M(M({}, t), {}, {
        pastIds: ve
      });
      if (ae === null)
        return M(M({}, F), {}, {
          unstable_moves: p + 1,
          currentId: st(F, ae)
        });
      var B = fi(o, ae);
      return M(M({}, F), {}, {
        unstable_moves: B ? p + 1 : p,
        currentId: st(F, B == null ? void 0 : B.id)
      });
    }
    case "next": {
      if (s == null)
        return Se(t, M(M({}, e), {}, {
          type: "first"
        }));
      var Q = n !== "vertical", be = a && Q, ge = be ? _t(o) : o, Ee = ge.find(function(ke) {
        return ke.id === s;
      });
      if (!Ee)
        return Se(t, M(M({}, e), {}, {
          type: "first"
        }));
      var k = !!Ee.groupId, W = ge.indexOf(Ee), K = ge.slice(W + 1), z = xr(K, Ee.groupId);
      if (e.allTheWay) {
        var H = Qe(be ? xr(ge, Ee.groupId) : _t(z));
        return Se(t, M(M({}, e), {}, {
          type: "move",
          id: H == null ? void 0 : H.id
        }));
      }
      var G = Ys(
        // If it's a grid and orientation is not set, it's a next/previous
        // call, which is inherently horizontal. up/down will call next with
        // orientation set to vertical by default (see below on up/down cases).
        k ? n || "horizontal" : n
      ), Y = i && i !== G, q = k && l && l !== G, X = (
        // `previous` and `up` will set action.hasNullItem, but when calling
        // next directly, hasNullItem will only be true if it's not a grid and
        // loop is set to true, which means that pressing right or down keys on
        // grids will never focus the composite element. On one-dimensional
        // composites that don't loop, pressing right or down keys also doesn't
        // focus the composite element.
        e.hasNullItem || !k && Y && c
      );
      if (Y) {
        var oe = q && !X ? ge : xr(ge, Ee.groupId), U = $s(oe, s, X), j = Qe(U, s);
        return Se(t, M(M({}, e), {}, {
          type: "move",
          id: j == null ? void 0 : j.id
        }));
      }
      if (q) {
        var se = Qe(
          // We can use nextItems, which contains all the next items, including
          // items from other groups, to wrap between groups. However, if there
          // is a null item (the composite element), we'll only use the next
          // items in the group. So moving next from the last item will focus
          // the composite element (null). On grid composites, horizontal
          // navigation never focuses the composite element, only vertical.
          X ? z : K,
          s
        ), we = X ? (se == null ? void 0 : se.id) || null : se == null ? void 0 : se.id;
        return Se(t, M(M({}, e), {}, {
          type: "move",
          id: we
        }));
      }
      var Ie = Qe(z, s);
      return !Ie && X ? Se(t, M(M({}, e), {}, {
        type: "move",
        id: null
      })) : Se(t, M(M({}, e), {}, {
        type: "move",
        id: Ie == null ? void 0 : Ie.id
      }));
    }
    case "previous": {
      var tr = !!u.length, rr = !tr && c, ar = Se(M(M({}, t), {}, {
        items: _t(o)
      }), M(M({}, e), {}, {
        type: "next",
        hasNullItem: rr
      }));
      return M(M({}, ar), {}, {
        items: o
      });
    }
    case "down": {
      var nr = m && !e.allTheWay, pu = lo(Lr(co(dr(o), s, nr))), bu = i && i !== "horizontal", gu = bu && c, yu = Se(M(M({}, t), {}, {
        orientation: "vertical",
        items: pu
      }), M(M({}, e), {}, {
        type: "next",
        hasNullItem: gu
      }));
      return M(M({}, yu), {}, {
        orientation: n,
        items: o
      });
    }
    case "up": {
      var wu = m && !e.allTheWay, Mu = lo(_t(Lr(co(dr(o), s, wu)))), _u = c, Eu = Se(M(M({}, t), {}, {
        orientation: "vertical",
        items: Mu
      }), M(M({}, e), {}, {
        type: "next",
        hasNullItem: _u
      }));
      return M(M({}, Eu), {}, {
        orientation: n,
        items: o
      });
    }
    case "first": {
      var yr = Qe(o);
      return Se(t, M(M({}, e), {}, {
        type: "move",
        id: yr == null ? void 0 : yr.id
      }));
    }
    case "last": {
      var Pu = Se(M(M({}, t), {}, {
        items: _t(o)
      }), M(M({}, e), {}, {
        type: "first"
      }));
      return M(M({}, Pu), {}, {
        items: o
      });
    }
    case "sort":
      return M(M({}, t), {}, {
        items: $r(o),
        groups: $r(u)
      });
    case "setVirtual":
      return M(M({}, t), {}, {
        unstable_virtual: Je(e.virtual, r)
      });
    case "setRTL":
      return M(M({}, t), {}, {
        rtl: Je(e.rtl, a)
      });
    case "setOrientation":
      return M(M({}, t), {}, {
        orientation: Je(e.orientation, n)
      });
    case "setCurrentId": {
      var Ou = st(M(M({}, t), {}, {
        currentId: Je(e.currentId, s)
      }));
      return M(M({}, t), {}, {
        currentId: Ou,
        hasSetCurrentId: !0
      });
    }
    case "setLoop":
      return M(M({}, t), {}, {
        loop: Je(e.loop, i)
      });
    case "setWrap":
      return M(M({}, t), {}, {
        wrap: Je(e.wrap, l)
      });
    case "setShift":
      return M(M({}, t), {}, {
        shift: Je(e.shift, m)
      });
    case "setIncludesBaseElement":
      return M(M({}, t), {}, {
        unstable_includesBaseElement: Je(e.includesBaseElement, c)
      });
    case "reset":
      return M(M({}, t), {}, {
        unstable_virtual: f,
        rtl: v,
        orientation: h,
        currentId: st(M(M({}, t), {}, {
          currentId: y
        })),
        loop: w,
        wrap: g,
        shift: b,
        unstable_moves: 0,
        pastIds: []
      });
    case "setItems":
      return M(M({}, t), {}, {
        items: e.items
      });
    default:
      throw new Error();
  }
}
function me(t) {
  return N(t, []);
}
function Xs() {
  var t = ee(!1);
  return ot(function() {
    return function() {
      t.current = !0;
    };
  }, []), t;
}
function Vs(t) {
  t === void 0 && (t = {});
  var e = pt(t), r = e.unstable_virtual, a = r === void 0 ? !1 : r, n = e.rtl, o = n === void 0 ? !1 : n, u = e.orientation, s = e.currentId, i = e.loop, l = i === void 0 ? !1 : i, d = e.wrap, m = d === void 0 ? !1 : d, p = e.shift, c = p === void 0 ? !1 : p, f = e.unstable_includesBaseElement, v = te(e, ["unstable_virtual", "rtl", "orientation", "currentId", "loop", "wrap", "shift", "unstable_includesBaseElement"]), h = gi(v), y = On(Se, {
    unstable_virtual: a,
    rtl: o,
    orientation: u,
    items: [],
    groups: [],
    currentId: s,
    loop: l,
    wrap: m,
    shift: c,
    unstable_moves: 0,
    pastIds: [],
    unstable_includesBaseElement: f ?? s === null,
    initialVirtual: a,
    initialRTL: o,
    initialOrientation: u,
    initialCurrentId: s,
    initialLoop: l,
    initialWrap: m,
    initialShift: c
  }), w = y[0];
  w.pastIds, w.initialVirtual, w.initialRTL, w.initialOrientation, w.initialCurrentId, w.initialLoop, w.initialWrap, w.initialShift, w.hasSetCurrentId;
  var g = te(w, ["pastIds", "initialVirtual", "initialRTL", "initialOrientation", "initialCurrentId", "initialLoop", "initialWrap", "initialShift", "hasSetCurrentId"]), b = y[1], E = le(!1), O = E[0], T = E[1], S = Xs(), P = N(function(_) {
    return b({
      type: "setItems",
      items: _
    });
  }, []);
  return Ks(g.items, P), M(M(M({}, h), g), {}, {
    unstable_hasActiveWidget: O,
    unstable_setHasActiveWidget: T,
    registerItem: me(function(_) {
      S.current || b({
        type: "registerItem",
        item: _
      });
    }),
    unregisterItem: me(function(_) {
      S.current || b({
        type: "unregisterItem",
        id: _
      });
    }),
    registerGroup: me(function(_) {
      S.current || b({
        type: "registerGroup",
        group: _
      });
    }),
    unregisterGroup: me(function(_) {
      S.current || b({
        type: "unregisterGroup",
        id: _
      });
    }),
    move: me(function(_) {
      return b({
        type: "move",
        id: _
      });
    }),
    next: me(function(_) {
      return b({
        type: "next",
        allTheWay: _
      });
    }),
    previous: me(function(_) {
      return b({
        type: "previous",
        allTheWay: _
      });
    }),
    up: me(function(_) {
      return b({
        type: "up",
        allTheWay: _
      });
    }),
    down: me(function(_) {
      return b({
        type: "down",
        allTheWay: _
      });
    }),
    first: me(function() {
      return b({
        type: "first"
      });
    }),
    last: me(function() {
      return b({
        type: "last"
      });
    }),
    sort: me(function() {
      return b({
        type: "sort"
      });
    }),
    unstable_setVirtual: me(function(_) {
      return b({
        type: "setVirtual",
        virtual: _
      });
    }),
    setRTL: me(function(_) {
      return b({
        type: "setRTL",
        rtl: _
      });
    }),
    setOrientation: me(function(_) {
      return b({
        type: "setOrientation",
        orientation: _
      });
    }),
    setCurrentId: me(function(_) {
      return b({
        type: "setCurrentId",
        currentId: _
      });
    }),
    setLoop: me(function(_) {
      return b({
        type: "setLoop",
        loop: _
      });
    }),
    setWrap: me(function(_) {
      return b({
        type: "setWrap",
        wrap: _
      });
    }),
    setShift: me(function(_) {
      return b({
        type: "setShift",
        shift: _
      });
    }),
    unstable_setIncludesBaseElement: me(function(_) {
      return b({
        type: "setIncludesBaseElement",
        includesBaseElement: _
      });
    }),
    reset: me(function() {
      return b({
        type: "reset"
      });
    })
  });
}
var Oe = "top", Ae = "bottom", We = "right", xe = "left", Tn = "auto", Jt = [Oe, Ae, We, xe], Ot = "start", Ut = "end", Qs = "clippingParents", _i = "viewport", Wt = "popper", Gs = "reference", mo = /* @__PURE__ */ Jt.reduce(function(t, e) {
  return t.concat([e + "-" + Ot, e + "-" + Ut]);
}, []), Ei = /* @__PURE__ */ [].concat(Jt, [Tn]).reduce(function(t, e) {
  return t.concat([e, e + "-" + Ot, e + "-" + Ut]);
}, []), Js = "beforeRead", Zs = "read", el = "afterRead", tl = "beforeMain", rl = "main", al = "afterMain", nl = "beforeWrite", ol = "write", il = "afterWrite", ul = [Js, Zs, el, tl, rl, al, nl, ol, il];
function Be(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Te(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function ft(t) {
  var e = Te(t).Element;
  return t instanceof e || t instanceof Element;
}
function je(t) {
  var e = Te(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function kn(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Te(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function sl(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(r) {
    var a = e.styles[r] || {}, n = e.attributes[r] || {}, o = e.elements[r];
    !je(o) || !Be(o) || (Object.assign(o.style, a), Object.keys(n).forEach(function(u) {
      var s = n[u];
      s === !1 ? o.removeAttribute(u) : o.setAttribute(u, s === !0 ? "" : s);
    }));
  });
}
function ll(t) {
  var e = t.state, r = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, r.popper), e.styles = r, e.elements.arrow && Object.assign(e.elements.arrow.style, r.arrow), function() {
    Object.keys(e.elements).forEach(function(a) {
      var n = e.elements[a], o = e.attributes[a] || {}, u = Object.keys(e.styles.hasOwnProperty(a) ? e.styles[a] : r[a]), s = u.reduce(function(i, l) {
        return i[l] = "", i;
      }, {});
      !je(n) || !Be(n) || (Object.assign(n.style, s), Object.keys(o).forEach(function(i) {
        n.removeAttribute(i);
      }));
    });
  };
}
const dl = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: sl,
  effect: ll,
  requires: ["computeStyles"]
};
function Ye(t) {
  return t.split("-")[0];
}
var dt = Math.max, cr = Math.min, xt = Math.round;
function zr() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function Pi() {
  return !/^((?!chrome|android).)*safari/i.test(zr());
}
function Dt(t, e, r) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  var a = t.getBoundingClientRect(), n = 1, o = 1;
  e && je(t) && (n = t.offsetWidth > 0 && xt(a.width) / t.offsetWidth || 1, o = t.offsetHeight > 0 && xt(a.height) / t.offsetHeight || 1);
  var u = ft(t) ? Te(t) : window, s = u.visualViewport, i = !Pi() && r, l = (a.left + (i && s ? s.offsetLeft : 0)) / n, d = (a.top + (i && s ? s.offsetTop : 0)) / o, m = a.width / n, p = a.height / o;
  return {
    width: m,
    height: p,
    top: d,
    right: l + m,
    bottom: d + p,
    left: l,
    x: l,
    y: d
  };
}
function Rn(t) {
  var e = Dt(t), r = t.offsetWidth, a = t.offsetHeight;
  return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - a) <= 1 && (a = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: r,
    height: a
  };
}
function Oi(t, e) {
  var r = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (r && kn(r)) {
    var a = e;
    do {
      if (a && t.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function Ge(t) {
  return Te(t).getComputedStyle(t);
}
function cl(t) {
  return ["table", "td", "th"].indexOf(Be(t)) >= 0;
}
function it(t) {
  return ((ft(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function br(t) {
  return Be(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (kn(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    it(t)
  );
}
function vo(t) {
  return !je(t) || // https://github.com/popperjs/popper-core/issues/837
  Ge(t).position === "fixed" ? null : t.offsetParent;
}
function fl(t) {
  var e = /firefox/i.test(zr()), r = /Trident/i.test(zr());
  if (r && je(t)) {
    var a = Ge(t);
    if (a.position === "fixed")
      return null;
  }
  var n = br(t);
  for (kn(n) && (n = n.host); je(n) && ["html", "body"].indexOf(Be(n)) < 0; ) {
    var o = Ge(n);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || e && o.willChange === "filter" || e && o.filter && o.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function Zt(t) {
  for (var e = Te(t), r = vo(t); r && cl(r) && Ge(r).position === "static"; )
    r = vo(r);
  return r && (Be(r) === "html" || Be(r) === "body" && Ge(r).position === "static") ? e : r || fl(t) || e;
}
function jn(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Ht(t, e, r) {
  return dt(t, cr(e, r));
}
function ml(t, e, r) {
  var a = Ht(t, e, r);
  return a > r ? r : a;
}
function xi() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Di(t) {
  return Object.assign({}, xi(), t);
}
function Si(t, e) {
  return e.reduce(function(r, a) {
    return r[a] = t, r;
  }, {});
}
var vl = function(e, r) {
  return e = typeof e == "function" ? e(Object.assign({}, r.rects, {
    placement: r.placement
  })) : e, Di(typeof e != "number" ? e : Si(e, Jt));
};
function hl(t) {
  var e, r = t.state, a = t.name, n = t.options, o = r.elements.arrow, u = r.modifiersData.popperOffsets, s = Ye(r.placement), i = jn(s), l = [xe, We].indexOf(s) >= 0, d = l ? "height" : "width";
  if (!(!o || !u)) {
    var m = vl(n.padding, r), p = Rn(o), c = i === "y" ? Oe : xe, f = i === "y" ? Ae : We, v = r.rects.reference[d] + r.rects.reference[i] - u[i] - r.rects.popper[d], h = u[i] - r.rects.reference[i], y = Zt(o), w = y ? i === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, g = v / 2 - h / 2, b = m[c], E = w - p[d] - m[f], O = w / 2 - p[d] / 2 + g, T = Ht(b, O, E), S = i;
    r.modifiersData[a] = (e = {}, e[S] = T, e.centerOffset = T - O, e);
  }
}
function pl(t) {
  var e = t.state, r = t.options, a = r.element, n = a === void 0 ? "[data-popper-arrow]" : a;
  n != null && (typeof n == "string" && (n = e.elements.popper.querySelector(n), !n) || Oi(e.elements.popper, n) && (e.elements.arrow = n));
}
const bl = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: hl,
  effect: pl,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function St(t) {
  return t.split("-")[1];
}
var gl = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function yl(t, e) {
  var r = t.x, a = t.y, n = e.devicePixelRatio || 1;
  return {
    x: xt(r * n) / n || 0,
    y: xt(a * n) / n || 0
  };
}
function ho(t) {
  var e, r = t.popper, a = t.popperRect, n = t.placement, o = t.variation, u = t.offsets, s = t.position, i = t.gpuAcceleration, l = t.adaptive, d = t.roundOffsets, m = t.isFixed, p = u.x, c = p === void 0 ? 0 : p, f = u.y, v = f === void 0 ? 0 : f, h = typeof d == "function" ? d({
    x: c,
    y: v
  }) : {
    x: c,
    y: v
  };
  c = h.x, v = h.y;
  var y = u.hasOwnProperty("x"), w = u.hasOwnProperty("y"), g = xe, b = Oe, E = window;
  if (l) {
    var O = Zt(r), T = "clientHeight", S = "clientWidth";
    if (O === Te(r) && (O = it(r), Ge(O).position !== "static" && s === "absolute" && (T = "scrollHeight", S = "scrollWidth")), O = O, n === Oe || (n === xe || n === We) && o === Ut) {
      b = Ae;
      var P = m && O === E && E.visualViewport ? E.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        O[T]
      );
      v -= P - a.height, v *= i ? 1 : -1;
    }
    if (n === xe || (n === Oe || n === Ae) && o === Ut) {
      g = We;
      var _ = m && O === E && E.visualViewport ? E.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        O[S]
      );
      c -= _ - a.width, c *= i ? 1 : -1;
    }
  }
  var R = Object.assign({
    position: s
  }, l && gl), x = d === !0 ? yl({
    x: c,
    y: v
  }, Te(r)) : {
    x: c,
    y: v
  };
  if (c = x.x, v = x.y, i) {
    var D;
    return Object.assign({}, R, (D = {}, D[b] = w ? "0" : "", D[g] = y ? "0" : "", D.transform = (E.devicePixelRatio || 1) <= 1 ? "translate(" + c + "px, " + v + "px)" : "translate3d(" + c + "px, " + v + "px, 0)", D));
  }
  return Object.assign({}, R, (e = {}, e[b] = w ? v + "px" : "", e[g] = y ? c + "px" : "", e.transform = "", e));
}
function wl(t) {
  var e = t.state, r = t.options, a = r.gpuAcceleration, n = a === void 0 ? !0 : a, o = r.adaptive, u = o === void 0 ? !0 : o, s = r.roundOffsets, i = s === void 0 ? !0 : s, l = {
    placement: Ye(e.placement),
    variation: St(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: n,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, ho(Object.assign({}, l, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: u,
    roundOffsets: i
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, ho(Object.assign({}, l, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: i
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const Ml = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: wl,
  data: {}
};
var or = {
  passive: !0
};
function _l(t) {
  var e = t.state, r = t.instance, a = t.options, n = a.scroll, o = n === void 0 ? !0 : n, u = a.resize, s = u === void 0 ? !0 : u, i = Te(e.elements.popper), l = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return o && l.forEach(function(d) {
    d.addEventListener("scroll", r.update, or);
  }), s && i.addEventListener("resize", r.update, or), function() {
    o && l.forEach(function(d) {
      d.removeEventListener("scroll", r.update, or);
    }), s && i.removeEventListener("resize", r.update, or);
  };
}
const El = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: _l,
  data: {}
};
var Pl = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function sr(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return Pl[e];
  });
}
var Ol = {
  start: "end",
  end: "start"
};
function po(t) {
  return t.replace(/start|end/g, function(e) {
    return Ol[e];
  });
}
function An(t) {
  var e = Te(t), r = e.pageXOffset, a = e.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: a
  };
}
function Wn(t) {
  return Dt(it(t)).left + An(t).scrollLeft;
}
function xl(t, e) {
  var r = Te(t), a = it(t), n = r.visualViewport, o = a.clientWidth, u = a.clientHeight, s = 0, i = 0;
  if (n) {
    o = n.width, u = n.height;
    var l = Pi();
    (l || !l && e === "fixed") && (s = n.offsetLeft, i = n.offsetTop);
  }
  return {
    width: o,
    height: u,
    x: s + Wn(t),
    y: i
  };
}
function Dl(t) {
  var e, r = it(t), a = An(t), n = (e = t.ownerDocument) == null ? void 0 : e.body, o = dt(r.scrollWidth, r.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), u = dt(r.scrollHeight, r.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), s = -a.scrollLeft + Wn(t), i = -a.scrollTop;
  return Ge(n || r).direction === "rtl" && (s += dt(r.clientWidth, n ? n.clientWidth : 0) - o), {
    width: o,
    height: u,
    x: s,
    y: i
  };
}
function In(t) {
  var e = Ge(t), r = e.overflow, a = e.overflowX, n = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + n + a);
}
function Ci(t) {
  return ["html", "body", "#document"].indexOf(Be(t)) >= 0 ? t.ownerDocument.body : je(t) && In(t) ? t : Ci(br(t));
}
function $t(t, e) {
  var r;
  e === void 0 && (e = []);
  var a = Ci(t), n = a === ((r = t.ownerDocument) == null ? void 0 : r.body), o = Te(a), u = n ? [o].concat(o.visualViewport || [], In(a) ? a : []) : a, s = e.concat(u);
  return n ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat($t(br(u)))
  );
}
function Yr(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function Sl(t, e) {
  var r = Dt(t, !1, e === "fixed");
  return r.top = r.top + t.clientTop, r.left = r.left + t.clientLeft, r.bottom = r.top + t.clientHeight, r.right = r.left + t.clientWidth, r.width = t.clientWidth, r.height = t.clientHeight, r.x = r.left, r.y = r.top, r;
}
function bo(t, e, r) {
  return e === _i ? Yr(xl(t, r)) : ft(e) ? Sl(e, r) : Yr(Dl(it(t)));
}
function Cl(t) {
  var e = $t(br(t)), r = ["absolute", "fixed"].indexOf(Ge(t).position) >= 0, a = r && je(t) ? Zt(t) : t;
  return ft(a) ? e.filter(function(n) {
    return ft(n) && Oi(n, a) && Be(n) !== "body";
  }) : [];
}
function Tl(t, e, r, a) {
  var n = e === "clippingParents" ? Cl(t) : [].concat(e), o = [].concat(n, [r]), u = o[0], s = o.reduce(function(i, l) {
    var d = bo(t, l, a);
    return i.top = dt(d.top, i.top), i.right = cr(d.right, i.right), i.bottom = cr(d.bottom, i.bottom), i.left = dt(d.left, i.left), i;
  }, bo(t, u, a));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Ti(t) {
  var e = t.reference, r = t.element, a = t.placement, n = a ? Ye(a) : null, o = a ? St(a) : null, u = e.x + e.width / 2 - r.width / 2, s = e.y + e.height / 2 - r.height / 2, i;
  switch (n) {
    case Oe:
      i = {
        x: u,
        y: e.y - r.height
      };
      break;
    case Ae:
      i = {
        x: u,
        y: e.y + e.height
      };
      break;
    case We:
      i = {
        x: e.x + e.width,
        y: s
      };
      break;
    case xe:
      i = {
        x: e.x - r.width,
        y: s
      };
      break;
    default:
      i = {
        x: e.x,
        y: e.y
      };
  }
  var l = n ? jn(n) : null;
  if (l != null) {
    var d = l === "y" ? "height" : "width";
    switch (o) {
      case Ot:
        i[l] = i[l] - (e[d] / 2 - r[d] / 2);
        break;
      case Ut:
        i[l] = i[l] + (e[d] / 2 - r[d] / 2);
        break;
    }
  }
  return i;
}
function Kt(t, e) {
  e === void 0 && (e = {});
  var r = e, a = r.placement, n = a === void 0 ? t.placement : a, o = r.strategy, u = o === void 0 ? t.strategy : o, s = r.boundary, i = s === void 0 ? Qs : s, l = r.rootBoundary, d = l === void 0 ? _i : l, m = r.elementContext, p = m === void 0 ? Wt : m, c = r.altBoundary, f = c === void 0 ? !1 : c, v = r.padding, h = v === void 0 ? 0 : v, y = Di(typeof h != "number" ? h : Si(h, Jt)), w = p === Wt ? Gs : Wt, g = t.rects.popper, b = t.elements[f ? w : p], E = Tl(ft(b) ? b : b.contextElement || it(t.elements.popper), i, d, u), O = Dt(t.elements.reference), T = Ti({
    reference: O,
    element: g,
    strategy: "absolute",
    placement: n
  }), S = Yr(Object.assign({}, g, T)), P = p === Wt ? S : O, _ = {
    top: E.top - P.top + y.top,
    bottom: P.bottom - E.bottom + y.bottom,
    left: E.left - P.left + y.left,
    right: P.right - E.right + y.right
  }, R = t.modifiersData.offset;
  if (p === Wt && R) {
    var x = R[n];
    Object.keys(_).forEach(function(D) {
      var I = [We, Ae].indexOf(D) >= 0 ? 1 : -1, C = [Oe, Ae].indexOf(D) >= 0 ? "y" : "x";
      _[D] += x[C] * I;
    });
  }
  return _;
}
function kl(t, e) {
  e === void 0 && (e = {});
  var r = e, a = r.placement, n = r.boundary, o = r.rootBoundary, u = r.padding, s = r.flipVariations, i = r.allowedAutoPlacements, l = i === void 0 ? Ei : i, d = St(a), m = d ? s ? mo : mo.filter(function(f) {
    return St(f) === d;
  }) : Jt, p = m.filter(function(f) {
    return l.indexOf(f) >= 0;
  });
  p.length === 0 && (p = m);
  var c = p.reduce(function(f, v) {
    return f[v] = Kt(t, {
      placement: v,
      boundary: n,
      rootBoundary: o,
      padding: u
    })[Ye(v)], f;
  }, {});
  return Object.keys(c).sort(function(f, v) {
    return c[f] - c[v];
  });
}
function Rl(t) {
  if (Ye(t) === Tn)
    return [];
  var e = sr(t);
  return [po(t), e, po(e)];
}
function jl(t) {
  var e = t.state, r = t.options, a = t.name;
  if (!e.modifiersData[a]._skip) {
    for (var n = r.mainAxis, o = n === void 0 ? !0 : n, u = r.altAxis, s = u === void 0 ? !0 : u, i = r.fallbackPlacements, l = r.padding, d = r.boundary, m = r.rootBoundary, p = r.altBoundary, c = r.flipVariations, f = c === void 0 ? !0 : c, v = r.allowedAutoPlacements, h = e.options.placement, y = Ye(h), w = y === h, g = i || (w || !f ? [sr(h)] : Rl(h)), b = [h].concat(g).reduce(function(F, B) {
      return F.concat(Ye(B) === Tn ? kl(e, {
        placement: B,
        boundary: d,
        rootBoundary: m,
        padding: l,
        flipVariations: f,
        allowedAutoPlacements: v
      }) : B);
    }, []), E = e.rects.reference, O = e.rects.popper, T = /* @__PURE__ */ new Map(), S = !0, P = b[0], _ = 0; _ < b.length; _++) {
      var R = b[_], x = Ye(R), D = St(R) === Ot, I = [Oe, Ae].indexOf(x) >= 0, C = I ? "width" : "height", A = Kt(e, {
        placement: R,
        boundary: d,
        rootBoundary: m,
        altBoundary: p,
        padding: l
      }), V = I ? D ? We : xe : D ? Ae : Oe;
      E[C] > O[C] && (V = sr(V));
      var J = sr(V), Z = [];
      if (o && Z.push(A[x] <= 0), s && Z.push(A[V] <= 0, A[J] <= 0), Z.every(function(F) {
        return F;
      })) {
        P = R, S = !1;
        break;
      }
      T.set(R, Z);
    }
    if (S)
      for (var de = f ? 3 : 1, ae = function(B) {
        var Q = b.find(function(be) {
          var ge = T.get(be);
          if (ge)
            return ge.slice(0, B).every(function(Ee) {
              return Ee;
            });
        });
        if (Q)
          return P = Q, "break";
      }, ne = de; ne > 0; ne--) {
        var ve = ae(ne);
        if (ve === "break")
          break;
      }
    e.placement !== P && (e.modifiersData[a]._skip = !0, e.placement = P, e.reset = !0);
  }
}
const Al = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: jl,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function go(t, e, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - r.y,
    right: t.right - e.width + r.x,
    bottom: t.bottom - e.height + r.y,
    left: t.left - e.width - r.x
  };
}
function yo(t) {
  return [Oe, We, Ae, xe].some(function(e) {
    return t[e] >= 0;
  });
}
function Wl(t) {
  var e = t.state, r = t.name, a = e.rects.reference, n = e.rects.popper, o = e.modifiersData.preventOverflow, u = Kt(e, {
    elementContext: "reference"
  }), s = Kt(e, {
    altBoundary: !0
  }), i = go(u, a), l = go(s, n, o), d = yo(i), m = yo(l);
  e.modifiersData[r] = {
    referenceClippingOffsets: i,
    popperEscapeOffsets: l,
    isReferenceHidden: d,
    hasPopperEscaped: m
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": m
  });
}
const Il = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Wl
};
function Nl(t, e, r) {
  var a = Ye(t), n = [xe, Oe].indexOf(a) >= 0 ? -1 : 1, o = typeof r == "function" ? r(Object.assign({}, e, {
    placement: t
  })) : r, u = o[0], s = o[1];
  return u = u || 0, s = (s || 0) * n, [xe, We].indexOf(a) >= 0 ? {
    x: s,
    y: u
  } : {
    x: u,
    y: s
  };
}
function Fl(t) {
  var e = t.state, r = t.options, a = t.name, n = r.offset, o = n === void 0 ? [0, 0] : n, u = Ei.reduce(function(d, m) {
    return d[m] = Nl(m, e.rects, o), d;
  }, {}), s = u[e.placement], i = s.x, l = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += i, e.modifiersData.popperOffsets.y += l), e.modifiersData[a] = u;
}
const Ll = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Fl
};
function Hl(t) {
  var e = t.state, r = t.name;
  e.modifiersData[r] = Ti({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const $l = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Hl,
  data: {}
};
function zl(t) {
  return t === "x" ? "y" : "x";
}
function Yl(t) {
  var e = t.state, r = t.options, a = t.name, n = r.mainAxis, o = n === void 0 ? !0 : n, u = r.altAxis, s = u === void 0 ? !1 : u, i = r.boundary, l = r.rootBoundary, d = r.altBoundary, m = r.padding, p = r.tether, c = p === void 0 ? !0 : p, f = r.tetherOffset, v = f === void 0 ? 0 : f, h = Kt(e, {
    boundary: i,
    rootBoundary: l,
    padding: m,
    altBoundary: d
  }), y = Ye(e.placement), w = St(e.placement), g = !w, b = jn(y), E = zl(b), O = e.modifiersData.popperOffsets, T = e.rects.reference, S = e.rects.popper, P = typeof v == "function" ? v(Object.assign({}, e.rects, {
    placement: e.placement
  })) : v, _ = typeof P == "number" ? {
    mainAxis: P,
    altAxis: P
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, P), R = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, x = {
    x: 0,
    y: 0
  };
  if (O) {
    if (o) {
      var D, I = b === "y" ? Oe : xe, C = b === "y" ? Ae : We, A = b === "y" ? "height" : "width", V = O[b], J = V + h[I], Z = V - h[C], de = c ? -S[A] / 2 : 0, ae = w === Ot ? T[A] : S[A], ne = w === Ot ? -S[A] : -T[A], ve = e.elements.arrow, F = c && ve ? Rn(ve) : {
        width: 0,
        height: 0
      }, B = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : xi(), Q = B[I], be = B[C], ge = Ht(0, T[A], F[A]), Ee = g ? T[A] / 2 - de - ge - Q - _.mainAxis : ae - ge - Q - _.mainAxis, k = g ? -T[A] / 2 + de + ge + be + _.mainAxis : ne + ge + be + _.mainAxis, W = e.elements.arrow && Zt(e.elements.arrow), K = W ? b === "y" ? W.clientTop || 0 : W.clientLeft || 0 : 0, z = (D = R == null ? void 0 : R[b]) != null ? D : 0, H = V + Ee - z - K, G = V + k - z, Y = Ht(c ? cr(J, H) : J, V, c ? dt(Z, G) : Z);
      O[b] = Y, x[b] = Y - V;
    }
    if (s) {
      var q, X = b === "x" ? Oe : xe, oe = b === "x" ? Ae : We, U = O[E], j = E === "y" ? "height" : "width", se = U + h[X], we = U - h[oe], Ie = [Oe, xe].indexOf(y) !== -1, tr = (q = R == null ? void 0 : R[E]) != null ? q : 0, rr = Ie ? se : U - T[j] - S[j] - tr + _.altAxis, ar = Ie ? U + T[j] + S[j] - tr - _.altAxis : we, nr = c && Ie ? ml(rr, U, ar) : Ht(c ? rr : se, U, c ? ar : we);
      O[E] = nr, x[E] = nr - U;
    }
    e.modifiersData[a] = x;
  }
}
const Bl = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Yl,
  requiresIfExists: ["offset"]
};
function ql(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function Ul(t) {
  return t === Te(t) || !je(t) ? An(t) : ql(t);
}
function Kl(t) {
  var e = t.getBoundingClientRect(), r = xt(e.width) / t.offsetWidth || 1, a = xt(e.height) / t.offsetHeight || 1;
  return r !== 1 || a !== 1;
}
function Xl(t, e, r) {
  r === void 0 && (r = !1);
  var a = je(e), n = je(e) && Kl(e), o = it(e), u = Dt(t, n, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, i = {
    x: 0,
    y: 0
  };
  return (a || !a && !r) && ((Be(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  In(o)) && (s = Ul(e)), je(e) ? (i = Dt(e, !0), i.x += e.clientLeft, i.y += e.clientTop) : o && (i.x = Wn(o))), {
    x: u.left + s.scrollLeft - i.x,
    y: u.top + s.scrollTop - i.y,
    width: u.width,
    height: u.height
  };
}
function Vl(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), a = [];
  t.forEach(function(o) {
    e.set(o.name, o);
  });
  function n(o) {
    r.add(o.name);
    var u = [].concat(o.requires || [], o.requiresIfExists || []);
    u.forEach(function(s) {
      if (!r.has(s)) {
        var i = e.get(s);
        i && n(i);
      }
    }), a.push(o);
  }
  return t.forEach(function(o) {
    r.has(o.name) || n(o);
  }), a;
}
function Ql(t) {
  var e = Vl(t);
  return ul.reduce(function(r, a) {
    return r.concat(e.filter(function(n) {
      return n.phase === a;
    }));
  }, []);
}
function Gl(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(r) {
      Promise.resolve().then(function() {
        e = void 0, r(t());
      });
    })), e;
  };
}
function Jl(t) {
  var e = t.reduce(function(r, a) {
    var n = r[a.name];
    return r[a.name] = n ? Object.assign({}, n, a, {
      options: Object.assign({}, n.options, a.options),
      data: Object.assign({}, n.data, a.data)
    }) : a, r;
  }, {});
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
var wo = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Mo() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return !e.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function Zl(t) {
  t === void 0 && (t = {});
  var e = t, r = e.defaultModifiers, a = r === void 0 ? [] : r, n = e.defaultOptions, o = n === void 0 ? wo : n;
  return function(s, i, l) {
    l === void 0 && (l = o);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, wo, o),
      modifiersData: {},
      elements: {
        reference: s,
        popper: i
      },
      attributes: {},
      styles: {}
    }, m = [], p = !1, c = {
      state: d,
      setOptions: function(y) {
        var w = typeof y == "function" ? y(d.options) : y;
        v(), d.options = Object.assign({}, o, d.options, w), d.scrollParents = {
          reference: ft(s) ? $t(s) : s.contextElement ? $t(s.contextElement) : [],
          popper: $t(i)
        };
        var g = Ql(Jl([].concat(a, d.options.modifiers)));
        return d.orderedModifiers = g.filter(function(b) {
          return b.enabled;
        }), f(), c.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var y = d.elements, w = y.reference, g = y.popper;
          if (Mo(w, g)) {
            d.rects = {
              reference: Xl(w, Zt(g), d.options.strategy === "fixed"),
              popper: Rn(g)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(_) {
              return d.modifiersData[_.name] = Object.assign({}, _.data);
            });
            for (var b = 0; b < d.orderedModifiers.length; b++) {
              if (d.reset === !0) {
                d.reset = !1, b = -1;
                continue;
              }
              var E = d.orderedModifiers[b], O = E.fn, T = E.options, S = T === void 0 ? {} : T, P = E.name;
              typeof O == "function" && (d = O({
                state: d,
                options: S,
                name: P,
                instance: c
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Gl(function() {
        return new Promise(function(h) {
          c.forceUpdate(), h(d);
        });
      }),
      destroy: function() {
        v(), p = !0;
      }
    };
    if (!Mo(s, i))
      return c;
    c.setOptions(l).then(function(h) {
      !p && l.onFirstUpdate && l.onFirstUpdate(h);
    });
    function f() {
      d.orderedModifiers.forEach(function(h) {
        var y = h.name, w = h.options, g = w === void 0 ? {} : w, b = h.effect;
        if (typeof b == "function") {
          var E = b({
            state: d,
            name: y,
            instance: c,
            options: g
          }), O = function() {
          };
          m.push(E || O);
        }
      });
    }
    function v() {
      m.forEach(function(h) {
        return h();
      }), m = [];
    }
    return c;
  };
}
var ed = [El, $l, Ml, dl, Ll, Al, Bl, bl, Il], td = /* @__PURE__ */ Zl({
  defaultModifiers: ed
});
function rd(t) {
  var e = ee(null);
  return ot(function() {
    e.current = t;
  }, [t]), e;
}
function ad(t) {
  t === void 0 && (t = {});
  var e = pt(t), r = e.visible, a = r === void 0 ? !1 : r, n = e.animated, o = n === void 0 ? !1 : n, u = te(e, ["visible", "animated"]), s = gi(u), i = le(a), l = i[0], d = i[1], m = le(o), p = m[0], c = m[1], f = le(!1), v = f[0], h = f[1], y = rd(l), w = y.current != null && y.current !== l;
  p && !v && w && h(!0), ie(function() {
    if (typeof p == "number" && v) {
      var T = setTimeout(function() {
        return h(!1);
      }, p);
      return function() {
        clearTimeout(T);
      };
    }
    if (p && v && process.env.NODE_ENV === "development") {
      var S = setTimeout(function() {
        process.env.NODE_ENV !== "production" && De(v, "It's been 8 seconds but stopAnimation has not been called. Does the disclousure element have a CSS transition?");
      }, 8e3);
      return function() {
        clearTimeout(S);
      };
    }
    return function() {
    };
  }, [p, v]);
  var g = N(function() {
    return d(!0);
  }, []), b = N(function() {
    return d(!1);
  }, []), E = N(function() {
    return d(function(T) {
      return !T;
    });
  }, []), O = N(function() {
    return h(!1);
  }, []);
  return M(M({}, s), {}, {
    visible: l,
    animated: p,
    animating: v,
    show: g,
    hide: b,
    toggle: E,
    setVisible: d,
    setAnimated: c,
    stopAnimation: O
  });
}
function nd(t) {
  t === void 0 && (t = {});
  var e = pt(t), r = e.modal, a = r === void 0 ? !0 : r, n = te(e, ["modal"]), o = ad(n), u = le(a), s = u[0], i = u[1], l = ee(null);
  return M(M({}, o), {}, {
    modal: s,
    setModal: i,
    unstable_disclosureRef: l
  });
}
var od = lt("Mac") && !lt("Chrome") && lt("Safari");
function _o(t) {
  return function(e) {
    return t && !Bt(e, t) ? t : e;
  };
}
function id(t) {
  t === void 0 && (t = {});
  var e = pt(t), r = e.gutter, a = r === void 0 ? 12 : r, n = e.placement, o = n === void 0 ? "bottom" : n, u = e.unstable_flip, s = u === void 0 ? !0 : u, i = e.unstable_offset, l = e.unstable_preventOverflow, d = l === void 0 ? !0 : l, m = e.unstable_fixed, p = m === void 0 ? !1 : m, c = e.modal, f = c === void 0 ? !1 : c, v = te(e, ["gutter", "placement", "unstable_flip", "unstable_offset", "unstable_preventOverflow", "unstable_fixed", "modal"]), h = ee(null), y = ee(null), w = ee(null), g = ee(null), b = le(o), E = b[0], O = b[1], T = le(o), S = T[0], P = T[1], _ = le(i || [0, a]), R = _[0], x = le({
    position: "fixed",
    left: "100%",
    top: "100%"
  }), D = x[0], I = x[1], C = le({}), A = C[0], V = C[1], J = nd(M({
    modal: f
  }, v)), Z = N(function() {
    return h.current ? (h.current.forceUpdate(), !0) : !1;
  }, []), de = N(function(ae) {
    ae.placement && P(ae.placement), ae.styles && (I(_o(ae.styles.popper)), g.current && V(_o(ae.styles.arrow)));
  }, []);
  return ot(function() {
    return y.current && w.current && (h.current = td(y.current, w.current, {
      // https://popper.js.org/docs/v2/constructors/#options
      placement: E,
      strategy: p ? "fixed" : "absolute",
      // Safari needs styles to be applied in the first render, otherwise
      // hovering over the popover when it gets visible for the first time
      // will change its dimensions unexpectedly.
      onFirstUpdate: od ? de : void 0,
      modifiers: [{
        // https://popper.js.org/docs/v2/modifiers/event-listeners/
        name: "eventListeners",
        enabled: J.visible
      }, {
        // https://popper.js.org/docs/v2/modifiers/apply-styles/
        name: "applyStyles",
        enabled: !1
      }, {
        // https://popper.js.org/docs/v2/modifiers/flip/
        name: "flip",
        enabled: s,
        options: {
          padding: 8
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/offset/
        name: "offset",
        options: {
          offset: R
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/prevent-overflow/
        name: "preventOverflow",
        enabled: d,
        options: {
          tetherOffset: function() {
            var ne;
            return ((ne = g.current) === null || ne === void 0 ? void 0 : ne.clientWidth) || 0;
          }
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/arrow/
        name: "arrow",
        enabled: !!g.current,
        options: {
          element: g.current
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/#custom-modifiers
        name: "updateState",
        phase: "write",
        requires: ["computeStyles"],
        enabled: J.visible && process.env.NODE_ENV !== "test",
        fn: function(ne) {
          var ve = ne.state;
          return de(ve);
        }
      }]
    })), function() {
      h.current && (h.current.destroy(), h.current = null);
    };
  }, [E, p, J.visible, s, R, d]), ie(function() {
    if (J.visible) {
      var ae = window.requestAnimationFrame(function() {
        var ne;
        (ne = h.current) === null || ne === void 0 || ne.forceUpdate();
      });
      return function() {
        window.cancelAnimationFrame(ae);
      };
    }
  }, [J.visible]), M(M({}, J), {}, {
    unstable_referenceRef: y,
    unstable_popoverRef: w,
    unstable_arrowRef: g,
    unstable_popoverStyles: D,
    unstable_arrowStyles: A,
    unstable_update: Z,
    unstable_originalPlacement: E,
    placement: S,
    place: O
  });
}
var ud = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation"], ki = ud, sd = ki, Ri = pe({
  name: "DisclosureContent",
  compose: Gt,
  keys: sd,
  useProps: function(e, r) {
    var a = r.onTransitionEnd, n = r.onAnimationEnd, o = r.style, u = te(r, ["onTransitionEnd", "onAnimationEnd", "style"]), s = e.animated && e.animating, i = le(null), l = i[0], d = i[1], m = !e.visible && !s, p = m ? M({
      display: "none"
    }, o) : o, c = re(a), f = re(n), v = ee(0);
    ie(function() {
      if (e.animated)
        return v.current = window.requestAnimationFrame(function() {
          v.current = window.requestAnimationFrame(function() {
            e.visible ? d("enter") : d(s ? "leave" : null);
          });
        }), function() {
          return window.cancelAnimationFrame(v.current);
        };
    }, [e.animated, e.visible, s]);
    var h = N(function(g) {
      if (Ne(g) && s && e.animated === !0) {
        var b;
        (b = e.stopAnimation) === null || b === void 0 || b.call(e);
      }
    }, [e.animated, s, e.stopAnimation]), y = N(function(g) {
      var b;
      (b = c.current) === null || b === void 0 || b.call(c, g), h(g);
    }, [h]), w = N(function(g) {
      var b;
      (b = f.current) === null || b === void 0 || b.call(f, g), h(g);
    }, [h]);
    return M({
      id: e.baseId,
      "data-enter": l === "enter" ? "" : void 0,
      "data-leave": l === "leave" ? "" : void 0,
      onTransitionEnd: y,
      onAnimationEnd: w,
      hidden: m,
      style: p
    }, u);
  }
});
he({
  as: "div",
  useHook: Ri
});
function ji() {
  return Rt ? document.body : null;
}
var Eo = /* @__PURE__ */ nt(ji());
function Ct(t) {
  var e = t.children, r = Ce(Eo) || ji(), a = le(function() {
    if (Rt) {
      var o = document.createElement("div");
      return o.className = Ct.__className, o;
    }
    return null;
  }), n = a[0];
  return ot(function() {
    if (!(!n || !r))
      return r.appendChild(n), function() {
        r.removeChild(n);
      };
  }, [n, r]), n ? /* @__PURE__ */ Hu(/* @__PURE__ */ Le(Eo.Provider, {
    value: n
  }, e), n) : null;
}
Ct.__className = "__reakit-portal";
Ct.__selector = "." + Ct.__className;
function Br(t, e) {
  var r = t.indexOf(e);
  return bs(t, r);
}
var at = /* @__PURE__ */ nt(null);
function ld(t, e, r) {
  var a = "unstable_orphan" in r && r.unstable_orphan, n = Ce(at), o = le([]), u = o[0], s = o[1], i = n || {}, l = i.addChild, d = i.removeChild, m = N(function(v) {
    return s(function(h) {
      return [].concat(h, [v]);
    });
  }, []), p = N(function(v) {
    return s(function(h) {
      return Br(h, v);
    });
  }, []);
  ie(function() {
    if (!(!l || a))
      return l(t), function() {
        d == null || d(t);
      };
  }, [t, l, d, a]);
  var c = Fe(function() {
    return {
      orientation: r.orientation,
      next: r.next,
      previous: r.previous,
      ref: t,
      role: e,
      parent: n,
      children: u,
      addChild: m,
      removeChild: p
    };
  }, [r.orientation, r.next, r.previous, t, e, n, u, m, p]), f = N(function(v) {
    return /* @__PURE__ */ Le(at.Provider, {
      value: c
    }, v);
  }, [c]);
  return f;
}
function dd(t) {
  if (Array.isArray(t)) {
    for (var e = 0, r = Array(t.length); e < t.length; e++)
      r[e] = t[e];
    return r;
  } else
    return Array.from(t);
}
var Nn = !1;
if (typeof window < "u") {
  var Po = {
    get passive() {
      Nn = !0;
    }
  };
  window.addEventListener("testPassive", null, Po), window.removeEventListener("testPassive", null, Po);
}
var Ai = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), rt = [], fr = !1, Wi = -1, zt = void 0, Yt = void 0, Ii = function(e) {
  return rt.some(function(r) {
    return !!(r.options.allowTouchMove && r.options.allowTouchMove(e));
  });
}, mr = function(e) {
  var r = e || window.event;
  return Ii(r.target) || r.touches.length > 1 ? !0 : (r.preventDefault && r.preventDefault(), !1);
}, cd = function(e) {
  if (Yt === void 0) {
    var r = !!e && e.reserveScrollBarGap === !0, a = window.innerWidth - document.documentElement.clientWidth;
    r && a > 0 && (Yt = document.body.style.paddingRight, document.body.style.paddingRight = a + "px");
  }
  zt === void 0 && (zt = document.body.style.overflow, document.body.style.overflow = "hidden");
}, fd = function() {
  Yt !== void 0 && (document.body.style.paddingRight = Yt, Yt = void 0), zt !== void 0 && (document.body.style.overflow = zt, zt = void 0);
}, md = function(e) {
  return e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1;
}, vd = function(e, r) {
  var a = e.targetTouches[0].clientY - Wi;
  return Ii(e.target) ? !1 : r && r.scrollTop === 0 && a > 0 || md(r) && a < 0 ? mr(e) : (e.stopPropagation(), !0);
}, hd = function(e, r) {
  if (!e) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!rt.some(function(n) {
    return n.targetElement === e;
  })) {
    var a = {
      targetElement: e,
      options: r || {}
    };
    rt = [].concat(dd(rt), [a]), Ai ? (e.ontouchstart = function(n) {
      n.targetTouches.length === 1 && (Wi = n.targetTouches[0].clientY);
    }, e.ontouchmove = function(n) {
      n.targetTouches.length === 1 && vd(n, e);
    }, fr || (document.addEventListener("touchmove", mr, Nn ? { passive: !1 } : void 0), fr = !0)) : cd(r);
  }
}, pd = function(e) {
  if (!e) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  rt = rt.filter(function(r) {
    return r.targetElement !== e;
  }), Ai ? (e.ontouchstart = null, e.ontouchmove = null, fr && rt.length === 0 && (document.removeEventListener("touchmove", mr, Nn ? { passive: !1 } : void 0), fr = !1)) : rt.length || fd();
}, bd = /* @__PURE__ */ nt(void 0);
function gd(t) {
  return Array.isArray(t) ? !t.length : Dn(t) ? !Object.keys(t).length : t == null || t === "";
}
var Ni = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal"], yd = [].concat(Ni, ["hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_initialFocusRef", "unstable_finalFocusRef", "unstable_orphan", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide"]), wd = Ni, Md = wd;
function _d(t, e) {
  var r = ee(null), a = !!(e.animated && e.animating);
  return ie(function() {
    if (!(e.visible || a)) {
      var n = function(s) {
        var i = s.target;
        "focus" in i && (r.current = i, e.unstable_disclosureRef && (e.unstable_disclosureRef.current = i));
      }, o = ye(t.current);
      return o.addEventListener("focusin", n), function() {
        return o.removeEventListener("focusin", n);
      };
    }
  }, [e.visible, a, e.unstable_disclosureRef, t]), ie(function() {
    var n;
    if (!(!e.visible || a)) {
      var o = function(i) {
        var l = i.currentTarget;
        pr(l) && (i.preventDefault(), l.focus());
      }, u = ((n = e.unstable_disclosureRef) === null || n === void 0 ? void 0 : n.current) || r.current;
      return u == null || u.addEventListener("mousedown", o), function() {
        return u == null ? void 0 : u.removeEventListener("mousedown", o);
      };
    }
  }, [e.visible, a, e.unstable_disclosureRef]), e.unstable_disclosureRef || r;
}
function Ed(t, e) {
  var r = !!(e.preventBodyScroll && e.visible);
  ie(function() {
    var a = t.current;
    if (!(!a || !r))
      return hd(a, {
        reserveScrollBarGap: !0
      }), function() {
        return pd(a);
      };
  }, [t, r]);
}
function Pd(t, e, r) {
  var a = r.unstable_initialFocusRef, n = r.visible && r.unstable_autoFocusOnShow, o = !!(r.animated && r.animating);
  di(function() {
    var u = t.current;
    if (process.env.NODE_ENV !== "production" && De(!!n && !u, "[reakit/Dialog]", "Can't set initial focus on dialog because `ref` wasn't passed to the dialog element.", "See https://reakit.io/docs/dialog"), !!n && u && !o && !e.some(function(l) {
      return l.current && !l.current.hidden;
    }))
      if (a != null && a.current)
        a.current.focus({
          preventScroll: !0
        });
      else {
        var s = ui(u, !0), i = function() {
          return Qt(u);
        };
        s ? qt(s, {
          preventScroll: !0,
          isActive: i
        }) : (qt(u, {
          preventScroll: !0,
          isActive: i
        }), process.env.NODE_ENV !== "production" && De(u.tabIndex === void 0 || u.tabIndex < 0, "It's recommended to have at least one tabbable element inside dialog. The dialog element has been automatically focused.", "If this is the intended behavior, pass `tabIndex={0}` to the dialog element to disable this warning.", "See https://reakit.io/docs/dialog/#initial-focus", u));
      }
  }, [t, n, o, e, a]);
}
function Od(t, e) {
  var r = ee(null);
  return ie(function() {
    var a = t.current;
    !a || !e.visible || (r.current = ai(a, Ct.__selector));
  }, [t, e.visible]), r;
}
function Oo(t) {
  t.parentNode != null && t.parentNode.removeChild(t);
}
var Fi = "__reakit-focus-trap";
function xd(t) {
  var e;
  return (e = t.classList) === null || e === void 0 ? void 0 : e.contains(Fi);
}
function Dd(t, e, r) {
  var a = Od(t, r), n = r.visible && r.modal, o = ee(null), u = ee(null);
  ie(function() {
    if (n) {
      var s = a.current;
      if (!s) {
        process.env.NODE_ENV !== "production" && De(!0, "Can't trap focus within modal dialog because either `ref` wasn't passed to component or the component wasn't rendered within a portal", "See https://reakit.io/docs/dialog");
        return;
      }
      if (!o.current) {
        var i = ye(s);
        o.current = i.createElement("div"), o.current.className = Fi, o.current.tabIndex = 0, o.current.style.position = "fixed", o.current.setAttribute("aria-hidden", "true");
      }
      return u.current || (u.current = o.current.cloneNode()), s.insertAdjacentElement("beforebegin", o.current), s.insertAdjacentElement("afterend", u.current), function() {
        o.current && Oo(o.current), u.current && Oo(u.current);
      };
    }
  }, [a, n]), ie(function() {
    var s = o.current, i = u.current;
    if (!(!n || !s || !i)) {
      var l = function(m) {
        var p = t.current;
        if (!(!p || e.length)) {
          m.preventDefault();
          var c = m.target === i, f = c ? ui(p) : us(p);
          f ? f.focus() : p.focus();
        }
      };
      return s.addEventListener("focus", l), i.addEventListener("focus", l), function() {
        s.removeEventListener("focus", l), i.removeEventListener("focus", l);
      };
    }
  }, [t, e, n]);
}
function Sd(t) {
  var e = t.current;
  if (!e)
    return !1;
  var r = jt(e);
  return !r || He(e, r) ? !1 : !!(Fr(r) || r.getAttribute("data-dialog") === "true");
}
function Cd(t, e, r) {
  var a = r.unstable_autoFocusOnHide && !r.visible, n = !!(r.animated && r.animating);
  di(function() {
    var o;
    if (a && !n && !Sd(t)) {
      var u = ((o = r.unstable_finalFocusRef) === null || o === void 0 ? void 0 : o.current) || e.current;
      if (u) {
        if (u.id) {
          var s = ye(u), i = s.querySelector("[aria-activedescendant='" + u.id + "']");
          if (i) {
            qt(i);
            return;
          }
        }
        qt(u);
        return;
      }
      process.env.NODE_ENV !== "production" && De(!0, "Can't return focus after closing dialog. Either render a disclosure component or provide a `unstable_finalFocusRef` prop.", "See https://reakit.io/docs/dialog", t.current);
    }
  }, [a, n, t, e]);
}
var xo = /* @__PURE__ */ nt({});
function Td(t, e) {
  var r = Ce(xo), a = le([]), n = a[0], o = a[1], u = le(n), s = u[0], i = u[1], l = N(function(v) {
    var h;
    (h = r.addDialog) === null || h === void 0 || h.call(r, v), o(function(y) {
      return [].concat(y, [v]);
    });
  }, [r.addDialog]), d = N(function(v) {
    var h;
    (h = r.removeDialog) === null || h === void 0 || h.call(r, v), o(function(y) {
      return Br(y, v);
    });
  }, [r.removeDialog]), m = N(function(v) {
    var h;
    (h = r.showDialog) === null || h === void 0 || h.call(r, v), i(function(y) {
      return [].concat(y, [v]);
    });
  }, [r.showDialog]), p = N(function(v) {
    var h;
    (h = r.hideDialog) === null || h === void 0 || h.call(r, v), i(function(y) {
      return Br(y, v);
    });
  }, [r.hideDialog]);
  ie(function() {
    var v;
    if (!e.unstable_orphan)
      return (v = r.addDialog) === null || v === void 0 || v.call(r, t), function() {
        var h;
        (h = r.removeDialog) === null || h === void 0 || h.call(r, t);
      };
  }, [e.unstable_orphan, r.addDialog, t, r.removeDialog]), ie(function() {
    var v;
    if (!e.unstable_orphan && e.modal && e.visible)
      return (v = r.showDialog) === null || v === void 0 || v.call(r, t), function() {
        var h;
        (h = r.hideDialog) === null || h === void 0 || h.call(r, t);
      };
  }, [e.unstable_orphan, e.modal, e.visible, r.showDialog, t, r.hideDialog]), ie(function() {
    if (r.visible === !1 && e.visible && !e.unstable_orphan) {
      var v;
      (v = e.hide) === null || v === void 0 || v.call(e);
    }
  }, [r.visible, e.visible, e.hide, e.unstable_orphan]);
  var c = Fe(function() {
    return {
      visible: e.visible,
      addDialog: l,
      removeDialog: d,
      showDialog: m,
      hideDialog: p
    };
  }, [e.visible, l, d, m, p]), f = N(function(v) {
    return /* @__PURE__ */ Le(xo.Provider, {
      value: c
    }, v);
  }, [c]);
  return {
    dialogs: n,
    visibleModals: s,
    wrap: f
  };
}
function kd(t) {
  return function(e) {
    var r = e.current;
    if (!r)
      return !1;
    if (He(r, t))
      return !0;
    var a = ye(r), n = a.querySelector('[data-dialog-ref="' + r.id + '"]');
    return n ? He(n, t) : !1;
  };
}
function Rd(t, e) {
  return He(e, t);
}
function jd(t) {
  var e = ye(t);
  return t.tagName === "HTML" ? !0 : He(e.body, t);
}
function qr(t, e, r, a, n, o, u) {
  var s = re(n);
  ie(function() {
    if (o) {
      var i = function(m) {
        if (s.current) {
          var p = t.current, c = e.current, f = m.target;
          if (!p) {
            process.env.NODE_ENV !== "production" && De(!0, "Can't detect events outside dialog because `ref` wasn't passed to component.", "See https://reakit.io/docs/dialog");
            return;
          }
          jd(f) && (He(p, f) || c && Rd(f, c) || xd(f) || r.some(kd(f)) || s.current(m));
        }
      }, l = ye(t.current);
      return l.addEventListener(a, i, u), function() {
        return l.removeEventListener(a, i, u);
      };
    }
  }, [t, e, r, a, o, s]);
}
function Ad(t, e) {
  var r = ee();
  return ie(function() {
    if (e.visible && e.hideOnClickOutside) {
      var a = ye(t.current), n = function(u) {
        r.current = u.target;
      };
      return a.addEventListener("mousedown", n), function() {
        return a.removeEventListener("mousedown", n);
      };
    }
  }, [e.visible, e.hideOnClickOutside, t]), r;
}
function Wd(t, e, r, a) {
  var n = Ad(t, a);
  qr(t, e, r, "click", function(o) {
    if (n.current === o.target) {
      var u;
      (u = a.hide) === null || u === void 0 || u.call(a);
    }
  }, a.visible && a.hideOnClickOutside), qr(t, e, r, "focusin", function(o) {
    var u = ye(t.current);
    if (o.target !== u && o.target !== u.body) {
      var s;
      (s = a.hide) === null || s === void 0 || s.call(a);
    }
  }, a.visible && a.hideOnClickOutside);
}
function Id(t, e, r) {
  var a = function(o) {
    return qr(t, {
      current: null
    }, e, o, function(u) {
      u.stopPropagation(), u.preventDefault();
    }, r.visible && r.modal, !0);
  };
  a("mouseover"), a("mousemove"), a("mouseout");
}
function Nd(t, e) {
  ie(function() {
    var r = t.current;
    if (!(!e.visible || !r)) {
      var a = new MutationObserver(function(n) {
        var o = n[0].target;
        if (o === r) {
          var u = ye(r), s = jt(r);
          (s === u.body || gd(s)) && r.focus();
        }
      });
      return a.observe(r, {
        childList: !0,
        subtree: !0
      }), function() {
        a.disconnect();
      };
    }
  }, [e.visible, t]);
}
function Do(t) {
  return t && t.tagName && t.tagName !== "HTML" && t !== ye(t).body;
}
function Fd(t, e) {
  var r = On(function(u) {
    return u + 1;
  }, 0), a = r[0], n = r[1];
  ot(function() {
    var u = t.current;
    e.visible && a && (Do(jt(u)) || (process.env.NODE_ENV !== "production" && De(!u, "Can't focus dialog after a nested element got blurred because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog"), u == null || u.focus()));
  }, [a, t]);
  var o = N(function(u) {
    if (e.visible) {
      var s = ci(u);
      Do(s) || n();
    }
  }, [e.visible]);
  return o;
}
var Li = pe({
  name: "Dialog",
  compose: Ri,
  keys: yd,
  useOptions: function(e) {
    var r = e.modal, a = r === void 0 ? !0 : r, n = e.hideOnEsc, o = n === void 0 ? !0 : n, u = e.hideOnClickOutside, s = u === void 0 ? !0 : u, i = e.preventBodyScroll, l = i === void 0 ? a : i, d = e.unstable_autoFocusOnShow, m = d === void 0 ? !0 : d, p = e.unstable_autoFocusOnHide, c = p === void 0 ? !0 : p, f = e.unstable_orphan, v = te(e, ["modal", "hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide", "unstable_orphan"]);
    return M({
      modal: a,
      hideOnEsc: o,
      hideOnClickOutside: s,
      preventBodyScroll: a && l,
      unstable_autoFocusOnShow: m,
      unstable_autoFocusOnHide: c,
      unstable_orphan: a && f
    }, v);
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.onKeyDown, o = r.onBlur, u = r.wrapElement, s = r.tabIndex, i = te(r, ["ref", "onKeyDown", "onBlur", "wrapElement", "tabIndex"]), l = ee(null), d = Ce(bd), m = d && d === e.baseId, p = _d(l, e), c = re(n), f = re(o), v = Fd(l, e), h = Td(l, e), y = h.dialogs, w = h.visibleModals, g = h.wrap, b = e.modal && !w.length ? !0 : void 0;
    Ed(l, e), Dd(l, w, e), Nd(l, e), Pd(l, y, e), Cd(l, p, e), Wd(l, p, y, e), Id(l, y, e);
    var E = N(function(S) {
      var P;
      if ((P = c.current) === null || P === void 0 || P.call(c, S), !S.defaultPrevented && S.key === "Escape" && e.hideOnEsc) {
        if (!e.hide) {
          process.env.NODE_ENV !== "production" && De(!0, "`hideOnEsc` prop is truthy, but `hide` prop wasn't provided.", "See https://reakit.io/docs/dialog", l.current);
          return;
        }
        S.stopPropagation(), e.hide();
      }
    }, [e.hideOnEsc, e.hide]), O = N(function(S) {
      var P;
      (P = f.current) === null || P === void 0 || P.call(f, S), v(S);
    }, [v]), T = N(function(S) {
      return S = g(S), e.modal && !m && (S = /* @__PURE__ */ Le(Ct, null, S)), u && (S = u(S)), // Prevents Menu > Dialog > Menu to behave as a sub menu
      /* @__PURE__ */ Le(at.Provider, {
        value: null
      }, S);
    }, [g, e.modal, m, u]);
    return M({
      ref: qe(l, a),
      role: "dialog",
      tabIndex: s ?? -1,
      "aria-modal": b,
      "data-dialog": !0,
      onKeyDown: E,
      onBlur: O,
      wrapElement: T
    }, i);
  }
});
he({
  as: "div",
  useHook: Li,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Vt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/dialog"), kt(e, r, a);
  }
});
var Ld = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"], Hi = Ld, Hd = Hi, $d = Hd, $i = pe({
  name: "Popover",
  compose: Li,
  keys: Hi,
  useOptions: function(e) {
    var r = e.modal, a = r === void 0 ? !1 : r, n = te(e, ["modal"]);
    return M({
      modal: a
    }, n);
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.style, o = te(r, ["ref", "style"]);
    return M({
      ref: qe(e.unstable_popoverRef, a),
      style: M(M({}, e.unstable_popoverStyles), n)
    }, o);
  }
});
he({
  as: "div",
  useHook: $i,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Vt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/popover"), kt(e, r, a);
  }
});
var zi = pe({
  name: "Disclosure",
  compose: si,
  keys: ki,
  useProps: function(e, r) {
    var a = r.onClick, n = r["aria-controls"], o = te(r, ["onClick", "aria-controls"]), u = re(a), s = n ? n + " " + e.baseId : e.baseId, i = N(function(l) {
      var d, m;
      (d = u.current) === null || d === void 0 || d.call(u, l), !l.defaultPrevented && ((m = e.toggle) === null || m === void 0 || m.call(e));
    }, [e.toggle]);
    return M({
      "aria-expanded": !!e.visible,
      "aria-controls": s,
      onClick: i
    }, o);
  }
});
he({
  as: "button",
  memo: !0,
  useHook: zi
});
var Yi = pe({
  name: "DialogDisclosure",
  compose: zi,
  keys: Md,
  useProps: function(e, r) {
    var a = r.ref, n = r.onClick, o = te(r, ["ref", "onClick"]), u = ee(null), s = re(n), i = le(!1), l = i[0], d = i[1], m = e.unstable_disclosureRef;
    ot(function() {
      var c = u.current;
      process.env.NODE_ENV !== "production" && De(!c, "Can't determine whether the element is the current disclosure because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog"), m && !m.current && (m.current = c);
      var f = !(m != null && m.current) || m.current === c;
      d(!!e.visible && f);
    }, [e.visible, m]);
    var p = N(function(c) {
      var f;
      (f = s.current) === null || f === void 0 || f.call(s, c), !c.defaultPrevented && m && (m.current = c.currentTarget);
    }, [m]);
    return M({
      ref: qe(u, a),
      "aria-haspopup": "dialog",
      "aria-expanded": l,
      onClick: p
    }, o);
  }
});
he({
  as: "button",
  memo: !0,
  useHook: Yi
});
var zd = ["baseId", "unstable_idCountRef", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "unstable_values", "setBaseId", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget", "unstable_setValue"], Yd = [].concat(zd, ["visible", "animated", "animating", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"]), Bi = Yd, Bd = Bi, qi = Bd, Ui = qi, qd = Ui, Ud = qd, Ki = Ud, Kd = Ki;
function Xd(t, e, r) {
  var a = e.items, n = a === void 0 ? [] : a, o = e.move;
  r === void 0 && (r = 500);
  var u = le(""), s = u[0], i = u[1];
  ie(function() {
    if (s) {
      var l = setTimeout(function() {
        return i("");
      }, r), d = n.find(function(m) {
        return !!(m.ref.current && m.ref.current.textContent && m.ref.current.textContent.toLowerCase().startsWith(s));
      });
      return d && o(d.id), function() {
        return clearTimeout(l);
      };
    }
  }, [s, n, o, r]), ie(function() {
    var l = t.current;
    if (l) {
      var d = function(p) {
        var c;
        if (!(p.key.length > 1) && !p.shiftKey && !p.metaKey && !p.ctrlKey && !p.altKey) {
          var f = p.target, v = (c = f.getAttribute) === null || c === void 0 ? void 0 : c.call(f, "role"), h = f === l, y = v && v.indexOf("menuitem") !== -1 && ai(f, "[role=menu],[role=menubar]") === l;
          !h && !y || /^[a-z0-9_-]$/i.test(p.key) && (p.stopPropagation(), p.preventDefault(), i(function(w) {
            return "" + w + p.key;
          }));
        }
      };
      return l.addEventListener("keydown", d), function() {
        return l.removeEventListener("keydown", d);
      };
    }
  }, [t, i]);
}
var Xi = pe({
  name: "MenuBar",
  compose: hi,
  keys: qi,
  useProps: function(e, r) {
    var a = r.ref, n = r.wrapElement, o = r.role, u = o === void 0 ? "menubar" : o, s = te(r, ["ref", "wrapElement", "role"]), i = ee(null), l = ld(i, u, e);
    Xd(i, e);
    var d = N(function(m) {
      return m = l(m), n ? n(m) : m;
    }, [l, n]);
    return M({
      ref: qe(i, a),
      role: u,
      "aria-orientation": e.orientation,
      wrapElement: d
    }, s);
  }
});
he({
  as: "div",
  useHook: Xi,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Vt(!r["aria-label"] && !r["aria-labelledby"] && r.role !== "menubar", "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/menu"), kt(e, r, a);
  }
});
function Vd(t) {
  return Fe(function() {
    var e;
    return t == null || (e = t.split("-")) === null || e === void 0 ? void 0 : e[0];
  }, [t]);
}
var Qd = pe({
  name: "Menu",
  compose: [Xi, $i],
  keys: Bi,
  useOptions: function(e) {
    var r = Ce(at), a = (r == null ? void 0 : r.role) === "menubar";
    return M(M({
      unstable_autoFocusOnHide: !a,
      modal: !1
    }, e), {}, {
      // will be handled by MenuButton
      unstable_autoFocusOnShow: !1,
      // will be handled differently from usePopover/useDialog
      hideOnEsc: !1
    });
  },
  useProps: function(e, r) {
    for (var a = r.onKeyDown, n = te(r, ["onKeyDown"]), o = re(a), u = Ce(at), s = !!u, i = u; i && i.role !== "menubar"; )
      i = i.parent;
    var l = i || {}, d = l.next, m = l.previous, p = l.orientation, c = p === "horizontal", f = Vd(e.placement), v = N(function(h) {
      var y;
      if ((y = o.current) === null || y === void 0 || y.call(o, h), !h.defaultPrevented) {
        if (h.key === "Escape") {
          var w;
          s || h.stopPropagation(), (w = e.hide) === null || w === void 0 || w.call(e);
        } else if (s && !Sn(h)) {
          var g = c && f !== "left" ? d : f === "left" && e.hide, b = c && f !== "right" ? m : f === "right" && e.hide, E = {
            ArrowRight: g,
            ArrowLeft: b
          }, O = E[h.key];
          O && (h.preventDefault(), s && h.stopPropagation(), O());
        }
      }
    }, [s, c, d, m, f, e.hide]);
    return M({
      role: "menu",
      onKeyDown: v
    }, n);
  }
}), Gd = he({
  as: "div",
  useHook: Qd,
  useCreateElement: function(e, r, a) {
    return process.env.NODE_ENV !== "production" && Vt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/menu"), kt(e, r, a);
  }
});
function Jd(t) {
  t === void 0 && (t = {});
  var e = pt(t), r = e.orientation, a = r === void 0 ? "horizontal" : r, n = e.unstable_values, o = n === void 0 ? {} : n, u = te(e, ["orientation", "unstable_values"]), s = le(o), i = s[0], l = s[1], d = Vs(M(M({}, u), {}, {
    orientation: a
  }));
  return M(M({}, d), {}, {
    unstable_values: i,
    unstable_setValue: N(function(m, p) {
      l(function(c) {
        var f;
        return M(M({}, c), {}, (f = {}, f[m] = typeof p == "function" ? p(c) : p, f));
      });
    }, [])
  });
}
var Ur = pe({
  name: "PopoverDisclosure",
  compose: Yi,
  keys: $d,
  useProps: function(e, r) {
    var a = r.ref, n = te(r, ["ref"]);
    return M({
      ref: qe(e.unstable_referenceRef, a)
    }, n);
  }
});
he({
  as: "button",
  memo: !0,
  useHook: Ur
});
function Fn(t) {
  var e = t == null ? void 0 : t.find(function(r) {
    return r.current && !r.current.hidden;
  });
  return e == null ? void 0 : e.current;
}
var Zd = function() {
}, ec = pe({
  name: "MenuButton",
  compose: Ur,
  keys: Ui,
  propsAreEqual: function(e, r) {
    e.unstable_popoverStyles, e.unstable_arrowStyles, e.currentId, e.unstable_moves;
    var a = te(e, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);
    r.unstable_popoverStyles, r.unstable_arrowStyles, r.currentId, r.unstable_moves;
    var n = te(r, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);
    return Ur.unstable_propsAreEqual(a, n);
  },
  useProps: function(e, r) {
    var a = r.ref, n = r.onClick, o = r.onKeyDown, u = r.onFocus, s = r.onMouseEnter, i = r.onMouseDown, l = te(r, ["ref", "onClick", "onKeyDown", "onFocus", "onMouseEnter", "onMouseDown"]), d = Ce(at), m = ee(null), p = ee(!1), c = e.placement.split("-"), f = c[0], v = !!d, h = (d == null ? void 0 : d.role) === "menubar", y = e.disabled || l["aria-disabled"], w = re(n), g = re(o), b = re(u), E = re(s), O = re(i), T = N(function(x) {
      var D;
      if (x.key === "Escape") {
        var I;
        (I = e.hide) === null || I === void 0 || I.call(e);
      } else if (!y) {
        var C = e.first && function() {
          return setTimeout(e.first);
        }, A = e.last && function() {
          return setTimeout(e.last);
        }, V = {
          Enter: C,
          " ": C,
          ArrowUp: (f === "top" || f === "bottom") && A,
          ArrowRight: f === "right" && C,
          ArrowDown: (f === "bottom" || f === "top") && C,
          ArrowLeft: f === "left" && C
        }, J = V[x.key];
        if (J) {
          var Z;
          x.preventDefault(), x.stopPropagation(), (Z = e.show) === null || Z === void 0 || Z.call(e), J();
          return;
        }
      }
      (D = g.current) === null || D === void 0 || D.call(g, x);
    }, [y, e.hide, e.first, e.last, f, e.show]), S = N(function(x) {
      var D;
      if ((D = E.current) === null || D === void 0 || D.call(E, x), !x.defaultPrevented && d) {
        var I = x.currentTarget;
        h ? Fn(d.children) && I.focus() : setTimeout(function() {
          if (Qt(I)) {
            var C;
            (C = e.show) === null || C === void 0 || C.call(e);
          }
        }, 200);
      }
    }, [d, h, e.show]), P = N(function(x) {
      var D;
      p.current = !0, (D = O.current) === null || D === void 0 || D.call(O, x);
    }, []), _ = N(function(x) {
      var D;
      if ((D = b.current) === null || D === void 0 || D.call(b, x), !x.defaultPrevented && !y && h && !p.current) {
        var I;
        (I = e.show) === null || I === void 0 || I.call(e);
      }
    }, [h, y, e.show]), R = N(function(x) {
      var D;
      if ((D = w.current) === null || D === void 0 || D.call(w, x), !x.defaultPrevented) {
        if (v && !h) {
          var I;
          (I = e.show) === null || I === void 0 || I.call(e);
        } else {
          var C;
          if ((C = e.toggle) === null || C === void 0 || C.call(e), p.current && !h && !e.visible) {
            var A;
            (A = e.move) === null || A === void 0 || A.call(e, null);
          }
        }
        p.current = !1;
      }
    }, [v, h, e.show, e.toggle, e.visible, e.move]);
    return M({
      ref: qe(m, a),
      "aria-haspopup": "menu",
      onKeyDown: T,
      onMouseEnter: S,
      onMouseDown: P,
      onFocus: _,
      onClick: R
    }, l);
  },
  useComposeOptions: function(e) {
    return M(M({}, e), {}, {
      // Toggling is handled by MenuButton
      toggle: Zd
    });
  }
}), tc = he({
  as: "button",
  memo: !0,
  useHook: ec
});
function ir(t, e, r) {
  return Math.abs((t.x * (e.y - r.y) + e.x * (r.y - t.y) + r.x * (t.y - e.y)) / 2);
}
function rc(t, e, r, a) {
  var n = ir(e, r, a), o = ir(t, r, a), u = ir(e, t, a), s = ir(e, r, t);
  return n === o + u + s;
}
function ac(t, e) {
  var r = e.getBoundingClientRect(), a = r.top, n = r.right, o = r.bottom, u = r.left, s = u > t.clientX ? u : n;
  return [{
    x: s,
    y: a
  }, {
    x: s,
    y: o
  }];
}
function nc(t, e) {
  var r = re(e), a = ee(null), n = ee(null), o = ee(null), u = ee(0), s = ee(0), i = N(function(m) {
    if (t != null && t.children.length) {
      n.current = null, o.current = null;
      var p = Fn(t.children);
      if (p) {
        var c = ac(m, p);
        n.current = c[0], o.current = c[1];
      }
    }
  }, [t == null ? void 0 : t.children]), l = N(function(m) {
    var p = u.current !== m.clientX || s.current !== m.clientY;
    if (m.isTrusted && !p)
      return !0;
    var c = Math.abs(u.current - m.clientX);
    u.current = m.clientX, s.current = m.clientY;
    var f = function() {
      return n.current && o.current;
    };
    return m.type === "mouseleave" && !f() && i(m), f() ? c && a.current && rc({
      x: m.clientX,
      y: m.clientY
    }, a.current, n.current, o.current) : !1;
  }, [i]), d = N(function(m) {
    var p;
    (p = r.current) === null || p === void 0 || p.call(r, m), !m.defaultPrevented && (t == null ? void 0 : t.role) !== "menubar" && (a.current = {
      x: m.clientX,
      y: m.clientY
    }, i(m));
  }, [t == null ? void 0 : t.role, i]);
  return {
    onMouseEnter: d,
    isMouseInTransitToSubmenu: l
  };
}
function Ln(t) {
  var e = t.relatedTarget;
  return (e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE ? t.relatedTarget : t.toElement || null;
}
function oc(t) {
  var e = Ln(t);
  return e ? He(t.currentTarget, e) : !1;
}
function ic(t, e) {
  if (!(e != null && e.length))
    return !1;
  var r = Ln(t);
  if (!r)
    return !1;
  var a = Fn(e);
  return a && He(a, r);
}
function uc(t, e) {
  var r = Ln(t);
  return r ? e == null ? void 0 : e.some(function(a) {
    return a.ref.current && He(a.ref.current, r);
  }) : !1;
}
var sc = pe({
  name: "MenuItem",
  compose: Hr,
  keys: Ki,
  propsAreEqual: function(e, r) {
    e.unstable_popoverStyles, e.unstable_arrowStyles, e.visible;
    var a = te(e, ["unstable_popoverStyles", "unstable_arrowStyles", "visible"]);
    r.unstable_popoverStyles, r.unstable_arrowStyles, r.visible;
    var n = te(r, ["unstable_popoverStyles", "unstable_arrowStyles", "visible"]);
    return Hr.unstable_propsAreEqual(a, n);
  },
  useProps: function(e, r) {
    var a = r.onMouseEnter, n = r.onMouseMove, o = r.onMouseLeave, u = te(r, ["onMouseEnter", "onMouseMove", "onMouseLeave"]), s = Ce(at), i = re(n), l = re(o), d = nc(s, a), m = d.onMouseEnter, p = d.isMouseInTransitToSubmenu, c = N(function(v) {
      var h, y;
      (h = i.current) === null || h === void 0 || h.call(i, v), !v.defaultPrevented && (s == null ? void 0 : s.role) !== "menubar" && (p(v) || Qt(v.currentTarget) || (y = e.move) === null || y === void 0 || y.call(e, v.currentTarget.id));
    }, [e.move]), f = N(function(v) {
      var h;
      if ((h = l.current) === null || h === void 0 || h.call(l, v), !v.defaultPrevented && (s == null ? void 0 : s.role) !== "menubar" && !oc(v) && !ic(v, s == null ? void 0 : s.children) && !uc(v, e.items)) {
        var y;
        if (p(v))
          return;
        (y = e.move) === null || y === void 0 || y.call(e, null);
      }
    }, [s == null ? void 0 : s.role, s == null ? void 0 : s.children, e.items, e.move]);
    return M({
      role: "menuitem",
      onMouseEnter: m,
      onMouseMove: c,
      onMouseLeave: f
    }, u);
  }
}), lc = he({
  as: "button",
  memo: !0,
  useHook: sc
}), dc = ["orientation"], Vi = pe({
  name: "Separator",
  compose: Gt,
  keys: dc,
  useOptions: function(e) {
    var r = e.orientation, a = r === void 0 ? "horizontal" : r, n = te(e, ["orientation"]);
    return M({
      orientation: a
    }, n);
  },
  useProps: function(e, r) {
    return M({
      role: "separator",
      "aria-orientation": e.orientation
    }, r);
  }
});
he({
  as: "hr",
  memo: !0,
  useHook: Vi
});
var cc = pe({
  name: "MenuSeparator",
  compose: Vi,
  keys: Kd,
  useOptions: function(e) {
    var r = e.orientation, a = r === void 0 ? "vertical" : r, n = te(e, ["orientation"]);
    return M({
      orientation: a === "vertical" ? "horizontal" : "vertical"
    }, n);
  }
}), So = he({
  as: "hr",
  memo: !0,
  useHook: cc
});
function fc(t) {
  t === void 0 && (t = {});
  var e = Ce(at), r = pt(t), a = r.orientation, n = a === void 0 ? "vertical" : a, o = r.gutter, u = o === void 0 ? 0 : o, s = te(r, ["orientation", "gutter"]), i = s.placement || (e && e.orientation === "vertical" ? "right-start" : "bottom-start"), l = Jd(M(M({}, s), {}, {
    orientation: n
  })), d = id(M(M({}, s), {}, {
    placement: i,
    gutter: u
  }));
  return ie(function() {
    d.visible || l.reset();
  }, [d.visible, l.reset]), M(M({}, l), d);
}
function mc(t) {
  var e = t.children, r = t.unstable_system;
  return /* @__PURE__ */ Le(xn.Provider, {
    value: r
  }, e);
}
var vc = {};
function Qi(t) {
  var e = t.unstable_prefix, r = t.unstable_system, a = r === void 0 ? vc : r, n = t.children;
  return /* @__PURE__ */ Le(Rs, {
    prefix: e
  }, /* @__PURE__ */ Le(mc, {
    unstable_system: a
  }, n));
}
const Gi = ({ children: t, i18nInstance: e }) => /* @__PURE__ */ $(Fu, { i18n: e, children: t }), Hn = (t = "label") => {
  const e = Array.isArray(t) ? t : [t];
  return Lu(e);
}, hc = () => {
  const { t } = Hn("label");
  return /* @__PURE__ */ $("div", { "data-testid": "default-loading-fallback", children: t("CX_ERROR_LOADING_TEXT", { ns: "label" }) });
};
const pc = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, bc = (t, e, r) => {
  let a;
  const n = pc[t];
  return typeof n == "string" ? a = n : e === 1 ? a = n.one : a = n.other.replace("{{count}}", e.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : a + " ago" : a;
};
function Dr(t) {
  return (e = {}) => {
    const r = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[r] || t.formats[t.defaultWidth];
  };
}
const gc = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, yc = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, wc = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Mc = {
  date: Dr({
    formats: gc,
    defaultWidth: "full"
  }),
  time: Dr({
    formats: yc,
    defaultWidth: "full"
  }),
  dateTime: Dr({
    formats: wc,
    defaultWidth: "full"
  })
}, _c = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ec = (t, e, r, a) => _c[t];
function It(t) {
  return (e, r) => {
    const a = r != null && r.context ? String(r.context) : "standalone";
    let n;
    if (a === "formatting" && t.formattingValues) {
      const u = t.defaultFormattingWidth || t.defaultWidth, s = r != null && r.width ? String(r.width) : u;
      n = t.formattingValues[s] || t.formattingValues[u];
    } else {
      const u = t.defaultWidth, s = r != null && r.width ? String(r.width) : t.defaultWidth;
      n = t.values[s] || t.values[u];
    }
    const o = t.argumentCallback ? t.argumentCallback(e) : e;
    return n[o];
  };
}
const Pc = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Oc = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, xc = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Dc = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Sc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Cc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Tc = (t, e) => {
  const r = Number(t), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, kc = {
  ordinalNumber: Tc,
  era: It({
    values: Pc,
    defaultWidth: "wide"
  }),
  quarter: It({
    values: Oc,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: It({
    values: xc,
    defaultWidth: "wide"
  }),
  day: It({
    values: Dc,
    defaultWidth: "wide"
  }),
  dayPeriod: It({
    values: Sc,
    defaultWidth: "wide",
    formattingValues: Cc,
    defaultFormattingWidth: "wide"
  })
};
function Nt(t) {
  return (e, r = {}) => {
    const a = r.width, n = a && t.matchPatterns[a] || t.matchPatterns[t.defaultMatchWidth], o = e.match(n);
    if (!o)
      return null;
    const u = o[0], s = a && t.parsePatterns[a] || t.parsePatterns[t.defaultParseWidth], i = Array.isArray(s) ? jc(s, (m) => m.test(u)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Rc(s, (m) => m.test(u))
    );
    let l;
    l = t.valueCallback ? t.valueCallback(i) : i, l = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(l)
    ) : l;
    const d = e.slice(u.length);
    return { value: l, rest: d };
  };
}
function Rc(t, e) {
  for (const r in t)
    if (Object.prototype.hasOwnProperty.call(t, r) && e(t[r]))
      return r;
}
function jc(t, e) {
  for (let r = 0; r < t.length; r++)
    if (e(t[r]))
      return r;
}
function Ac(t) {
  return (e, r = {}) => {
    const a = e.match(t.matchPattern);
    if (!a)
      return null;
    const n = a[0], o = e.match(t.parsePattern);
    if (!o)
      return null;
    let u = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    u = r.valueCallback ? r.valueCallback(u) : u;
    const s = e.slice(n.length);
    return { value: u, rest: s };
  };
}
const Wc = /^(\d+)(th|st|nd|rd)?/i, Ic = /\d+/i, Nc = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Fc = {
  any: [/^b/i, /^(a|c)/i]
}, Lc = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Hc = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $c = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, zc = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Yc = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Bc = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, qc = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Uc = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Kc = {
  ordinalNumber: Ac({
    matchPattern: Wc,
    parsePattern: Ic,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Nt({
    matchPatterns: Nc,
    defaultMatchWidth: "wide",
    parsePatterns: Fc,
    defaultParseWidth: "any"
  }),
  quarter: Nt({
    matchPatterns: Lc,
    defaultMatchWidth: "wide",
    parsePatterns: Hc,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Nt({
    matchPatterns: $c,
    defaultMatchWidth: "wide",
    parsePatterns: zc,
    defaultParseWidth: "any"
  }),
  day: Nt({
    matchPatterns: Yc,
    defaultMatchWidth: "wide",
    parsePatterns: Bc,
    defaultParseWidth: "any"
  }),
  dayPeriod: Nt({
    matchPatterns: qc,
    defaultMatchWidth: "any",
    parsePatterns: Uc,
    defaultParseWidth: "any"
  })
}, Xc = {
  code: "en-US",
  formatDistance: bc,
  formatLong: Mc,
  formatRelative: Ec,
  localize: kc,
  match: Kc,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let Vc = {};
function er() {
  return Vc;
}
const Ji = 6048e5, Qc = 864e5;
function $e(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function Co(t) {
  const e = $e(t);
  return e.setHours(0, 0, 0, 0), e;
}
function To(t) {
  const e = $e(t), r = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return r.setUTCFullYear(e.getFullYear()), +t - +r;
}
function Gc(t, e) {
  const r = Co(t), a = Co(e), n = +r - To(r), o = +a - To(a);
  return Math.round((n - o) / Qc);
}
function mt(t, e) {
  return t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Jc(t) {
  const e = $e(t), r = mt(t, 0);
  return r.setFullYear(e.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function Zc(t) {
  const e = $e(t);
  return Gc(e, Jc(e)) + 1;
}
function Xt(t, e) {
  var s, i, l, d;
  const r = er(), a = (e == null ? void 0 : e.weekStartsOn) ?? ((i = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : i.weekStartsOn) ?? r.weekStartsOn ?? ((d = (l = r.locale) == null ? void 0 : l.options) == null ? void 0 : d.weekStartsOn) ?? 0, n = $e(t), o = n.getDay(), u = (o < a ? 7 : 0) + o - a;
  return n.setDate(n.getDate() - u), n.setHours(0, 0, 0, 0), n;
}
function vr(t) {
  return Xt(t, { weekStartsOn: 1 });
}
function Zi(t) {
  const e = $e(t), r = e.getFullYear(), a = mt(t, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const n = vr(a), o = mt(t, 0);
  o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
  const u = vr(o);
  return e.getTime() >= n.getTime() ? r + 1 : e.getTime() >= u.getTime() ? r : r - 1;
}
function ef(t) {
  const e = Zi(t), r = mt(t, 0);
  return r.setFullYear(e, 0, 4), r.setHours(0, 0, 0, 0), vr(r);
}
function tf(t) {
  const e = $e(t), r = +vr(e) - +ef(e);
  return Math.round(r / Ji) + 1;
}
function eu(t, e) {
  var d, m, p, c;
  const r = $e(t), a = r.getFullYear(), n = er(), o = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((m = (d = e == null ? void 0 : e.locale) == null ? void 0 : d.options) == null ? void 0 : m.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((c = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, u = mt(t, 0);
  u.setFullYear(a + 1, 0, o), u.setHours(0, 0, 0, 0);
  const s = Xt(u, e), i = mt(t, 0);
  i.setFullYear(a, 0, o), i.setHours(0, 0, 0, 0);
  const l = Xt(i, e);
  return r.getTime() >= s.getTime() ? a + 1 : r.getTime() >= l.getTime() ? a : a - 1;
}
function rf(t, e) {
  var s, i, l, d;
  const r = er(), a = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((i = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : i.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((d = (l = r.locale) == null ? void 0 : l.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, n = eu(t, e), o = mt(t, 0);
  return o.setFullYear(n, 0, a), o.setHours(0, 0, 0, 0), Xt(o, e);
}
function af(t, e) {
  const r = $e(t), a = +Xt(r, e) - +rf(r, e);
  return Math.round(a / Ji) + 1;
}
function ue(t, e) {
  const r = t < 0 ? "-" : "", a = Math.abs(t).toString().padStart(e, "0");
  return r + a;
}
const Ze = {
  // Year
  y(t, e) {
    const r = t.getFullYear(), a = r > 0 ? r : 1 - r;
    return ue(e === "yy" ? a % 100 : a, e.length);
  },
  // Month
  M(t, e) {
    const r = t.getMonth();
    return e === "M" ? String(r + 1) : ue(r + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return ue(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return ue(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return ue(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return ue(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return ue(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const r = e.length, a = t.getMilliseconds(), n = Math.trunc(
      a * Math.pow(10, r - 3)
    );
    return ue(n, e.length);
  }
}, wt = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ko = {
  // Era
  G: function(t, e, r) {
    const a = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(a, { width: "abbreviated" });
      case "GGGGG":
        return r.era(a, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, r) {
    if (e === "yo") {
      const a = t.getFullYear(), n = a > 0 ? a : 1 - a;
      return r.ordinalNumber(n, { unit: "year" });
    }
    return Ze.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, r, a) {
    const n = eu(t, a), o = n > 0 ? n : 1 - n;
    if (e === "YY") {
      const u = o % 100;
      return ue(u, 2);
    }
    return e === "Yo" ? r.ordinalNumber(o, { unit: "year" }) : ue(o, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const r = Zi(t);
    return ue(r, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const r = t.getFullYear();
    return ue(r, e.length);
  },
  // Quarter
  Q: function(t, e, r) {
    const a = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(a);
      case "QQ":
        return ue(a, 2);
      case "Qo":
        return r.ordinalNumber(a, { unit: "quarter" });
      case "QQQ":
        return r.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, r) {
    const a = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(a);
      case "qq":
        return ue(a, 2);
      case "qo":
        return r.ordinalNumber(a, { unit: "quarter" });
      case "qqq":
        return r.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, r) {
    const a = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Ze.M(t, e);
      case "Mo":
        return r.ordinalNumber(a + 1, { unit: "month" });
      case "MMM":
        return r.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, r) {
    const a = t.getMonth();
    switch (e) {
      case "L":
        return String(a + 1);
      case "LL":
        return ue(a + 1, 2);
      case "Lo":
        return r.ordinalNumber(a + 1, { unit: "month" });
      case "LLL":
        return r.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, r, a) {
    const n = af(t, a);
    return e === "wo" ? r.ordinalNumber(n, { unit: "week" }) : ue(n, e.length);
  },
  // ISO week of year
  I: function(t, e, r) {
    const a = tf(t);
    return e === "Io" ? r.ordinalNumber(a, { unit: "week" }) : ue(a, e.length);
  },
  // Day of the month
  d: function(t, e, r) {
    return e === "do" ? r.ordinalNumber(t.getDate(), { unit: "date" }) : Ze.d(t, e);
  },
  // Day of year
  D: function(t, e, r) {
    const a = Zc(t);
    return e === "Do" ? r.ordinalNumber(a, { unit: "dayOfYear" }) : ue(a, e.length);
  },
  // Day of week
  E: function(t, e, r) {
    const a = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, r, a) {
    const n = t.getDay(), o = (n - a.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(o);
      case "ee":
        return ue(o, 2);
      case "eo":
        return r.ordinalNumber(o, { unit: "day" });
      case "eee":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, r, a) {
    const n = t.getDay(), o = (n - a.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(o);
      case "cc":
        return ue(o, e.length);
      case "co":
        return r.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return r.day(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(n, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, r) {
    const a = t.getDay(), n = a === 0 ? 7 : a;
    switch (e) {
      case "i":
        return String(n);
      case "ii":
        return ue(n, e.length);
      case "io":
        return r.ordinalNumber(n, { unit: "day" });
      case "iii":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, r) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, r) {
    const a = t.getHours();
    let n;
    switch (a === 12 ? n = wt.noon : a === 0 ? n = wt.midnight : n = a / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, r) {
    const a = t.getHours();
    let n;
    switch (a >= 17 ? n = wt.evening : a >= 12 ? n = wt.afternoon : a >= 4 ? n = wt.morning : n = wt.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, r) {
    if (e === "ho") {
      let a = t.getHours() % 12;
      return a === 0 && (a = 12), r.ordinalNumber(a, { unit: "hour" });
    }
    return Ze.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, r) {
    return e === "Ho" ? r.ordinalNumber(t.getHours(), { unit: "hour" }) : Ze.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, r) {
    const a = t.getHours() % 12;
    return e === "Ko" ? r.ordinalNumber(a, { unit: "hour" }) : ue(a, e.length);
  },
  // Hour [1-24]
  k: function(t, e, r) {
    let a = t.getHours();
    return a === 0 && (a = 24), e === "ko" ? r.ordinalNumber(a, { unit: "hour" }) : ue(a, e.length);
  },
  // Minute
  m: function(t, e, r) {
    return e === "mo" ? r.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Ze.m(t, e);
  },
  // Second
  s: function(t, e, r) {
    return e === "so" ? r.ordinalNumber(t.getSeconds(), { unit: "second" }) : Ze.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Ze.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, r) {
    const a = t.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (e) {
      case "X":
        return jo(a);
      case "XXXX":
      case "XX":
        return ut(a);
      case "XXXXX":
      case "XXX":
      default:
        return ut(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, r) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return jo(a);
      case "xxxx":
      case "xx":
        return ut(a);
      case "xxxxx":
      case "xxx":
      default:
        return ut(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, r) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ro(a, ":");
      case "OOOO":
      default:
        return "GMT" + ut(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, r) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ro(a, ":");
      case "zzzz":
      default:
        return "GMT" + ut(a, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, r) {
    const a = Math.trunc(t.getTime() / 1e3);
    return ue(a, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, r) {
    const a = t.getTime();
    return ue(a, e.length);
  }
};
function Ro(t, e = "") {
  const r = t > 0 ? "-" : "+", a = Math.abs(t), n = Math.trunc(a / 60), o = a % 60;
  return o === 0 ? r + String(n) : r + String(n) + e + ue(o, 2);
}
function jo(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + ue(Math.abs(t) / 60, 2) : ut(t, e);
}
function ut(t, e = "") {
  const r = t > 0 ? "-" : "+", a = Math.abs(t), n = ue(Math.trunc(a / 60), 2), o = ue(a % 60, 2);
  return r + n + e + o;
}
const Ao = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, tu = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, nf = (t, e) => {
  const r = t.match(/(P+)(p+)?/) || [], a = r[1], n = r[2];
  if (!n)
    return Ao(t, e);
  let o;
  switch (a) {
    case "P":
      o = e.dateTime({ width: "short" });
      break;
    case "PP":
      o = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = e.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", Ao(a, e)).replace("{{time}}", tu(n, e));
}, of = {
  p: tu,
  P: nf
}, uf = /^D+$/, sf = /^Y+$/, lf = ["D", "DD", "YY", "YYYY"];
function df(t) {
  return uf.test(t);
}
function cf(t) {
  return sf.test(t);
}
function ff(t, e, r) {
  const a = mf(t, e, r);
  if (console.warn(a), lf.includes(t))
    throw new RangeError(a);
}
function mf(t, e, r) {
  const a = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${a} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function vf(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function hf(t) {
  if (!vf(t) && typeof t != "number")
    return !1;
  const e = $e(t);
  return !isNaN(Number(e));
}
const pf = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, bf = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, gf = /^'([^]*?)'?$/, yf = /''/g, wf = /[a-zA-Z]/;
function Mf(t, e, r) {
  var d, m, p, c, f, v, h, y;
  const a = er(), n = (r == null ? void 0 : r.locale) ?? a.locale ?? Xc, o = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((m = (d = r == null ? void 0 : r.locale) == null ? void 0 : d.options) == null ? void 0 : m.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((c = (p = a.locale) == null ? void 0 : p.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, u = (r == null ? void 0 : r.weekStartsOn) ?? ((v = (f = r == null ? void 0 : r.locale) == null ? void 0 : f.options) == null ? void 0 : v.weekStartsOn) ?? a.weekStartsOn ?? ((y = (h = a.locale) == null ? void 0 : h.options) == null ? void 0 : y.weekStartsOn) ?? 0, s = $e(t);
  if (!hf(s))
    throw new RangeError("Invalid time value");
  let i = e.match(bf).map((w) => {
    const g = w[0];
    if (g === "p" || g === "P") {
      const b = of[g];
      return b(w, n.formatLong);
    }
    return w;
  }).join("").match(pf).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const g = w[0];
    if (g === "'")
      return { isToken: !1, value: _f(w) };
    if (ko[g])
      return { isToken: !0, value: w };
    if (g.match(wf))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + g + "`"
      );
    return { isToken: !1, value: w };
  });
  n.localize.preprocessor && (i = n.localize.preprocessor(s, i));
  const l = {
    firstWeekContainsDate: o,
    weekStartsOn: u,
    locale: n
  };
  return i.map((w) => {
    if (!w.isToken)
      return w.value;
    const g = w.value;
    (!(r != null && r.useAdditionalWeekYearTokens) && cf(g) || !(r != null && r.useAdditionalDayOfYearTokens) && df(g)) && ff(g, e, String(t));
    const b = ko[g[0]];
    return b(s, g, n.localize, l);
  }).join("");
}
function _f(t) {
  const e = t.match(gf);
  return e ? e[1].replace(yf, "'") : t;
}
function Ef() {
  return Object.assign({}, er());
}
function Wo(t, e, r) {
  const a = Ef(), n = xf(t, r.timeZone, r.locale ?? a.locale);
  return "formatToParts" in n ? Pf(n, e) : Of(n, e);
}
function Pf(t, e) {
  const r = t.formatToParts(e);
  for (let a = r.length - 1; a >= 0; --a)
    if (r[a].type === "timeZoneName")
      return r[a].value;
}
function Of(t, e) {
  const r = t.format(e).replace(/\u200E/g, ""), a = / [\w-+ ]+$/.exec(r);
  return a ? a[0].substr(1) : "";
}
function xf(t, e, r) {
  return new Intl.DateTimeFormat(r ? [r.code, "en-US"] : void 0, {
    timeZone: e,
    timeZoneName: t
  });
}
function Df(t, e) {
  const r = Rf(e);
  return "formatToParts" in r ? Cf(r, t) : Tf(r, t);
}
const Sf = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Cf(t, e) {
  try {
    const r = t.formatToParts(e), a = [];
    for (let n = 0; n < r.length; n++) {
      const o = Sf[r[n].type];
      o !== void 0 && (a[o] = parseInt(r[n].value, 10));
    }
    return a;
  } catch (r) {
    if (r instanceof RangeError)
      return [NaN];
    throw r;
  }
}
function Tf(t, e) {
  const r = t.format(e), a = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [
    parseInt(a[3], 10),
    parseInt(a[1], 10),
    parseInt(a[2], 10),
    parseInt(a[4], 10),
    parseInt(a[5], 10),
    parseInt(a[6], 10)
  ];
}
const Sr = {}, Io = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), kf = Io === "06/25/2014, 00:00:00" || Io === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function Rf(t) {
  return Sr[t] || (Sr[t] = kf ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), Sr[t];
}
function ru(t, e, r, a, n, o, u) {
  const s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(t, e, r), s.setUTCHours(a, n, o, u), s;
}
const No = 36e5, jf = 6e4, Cr = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $n(t, e, r) {
  if (!t)
    return 0;
  let a = Cr.timezoneZ.exec(t);
  if (a)
    return 0;
  let n, o;
  if (a = Cr.timezoneHH.exec(t), a)
    return n = parseInt(a[1], 10), Fo(n) ? -(n * No) : NaN;
  if (a = Cr.timezoneHHMM.exec(t), a) {
    n = parseInt(a[2], 10);
    const u = parseInt(a[3], 10);
    return Fo(n, u) ? (o = Math.abs(n) * No + u * jf, a[1] === "+" ? -o : o) : NaN;
  }
  if (If(t)) {
    e = new Date(e || Date.now());
    const u = r ? e : Af(e), s = Kr(u, t);
    return -(r ? s : Wf(e, s, t));
  }
  return NaN;
}
function Af(t) {
  return ru(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds());
}
function Kr(t, e) {
  const r = Df(t, e), a = ru(r[0], r[1] - 1, r[2], r[3] % 24, r[4], r[5], 0).getTime();
  let n = t.getTime();
  const o = n % 1e3;
  return n -= o >= 0 ? o : 1e3 + o, a - n;
}
function Wf(t, e, r) {
  let n = t.getTime() - e;
  const o = Kr(new Date(n), r);
  if (e === o)
    return e;
  n -= o - e;
  const u = Kr(new Date(n), r);
  return o === u ? o : Math.max(o, u);
}
function Fo(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
const Lo = {};
function If(t) {
  if (Lo[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), Lo[t] = !0, !0;
  } catch {
    return !1;
  }
}
const Nf = 60 * 1e3, Ff = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, r) {
    const a = Tr(r.timeZone, t);
    if (a === 0)
      return "Z";
    switch (e) {
      case "X":
        return Ho(a);
      case "XXXX":
      case "XX":
        return Et(a);
      case "XXXXX":
      case "XXX":
      default:
        return Et(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, r) {
    const a = Tr(r.timeZone, t);
    switch (e) {
      case "x":
        return Ho(a);
      case "xxxx":
      case "xx":
        return Et(a);
      case "xxxxx":
      case "xxx":
      default:
        return Et(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, r) {
    const a = Tr(r.timeZone, t);
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Lf(a, ":");
      case "OOOO":
      default:
        return "GMT" + Et(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, r) {
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return Wo("short", t, r);
      case "zzzz":
      default:
        return Wo("long", t, r);
    }
  }
};
function Tr(t, e) {
  const r = t ? $n(t, e, !0) / Nf : (e == null ? void 0 : e.getTimezoneOffset()) ?? 0;
  if (Number.isNaN(r))
    throw new RangeError("Invalid time zone specified: " + t);
  return r;
}
function hr(t, e) {
  const r = t < 0 ? "-" : "";
  let a = Math.abs(t).toString();
  for (; a.length < e; )
    a = "0" + a;
  return r + a;
}
function Et(t, e = "") {
  const r = t > 0 ? "-" : "+", a = Math.abs(t), n = hr(Math.floor(a / 60), 2), o = hr(Math.floor(a % 60), 2);
  return r + n + e + o;
}
function Ho(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + hr(Math.abs(t) / 60, 2) : Et(t, e);
}
function Lf(t, e = "") {
  const r = t > 0 ? "-" : "+", a = Math.abs(t), n = Math.floor(a / 60), o = a % 60;
  return o === 0 ? r + String(n) : r + String(n) + e + hr(o, 2);
}
function $o(t) {
  const e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), +t - +e;
}
const Hf = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, kr = 36e5, zo = 6e4, $f = 2, Pe = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: Hf
};
function au(t, e = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  const r = e.additionalDigits == null ? $f : Number(e.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (Object.prototype.toString.call(t) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const a = zf(t), { year: n, restDateString: o } = Yf(a.date, r), u = Bf(o, n);
  if (u === null || isNaN(u.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (u) {
    const s = u.getTime();
    let i = 0, l;
    if (a.time && (i = qf(a.time), i === null || isNaN(i)))
      return /* @__PURE__ */ new Date(NaN);
    if (a.timeZone || e.timeZone) {
      if (l = $n(a.timeZone || e.timeZone, new Date(s + i)), isNaN(l))
        return /* @__PURE__ */ new Date(NaN);
    } else
      l = $o(new Date(s + i)), l = $o(new Date(s + i + l));
    return new Date(s + i + l);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function zf(t) {
  const e = {};
  let r = Pe.dateTimePattern.exec(t), a;
  if (r ? (e.date = r[1], a = r[3]) : (r = Pe.datePattern.exec(t), r ? (e.date = r[1], a = r[2]) : (e.date = null, a = t)), a) {
    const n = Pe.timeZone.exec(a);
    n ? (e.time = a.replace(n[1], ""), e.timeZone = n[1].trim()) : e.time = a;
  }
  return e;
}
function Yf(t, e) {
  if (t) {
    const r = Pe.YYY[e], a = Pe.YYYYY[e];
    let n = Pe.YYYY.exec(t) || a.exec(t);
    if (n) {
      const o = n[1];
      return {
        year: parseInt(o, 10),
        restDateString: t.slice(o.length)
      };
    }
    if (n = Pe.YY.exec(t) || r.exec(t), n) {
      const o = n[1];
      return {
        year: parseInt(o, 10) * 100,
        restDateString: t.slice(o.length)
      };
    }
  }
  return {
    year: null
  };
}
function Bf(t, e) {
  if (e === null)
    return null;
  let r, a, n;
  if (!t || !t.length)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(e), r;
  let o = Pe.MM.exec(t);
  if (o)
    return r = /* @__PURE__ */ new Date(0), a = parseInt(o[1], 10) - 1, Bo(e, a) ? (r.setUTCFullYear(e, a), r) : /* @__PURE__ */ new Date(NaN);
  if (o = Pe.DDD.exec(t), o) {
    r = /* @__PURE__ */ new Date(0);
    const u = parseInt(o[1], 10);
    return Xf(e, u) ? (r.setUTCFullYear(e, 0, u), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = Pe.MMDD.exec(t), o) {
    r = /* @__PURE__ */ new Date(0), a = parseInt(o[1], 10) - 1;
    const u = parseInt(o[2], 10);
    return Bo(e, a, u) ? (r.setUTCFullYear(e, a, u), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = Pe.Www.exec(t), o)
    return n = parseInt(o[1], 10) - 1, qo(n) ? Yo(e, n) : /* @__PURE__ */ new Date(NaN);
  if (o = Pe.WwwD.exec(t), o) {
    n = parseInt(o[1], 10) - 1;
    const u = parseInt(o[2], 10) - 1;
    return qo(n, u) ? Yo(e, n, u) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function qf(t) {
  let e, r, a = Pe.HH.exec(t);
  if (a)
    return e = parseFloat(a[1].replace(",", ".")), Rr(e) ? e % 24 * kr : NaN;
  if (a = Pe.HHMM.exec(t), a)
    return e = parseInt(a[1], 10), r = parseFloat(a[2].replace(",", ".")), Rr(e, r) ? e % 24 * kr + r * zo : NaN;
  if (a = Pe.HHMMSS.exec(t), a) {
    e = parseInt(a[1], 10), r = parseInt(a[2], 10);
    const n = parseFloat(a[3].replace(",", "."));
    return Rr(e, r, n) ? e % 24 * kr + r * zo + n * 1e3 : NaN;
  }
  return null;
}
function Yo(t, e, r) {
  e = e || 0, r = r || 0;
  const a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4);
  const n = a.getUTCDay() || 7, o = e * 7 + r + 1 - n;
  return a.setUTCDate(a.getUTCDate() + o), a;
}
const Uf = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Kf = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function nu(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function Bo(t, e, r) {
  if (e < 0 || e > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    const a = nu(t);
    if (a && r > Kf[e] || !a && r > Uf[e])
      return !1;
  }
  return !0;
}
function Xf(t, e) {
  if (e < 1)
    return !1;
  const r = nu(t);
  return !(r && e > 366 || !r && e > 365);
}
function qo(t, e) {
  return !(t < 0 || t > 52 || e != null && (e < 0 || e > 6));
}
function Rr(t, e, r) {
  return !(t < 0 || t >= 25 || e != null && (e < 0 || e >= 60) || r != null && (r < 0 || r >= 60));
}
const Vf = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function Qf(t, e, r = {}) {
  e = String(e);
  const a = e.match(Vf);
  if (a) {
    const n = au(r.originalDate || t, r);
    e = a.reduce(function(o, u) {
      if (u[0] === "'")
        return o;
      const s = o.indexOf(u), i = o[s - 1] === "'", l = o.replace(u, "'" + Ff[u[0]](n, u, r) + "'");
      return i ? l.substring(0, s - 1) + l.substring(s + 1) : l;
    }, e);
  }
  return Mf(t, e, r);
}
function Gf(t, e, r) {
  t = au(t, r);
  const a = $n(e, t, !0), n = new Date(t.getTime() - a), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate()), o.setHours(n.getUTCHours(), n.getUTCMinutes(), n.getUTCSeconds(), n.getUTCMilliseconds()), o;
}
function Uo(t, e, r, a) {
  return a = {
    ...a,
    timeZone: e,
    originalDate: t
  }, Qf(Gf(t, e, { timeZone: a.timeZone }), r, a);
}
var Xr = { exports: {} }, ou = { exports: {} };
(function(t) {
  function e(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(ou);
var L = ou.exports, Vr = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "mindre end ét sekund",
      other: "mindre end {{count}} sekunder"
    },
    xSeconds: {
      one: "1 sekund",
      other: "{{count}} sekunder"
    },
    halfAMinute: "ét halvt minut",
    lessThanXMinutes: {
      one: "mindre end ét minut",
      other: "mindre end {{count}} minutter"
    },
    xMinutes: {
      one: "1 minut",
      other: "{{count}} minutter"
    },
    aboutXHours: {
      one: "cirka 1 time",
      other: "cirka {{count}} timer"
    },
    xHours: {
      one: "1 time",
      other: "{{count}} timer"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dage"
    },
    aboutXWeeks: {
      one: "cirka 1 uge",
      other: "cirka {{count}} uger"
    },
    xWeeks: {
      one: "1 uge",
      other: "{{count}} uger"
    },
    aboutXMonths: {
      one: "cirka 1 måned",
      other: "cirka {{count}} måneder"
    },
    xMonths: {
      one: "1 måned",
      other: "{{count}} måneder"
    },
    aboutXYears: {
      one: "cirka 1 år",
      other: "cirka {{count}} år"
    },
    xYears: {
      one: "1 år",
      other: "{{count}} år"
    },
    overXYears: {
      one: "over 1 år",
      other: "over {{count}} år"
    },
    almostXYears: {
      one: "næsten 1 år",
      other: "næsten {{count}} år"
    }
  }, a = function(u, s, i) {
    var l, d = r[u];
    return typeof d == "string" ? l = d : s === 1 ? l = d.one : l = d.other.replace("{{count}}", String(s)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "om " + l : l + " siden" : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Vr, Vr.exports);
var Jf = Vr.exports, Qr = { exports: {} }, Gr = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    return function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = n.width ? String(n.width) : a.defaultWidth, u = a.formats[o] || a.formats[a.defaultWidth];
      return u;
    };
  }
  t.exports = e.default;
})(Gr, Gr.exports);
var _e = Gr.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE 'den' d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, u = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(Qr, Qr.exports);
var Zf = Qr.exports, Jr = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i går kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'på' eeee 'kl.' p",
    other: "P"
  }, a = function(u, s, i, l) {
    return r[u];
  }, n = a;
  e.default = n, t.exports = e.default;
})(Jr, Jr.exports);
var em = Jr.exports, Zr = { exports: {} }, ea = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    return function(n, o) {
      var u = o != null && o.context ? String(o.context) : "standalone", s;
      if (u === "formatting" && a.formattingValues) {
        var i = a.defaultFormattingWidth || a.defaultWidth, l = o != null && o.width ? String(o.width) : i;
        s = a.formattingValues[l] || a.formattingValues[i];
      } else {
        var d = a.defaultWidth, m = o != null && o.width ? String(o.width) : a.defaultWidth;
        s = a.values[m] || a.values[d];
      }
      var p = a.argumentCallback ? a.argumentCallback(n) : n;
      return s[p];
    };
  }
  t.exports = e.default;
})(ea, ea.exports);
var Ue = ea.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ue), n = {
    narrow: ["fvt", "vt"],
    abbreviated: ["f.v.t.", "v.t."],
    wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
    wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
  }, u = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
  }, s = {
    narrow: ["S", "M", "T", "O", "T", "F", "L"],
    short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
    abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
    wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
  }, i = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnat",
      noon: "middag",
      morning: "morgen",
      afternoon: "eftermiddag",
      evening: "aften",
      night: "nat"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnat",
      noon: "middag",
      morning: "om morgenen",
      afternoon: "om eftermiddagen",
      evening: "om aftenen",
      night: "om natten"
    }
  }, d = function(f, v) {
    var h = Number(f);
    return h + ".";
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(f) {
        return f - 1;
      }
    }),
    month: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = m;
  e.default = p, t.exports = e.default;
})(Zr, Zr.exports);
var tm = Zr.exports, ta = { exports: {} }, ra = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(o) {
    return function(u) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = s.width, l = i && o.matchPatterns[i] || o.matchPatterns[o.defaultMatchWidth], d = u.match(l);
      if (!d)
        return null;
      var m = d[0], p = i && o.parsePatterns[i] || o.parsePatterns[o.defaultParseWidth], c = Array.isArray(p) ? n(p, function(h) {
        return h.test(m);
      }) : a(p, function(h) {
        return h.test(m);
      }), f;
      f = o.valueCallback ? o.valueCallback(c) : c, f = s.valueCallback ? s.valueCallback(f) : f;
      var v = u.slice(m.length);
      return {
        value: f,
        rest: v
      };
    };
  }
  function a(o, u) {
    for (var s in o)
      if (o.hasOwnProperty(s) && u(o[s]))
        return s;
  }
  function n(o, u) {
    for (var s = 0; s < o.length; s++)
      if (u(o[s]))
        return s;
  }
  t.exports = e.default;
})(ra, ra.exports);
var Ke = ra.exports, aa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    return function(n) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = n.match(a.matchPattern);
      if (!u)
        return null;
      var s = u[0], i = n.match(a.parsePattern);
      if (!i)
        return null;
      var l = a.valueCallback ? a.valueCallback(i[0]) : i[0];
      l = o.valueCallback ? o.valueCallback(l) : l;
      var d = n.slice(s.length);
      return {
        value: l,
        rest: d
      };
    };
  }
  t.exports = e.default;
})(aa, aa.exports);
var Xe = aa.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = r(Xe), o = /^(\d+)(\.)?/i, u = /\d+/i, s = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
  }, i = {
    any: [/^f/i, /^(v|e)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
  }, f = {
    narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
    any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
  }, v = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
  }, h = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /midnat/i,
      noon: /middag/i,
      morning: /morgen/i,
      afternoon: /eftermiddag/i,
      evening: /aften/i,
      night: /nat/i
    }
  }, y = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: u,
      valueCallback: function(b) {
        return parseInt(b, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(b) {
        return b + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "any",
      parsePatterns: h,
      defaultParseWidth: "any"
    })
  }, w = y;
  e.default = w, t.exports = e.default;
})(ta, ta.exports);
var rm = ta.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Jf), n = r(Zf), o = r(em), u = r(tm), s = r(rm), i = {
    code: "da",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: u.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Xr, Xr.exports);
var am = Xr.exports;
const nm = /* @__PURE__ */ Me(am);
var na = { exports: {} }, oa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      standalone: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      },
      withPreposition: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      }
    },
    xSeconds: {
      standalone: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      },
      withPreposition: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      }
    },
    halfAMinute: {
      standalone: "halbe Minute",
      withPreposition: "halben Minute"
    },
    lessThanXMinutes: {
      standalone: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      },
      withPreposition: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      }
    },
    xMinutes: {
      standalone: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      },
      withPreposition: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      }
    },
    aboutXHours: {
      standalone: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      },
      withPreposition: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      }
    },
    xHours: {
      standalone: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      },
      withPreposition: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      }
    },
    xDays: {
      standalone: {
        one: "1 Tag",
        other: "{{count}} Tage"
      },
      withPreposition: {
        one: "1 Tag",
        other: "{{count}} Tagen"
      }
    },
    aboutXWeeks: {
      standalone: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      },
      withPreposition: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      }
    },
    xWeeks: {
      standalone: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      },
      withPreposition: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      }
    },
    aboutXMonths: {
      standalone: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monate"
      },
      withPreposition: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monaten"
      }
    },
    xMonths: {
      standalone: {
        one: "1 Monat",
        other: "{{count}} Monate"
      },
      withPreposition: {
        one: "1 Monat",
        other: "{{count}} Monaten"
      }
    },
    aboutXYears: {
      standalone: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahre"
      },
      withPreposition: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahren"
      }
    },
    xYears: {
      standalone: {
        one: "1 Jahr",
        other: "{{count}} Jahre"
      },
      withPreposition: {
        one: "1 Jahr",
        other: "{{count}} Jahren"
      }
    },
    overXYears: {
      standalone: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahre"
      },
      withPreposition: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahren"
      }
    },
    almostXYears: {
      standalone: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahre"
      },
      withPreposition: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahren"
      }
    }
  }, a = function(u, s, i) {
    var l, d = i != null && i.addSuffix ? r[u].withPreposition : r[u].standalone;
    return typeof d == "string" ? l = d : s === 1 ? l = d.one : l = d.other.replace("{{count}}", String(s)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "in " + l : "vor " + l : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(oa, oa.exports);
var om = oa.exports, ia = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, do MMMM y",
    // Montag, 7. Januar 2018
    long: "do MMMM y",
    // 7. Januar 2018
    medium: "do MMM y",
    // 7. Jan. 2018
    short: "dd.MM.y"
    // 07.01.2018
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, u = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(ia, ia.exports);
var im = ia.exports, ua = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
  }, a = function(u, s, i, l) {
    return r[u];
  }, n = a;
  e.default = n, t.exports = e.default;
})(ua, ua.exports);
var um = ua.exports, sa = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ue), n = {
    narrow: ["v.Chr.", "n.Chr."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["vor Christus", "nach Christus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
  }, u = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
  }, s = {
    narrow: u.narrow,
    abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
    wide: u.wide
  }, i = {
    narrow: ["S", "M", "D", "M", "D", "F", "S"],
    short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
    wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
  }, l = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachm.",
      evening: "Abend",
      night: "Nacht"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    }
  }, d = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachm.",
      evening: "abends",
      night: "nachts"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    }
  }, m = function(v) {
    var h = Number(v);
    return h + ".";
  }, p = {
    ordinalNumber: m,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(v) {
        return v - 1;
      }
    }),
    month: (0, a.default)({
      values: u,
      formattingValues: s,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: l,
      defaultWidth: "wide",
      formattingValues: d,
      defaultFormattingWidth: "wide"
    })
  }, c = p;
  e.default = c, t.exports = e.default;
})(sa, sa.exports);
var sm = sa.exports, la = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = r(Xe), o = /^(\d+)(\.)?/i, u = /\d+/i, s = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
  }, i = {
    any: [/^v/i, /^n/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
  }, f = {
    any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
  }, v = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
  }, h = {
    any: {
      am: /^v/i,
      pm: /^n/i,
      midnight: /^Mitte/i,
      noon: /^Mitta/i,
      morning: /morgens/i,
      afternoon: /nachmittags/i,
      // will never be matched. Afternoon is matched by `pm`
      evening: /abends/i,
      night: /nachts/i
      // will never be matched. Night is matched by `pm`
    }
  }, y = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: u,
      valueCallback: function(b) {
        return parseInt(b);
      }
    }),
    era: (0, a.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(b) {
        return b + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "wide",
      parsePatterns: h,
      defaultParseWidth: "any"
    })
  }, w = y;
  e.default = w, t.exports = e.default;
})(la, la.exports);
var lm = la.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(om), n = r(im), o = r(um), u = r(sm), s = r(lm), i = {
    code: "de",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: u.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(na, na.exports);
var dm = na.exports;
const cm = /* @__PURE__ */ Me(dm);
var da = { exports: {} }, ca = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, a = function(u, s, i) {
    var l, d = r[u];
    return typeof d == "string" ? l = d : s === 1 ? l = d.one : l = d.other.replace("{{count}}", s.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "in " + l : l + " ago" : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(ca, ca.exports);
var At = ca.exports, fa = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, u = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(fa, fa.exports);
var fm = fa.exports, ma = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, a = function(u, s, i, l) {
    return r[u];
  }, n = a;
  e.default = n, t.exports = e.default;
})(ma, ma.exports);
var bt = ma.exports, va = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ue), n = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, u = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, s = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, i = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, d = function(f, v) {
    var h = Number(f), y = h % 100;
    if (y > 20 || y < 10)
      switch (y % 10) {
        case 1:
          return h + "st";
        case 2:
          return h + "nd";
        case 3:
          return h + "rd";
      }
    return h + "th";
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(f) {
        return f - 1;
      }
    }),
    month: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = m;
  e.default = p, t.exports = e.default;
})(va, va.exports);
var gt = va.exports, ha = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = r(Xe), o = /^(\d+)(th|st|nd|rd)?/i, u = /\d+/i, s = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, i = {
    any: [/^b/i, /^(a|c)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, f = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, v = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, h = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, y = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: u,
      valueCallback: function(b) {
        return parseInt(b, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(b) {
        return b + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "any",
      parsePatterns: h,
      defaultParseWidth: "any"
    })
  }, w = y;
  e.default = w, t.exports = e.default;
})(ha, ha.exports);
var yt = ha.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(At), n = r(fm), o = r(bt), u = r(gt), s = r(yt), i = {
    code: "en-AU",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: u.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(da, da.exports);
var mm = da.exports;
const vm = /* @__PURE__ */ Me(mm);
var pa = { exports: {} }, ba = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "a second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "a minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about an hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "an hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "a day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about a week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "a week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about a month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "a month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about a year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "a year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over a year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost a year",
      other: "almost {{count}} years"
    }
  }, a = function(u, s, i) {
    var l, d = r[u];
    return typeof d == "string" ? l = d : s === 1 ? l = d.one : l = d.other.replace("{{count}}", s.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "in " + l : l + " ago" : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(ba, ba.exports);
var hm = ba.exports, ga = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, MMMM do, yyyy",
    long: "MMMM do, yyyy",
    medium: "MMM d, yyyy",
    short: "yyyy-MM-dd"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, u = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(ga, ga.exports);
var pm = ga.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(bt), n = r(gt), o = r(yt), u = r(hm), s = r(pm), i = {
    code: "en-CA",
    formatDistance: u.default,
    formatLong: s.default,
    formatRelative: a.default,
    localize: n.default,
    match: o.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(pa, pa.exports);
var bm = pa.exports;
const gm = /* @__PURE__ */ Me(bm);
var ya = { exports: {} }, wa = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, u = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(wa, wa.exports);
var ym = wa.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(At), n = r(bt), o = r(gt), u = r(yt), s = r(ym), i = {
    code: "en-GB",
    formatDistance: a.default,
    formatLong: s.default,
    formatRelative: n.default,
    localize: o.default,
    match: u.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(ya, ya.exports);
var wm = ya.exports;
const Mm = /* @__PURE__ */ Me(wm);
var Ma = { exports: {} }, _a = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM, yyyy",
    medium: "d MMM, yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, u = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(_a, _a.exports);
var _m = _a.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(At), n = r(bt), o = r(gt), u = r(yt), s = r(_m), i = {
    code: "en-IN",
    formatDistance: a.default,
    formatLong: s.default,
    formatRelative: n.default,
    localize: o.default,
    match: u.default,
    options: {
      weekStartsOn: 1,
      // Monday is the first day of the week.
      firstWeekContainsDate: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Ma, Ma.exports);
var Em = Ma.exports;
const Pm = /* @__PURE__ */ Me(Em);
var Ea = { exports: {} }, Pa = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, u = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(Pa, Pa.exports);
var Om = Pa.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(At), n = r(bt), o = r(gt), u = r(yt), s = r(Om), i = {
    code: "en-NZ",
    formatDistance: a.default,
    formatLong: s.default,
    formatRelative: n.default,
    localize: o.default,
    match: u.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Ea, Ea.exports);
var xm = Ea.exports;
const Dm = /* @__PURE__ */ Me(xm);
var Oa = { exports: {} }, xa = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, u = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(xa, xa.exports);
var Sm = xa.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(At), n = r(Sm), o = r(bt), u = r(gt), s = r(yt), i = {
    code: "en-US",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: u.default,
    match: s.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Oa, Oa.exports);
var Cm = Oa.exports;
const Tm = /* @__PURE__ */ Me(Cm);
var Da = { exports: {} }, Sa = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "yyyy/MM/dd"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, u = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(Sa, Sa.exports);
var km = Sa.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(At), n = r(bt), o = r(gt), u = r(yt), s = r(km), i = {
    code: "en-ZA",
    formatDistance: a.default,
    formatLong: s.default,
    formatRelative: n.default,
    localize: o.default,
    match: u.default,
    options: {
      weekStartsOn: 0,
      // Sunday is the first day of the week.
      firstWeekContainsDate: 1
      // The week that contains Jan 1st is the first week of the year.
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Da, Da.exports);
var Rm = Da.exports;
const jm = /* @__PURE__ */ Me(Rm);
var Ca = { exports: {} }, Ta = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "menos de un segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
      one: "menos de un minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "alrededor de 1 hora",
      other: "alrededor de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 día",
      other: "{{count}} días"
    },
    aboutXWeeks: {
      one: "alrededor de 1 semana",
      other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "alrededor de 1 mes",
      other: "alrededor de {{count}} meses"
    },
    xMonths: {
      one: "1 mes",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "alrededor de 1 año",
      other: "alrededor de {{count}} años"
    },
    xYears: {
      one: "1 año",
      other: "{{count}} años"
    },
    overXYears: {
      one: "más de 1 año",
      other: "más de {{count}} años"
    },
    almostXYears: {
      one: "casi 1 año",
      other: "casi {{count}} años"
    }
  }, a = function(u, s, i) {
    var l, d = r[u];
    return typeof d == "string" ? l = d : s === 1 ? l = d.one : l = d.other.replace("{{count}}", s.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "en " + l : "hace " + l : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Ta, Ta.exports);
var Am = Ta.exports, ka = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, u = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(ka, ka.exports);
var Wm = ka.exports, Ra = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'mañana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
  }, a = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'mañana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
  }, n = function(s, i, l, d) {
    return i.getUTCHours() !== 1 ? a[s] : r[s];
  }, o = n;
  e.default = o, t.exports = e.default;
})(Ra, Ra.exports);
var Im = Ra.exports, ja = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ue), n = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "después de cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, u = {
    narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
  }, s = {
    narrow: ["d", "l", "m", "m", "j", "v", "s"],
    short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
    abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
  }, i = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    }
  }, d = function(f, v) {
    var h = Number(f);
    return h + "º";
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(f) {
        return Number(f) - 1;
      }
    }),
    month: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = m;
  e.default = p, t.exports = e.default;
})(ja, ja.exports);
var Nm = ja.exports, Aa = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Xe), n = r(Ke), o = /^(\d+)(º)?/i, u = /\d+/i, s = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
  }, i = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
  }, p = {
    narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
  }, c = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
  }, f = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
  }, v = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
  }, h = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn/i,
      noon: /^md/i,
      morning: /mañana/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noche/i
    }
  }, y = {
    ordinalNumber: (0, a.default)({
      matchPattern: o,
      parsePattern: u,
      valueCallback: function(b) {
        return parseInt(b, 10);
      }
    }),
    era: (0, n.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, n.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(b) {
        return b + 1;
      }
    }),
    month: (0, n.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, n.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, n.default)({
      matchPatterns: v,
      defaultMatchWidth: "any",
      parsePatterns: h,
      defaultParseWidth: "any"
    })
  }, w = y;
  e.default = w, t.exports = e.default;
})(Aa, Aa.exports);
var Fm = Aa.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Am), n = r(Wm), o = r(Im), u = r(Nm), s = r(Fm), i = {
    code: "es",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: u.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 1
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Ca, Ca.exports);
var Lm = Ca.exports;
const Hm = /* @__PURE__ */ Me(Lm);
var Wa = { exports: {} }, Ia = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "moins d’une seconde",
      other: "moins de {{count}} secondes"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
      one: "moins d’une minute",
      other: "moins de {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "environ 1 heure",
      other: "environ {{count}} heures"
    },
    xHours: {
      one: "1 heure",
      other: "{{count}} heures"
    },
    xDays: {
      one: "1 jour",
      other: "{{count}} jours"
    },
    aboutXWeeks: {
      one: "environ 1 semaine",
      other: "environ {{count}} semaines"
    },
    xWeeks: {
      one: "1 semaine",
      other: "{{count}} semaines"
    },
    aboutXMonths: {
      one: "environ 1 mois",
      other: "environ {{count}} mois"
    },
    xMonths: {
      one: "1 mois",
      other: "{{count}} mois"
    },
    aboutXYears: {
      one: "environ 1 an",
      other: "environ {{count}} ans"
    },
    xYears: {
      one: "1 an",
      other: "{{count}} ans"
    },
    overXYears: {
      one: "plus d’un an",
      other: "plus de {{count}} ans"
    },
    almostXYears: {
      one: "presqu’un an",
      other: "presque {{count}} ans"
    }
  }, a = function(u, s, i) {
    var l, d = r[u];
    return typeof d == "string" ? l = d : s === 1 ? l = d.one : l = d.other.replace("{{count}}", String(s)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "dans " + l : "il y a " + l : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Ia, Ia.exports);
var $m = Ia.exports, Na = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, u = {
    full: "{{date}} 'à' {{time}}",
    long: "{{date}} 'à' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(Na, Na.exports);
var zm = Na.exports, Fa = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "eeee 'dernier à' p",
    yesterday: "'hier à' p",
    today: "'aujourd’hui à' p",
    tomorrow: "'demain à' p'",
    nextWeek: "eeee 'prochain à' p",
    other: "P"
  }, a = function(u, s, i, l) {
    return r[u];
  }, n = a;
  e.default = n, t.exports = e.default;
})(Fa, Fa.exports);
var Ym = Fa.exports, La = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ue), n = {
    narrow: ["av. J.-C", "ap. J.-C"],
    abbreviated: ["av. J.-C", "ap. J.-C"],
    wide: ["avant Jésus-Christ", "après Jésus-Christ"]
  }, o = {
    narrow: ["T1", "T2", "T3", "T4"],
    abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
    wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
  }, u = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
    wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
  }, s = {
    narrow: ["D", "L", "M", "M", "J", "V", "S"],
    short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
    abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
    wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
  }, i = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "mat.",
      afternoon: "ap.m.",
      evening: "soir",
      night: "mat."
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "matin",
      afternoon: "après-midi",
      evening: "soir",
      night: "matin"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "du matin",
      afternoon: "de l’après-midi",
      evening: "du soir",
      night: "du matin"
    }
  }, l = function(c, f) {
    var v = Number(c), h = f == null ? void 0 : f.unit;
    if (v === 0)
      return "0";
    var y = ["year", "week", "hour", "minute", "second"], w;
    return v === 1 ? w = h && y.includes(h) ? "ère" : "er" : w = "ème", v + w;
  }, d = {
    ordinalNumber: l,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(c) {
        return c - 1;
      }
    }),
    month: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    })
  }, m = d;
  e.default = m, t.exports = e.default;
})(La, La.exports);
var Bm = La.exports, Ha = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = r(Xe), o = /^(\d+)(ième|ère|ème|er|e)?/i, u = /\d+/i, s = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
  }, i = {
    any: [/^av/i, /^ap/i]
  }, l = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
  }, f = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
  }, v = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
  }, h = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^min/i,
      noon: /^mid/i,
      morning: /mat/i,
      afternoon: /ap/i,
      evening: /soir/i,
      night: /nuit/i
    }
  }, y = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: u,
      valueCallback: function(b) {
        return parseInt(b);
      }
    }),
    era: (0, a.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(b) {
        return b + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "any",
      parsePatterns: h,
      defaultParseWidth: "any"
    })
  }, w = y;
  e.default = w, t.exports = e.default;
})(Ha, Ha.exports);
var qm = Ha.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r($m), n = r(zm), o = r(Ym), u = r(Bm), s = r(qm), i = {
    code: "fr",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: u.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Wa, Wa.exports);
var Um = Wa.exports;
const Km = /* @__PURE__ */ Me(Um);
var $a = { exports: {} }, za = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "meno di un secondo",
      other: "meno di {{count}} secondi"
    },
    xSeconds: {
      one: "un secondo",
      other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
      one: "meno di un minuto",
      other: "meno di {{count}} minuti"
    },
    xMinutes: {
      one: "un minuto",
      other: "{{count}} minuti"
    },
    aboutXHours: {
      one: "circa un'ora",
      other: "circa {{count}} ore"
    },
    xHours: {
      one: "un'ora",
      other: "{{count}} ore"
    },
    xDays: {
      one: "un giorno",
      other: "{{count}} giorni"
    },
    aboutXWeeks: {
      one: "circa una settimana",
      other: "circa {{count}} settimane"
    },
    xWeeks: {
      one: "una settimana",
      other: "{{count}} settimane"
    },
    aboutXMonths: {
      one: "circa un mese",
      other: "circa {{count}} mesi"
    },
    xMonths: {
      one: "un mese",
      other: "{{count}} mesi"
    },
    aboutXYears: {
      one: "circa un anno",
      other: "circa {{count}} anni"
    },
    xYears: {
      one: "un anno",
      other: "{{count}} anni"
    },
    overXYears: {
      one: "più di un anno",
      other: "più di {{count}} anni"
    },
    almostXYears: {
      one: "quasi un anno",
      other: "quasi {{count}} anni"
    }
  }, a = function(u, s, i) {
    var l, d = r[u];
    return typeof d == "string" ? l = d : s === 1 ? l = d.one : l = d.other.replace("{{count}}", s.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "tra " + l : l + " fa" : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(za, za.exports);
var Xm = za.exports, Ya = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, u = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(Ya, Ya.exports);
var Vm = Ya.exports, Ba = { exports: {} }, qa = { exports: {} }, Ua = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a, n) {
    if (n.length < a)
      throw new TypeError(a + " argument" + (a > 1 ? "s" : "") + " required, but only " + n.length + " present");
  }
  t.exports = e.default;
})(Ua, Ua.exports);
var zn = Ua.exports, Ka = { exports: {} }, Xa = { exports: {} }, iu = { exports: {} };
(function(t) {
  function e(r) {
    "@babel/helpers - typeof";
    return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
      return typeof a;
    } : function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(iu);
var Qm = iu.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var a = r(Qm), n = r(zn);
  function o(u) {
    (0, n.default)(1, arguments);
    var s = Object.prototype.toString.call(u);
    return u instanceof Date || (0, a.default)(u) === "object" && s === "[object Date]" ? new Date(u.getTime()) : typeof u == "number" || s === "[object Number]" ? new Date(u) : ((typeof u == "string" || s === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  t.exports = e.default;
})(Xa, Xa.exports);
var Gm = Xa.exports, Va = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  function r(a) {
    if (a === null || a === !0 || a === !1)
      return NaN;
    var n = Number(a);
    return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  t.exports = e.default;
})(Va, Va.exports);
var Jm = Va.exports, gr = {};
Object.defineProperty(gr, "__esModule", {
  value: !0
});
gr.getDefaultOptions = Zm;
gr.setDefaultOptions = ev;
var uu = {};
function Zm() {
  return uu;
}
function ev(t) {
  uu = t;
}
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = s;
  var a = r(Gm), n = r(zn), o = r(Jm), u = gr;
  function s(i, l) {
    var d, m, p, c, f, v, h, y;
    (0, n.default)(1, arguments);
    var w = (0, u.getDefaultOptions)(), g = (0, o.default)((d = (m = (p = (c = l == null ? void 0 : l.weekStartsOn) !== null && c !== void 0 ? c : l == null || (f = l.locale) === null || f === void 0 || (v = f.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && p !== void 0 ? p : w.weekStartsOn) !== null && m !== void 0 ? m : (h = w.locale) === null || h === void 0 || (y = h.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && d !== void 0 ? d : 0);
    if (!(g >= 0 && g <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var b = (0, a.default)(i), E = b.getUTCDay(), O = (E < g ? 7 : 0) + E - g;
    return b.setUTCDate(b.getUTCDate() - O), b.setUTCHours(0, 0, 0, 0), b;
  }
  t.exports = e.default;
})(Ka, Ka.exports);
var tv = Ka.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var a = r(zn), n = r(tv);
  function o(u, s, i) {
    (0, a.default)(2, arguments);
    var l = (0, n.default)(u, i), d = (0, n.default)(s, i);
    return l.getTime() === d.getTime();
  }
  t.exports = e.default;
})(qa, qa.exports);
var rv = qa.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(rv), n = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
  function o(m) {
    switch (m) {
      case 0:
        return "'domenica scorsa alle' p";
      default:
        return "'" + n[m] + " scorso alle' p";
    }
  }
  function u(m) {
    return "'" + n[m] + " alle' p";
  }
  function s(m) {
    switch (m) {
      case 0:
        return "'domenica prossima alle' p";
      default:
        return "'" + n[m] + " prossimo alle' p";
    }
  }
  var i = {
    lastWeek: function(p, c, f) {
      var v = p.getUTCDay();
      return (0, a.default)(p, c, f) ? u(v) : o(v);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function(p, c, f) {
      var v = p.getUTCDay();
      return (0, a.default)(p, c, f) ? u(v) : s(v);
    },
    other: "P"
  }, l = function(p, c, f, v) {
    var h = i[p];
    return typeof h == "function" ? h(c, f, v) : h;
  }, d = l;
  e.default = d, t.exports = e.default;
})(Ba, Ba.exports);
var av = Ba.exports, Qa = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ue), n = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["avanti Cristo", "dopo Cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, u = {
    narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
    abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
    wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
  }, s = {
    narrow: ["D", "L", "M", "M", "G", "V", "S"],
    short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
  }, i = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    }
  }, l = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    }
  }, d = function(f, v) {
    var h = Number(f);
    return String(h);
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(f) {
        return f - 1;
      }
    }),
    month: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = m;
  e.default = p, t.exports = e.default;
})(Qa, Qa.exports);
var nv = Qa.exports, Ga = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = r(Xe), o = /^(\d+)(º)?/i, u = /\d+/i, s = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
  }, i = {
    any: [/^a/i, /^(d|e)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
  }, p = {
    narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
  }, f = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
    any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
  }, v = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
  }, h = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mezza/i,
      noon: /^mezzo/i,
      morning: /mattina/i,
      afternoon: /pomeriggio/i,
      evening: /sera/i,
      night: /notte/i
    }
  }, y = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: u,
      valueCallback: function(b) {
        return parseInt(b, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(b) {
        return b + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "any",
      parsePatterns: h,
      defaultParseWidth: "any"
    })
  }, w = y;
  e.default = w, t.exports = e.default;
})(Ga, Ga.exports);
var ov = Ga.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Xm), n = r(Vm), o = r(av), u = r(nv), s = r(ov), i = {
    code: "it",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: u.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})($a, $a.exports);
var iv = $a.exports;
const uv = /* @__PURE__ */ Me(iv);
var Ja = { exports: {} }, Za = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "minder dan een seconde",
      other: "minder dan {{count}} seconden"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
      one: "minder dan een minuut",
      other: "minder dan {{count}} minuten"
    },
    xMinutes: {
      one: "een minuut",
      other: "{{count}} minuten"
    },
    aboutXHours: {
      one: "ongeveer 1 uur",
      other: "ongeveer {{count}} uur"
    },
    xHours: {
      one: "1 uur",
      other: "{{count}} uur"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dagen"
    },
    aboutXWeeks: {
      one: "ongeveer 1 week",
      other: "ongeveer {{count}} weken"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weken"
    },
    aboutXMonths: {
      one: "ongeveer 1 maand",
      other: "ongeveer {{count}} maanden"
    },
    xMonths: {
      one: "1 maand",
      other: "{{count}} maanden"
    },
    aboutXYears: {
      one: "ongeveer 1 jaar",
      other: "ongeveer {{count}} jaar"
    },
    xYears: {
      one: "1 jaar",
      other: "{{count}} jaar"
    },
    overXYears: {
      one: "meer dan 1 jaar",
      other: "meer dan {{count}} jaar"
    },
    almostXYears: {
      one: "bijna 1 jaar",
      other: "bijna {{count}} jaar"
    }
  }, a = function(u, s, i) {
    var l, d = r[u];
    return typeof d == "string" ? l = d : s === 1 ? l = d.one : l = d.other.replace("{{count}}", String(s)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "over " + l : l + " geleden" : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(Za, Za.exports);
var sv = Za.exports, en = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, u = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(en, en.exports);
var lv = en.exports, tn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
  }, a = function(u, s, i, l) {
    return r[u];
  }, n = a;
  e.default = n, t.exports = e.default;
})(tn, tn.exports);
var dv = tn.exports, rn = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ue), n = {
    narrow: ["v.C.", "n.C."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["voor Christus", "na Christus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["K1", "K2", "K3", "K4"],
    wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
  }, u = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
  }, s = {
    narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
    short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
    abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
    wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
  }, i = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    }
  }, l = function(c, f) {
    var v = Number(c);
    return v + "e";
  }, d = {
    ordinalNumber: l,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(c) {
        return c - 1;
      }
    }),
    month: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide"
    })
  }, m = d;
  e.default = m, t.exports = e.default;
})(rn, rn.exports);
var cv = rn.exports, an = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = r(Xe), o = /^(\d+)e?/i, u = /\d+/i, s = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
  }, i = {
    any: [/^v/, /^n/]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
  }, c = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
  }, f = {
    narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
    any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
  }, v = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
  }, h = {
    any: {
      am: /^am/i,
      pm: /^pm/i,
      midnight: /^middernacht/i,
      noon: /^het middaguur/i,
      morning: /ochtend/i,
      afternoon: /middag/i,
      evening: /avond/i,
      night: /nacht/i
    }
  }, y = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: u,
      valueCallback: function(b) {
        return parseInt(b, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(b) {
        return b + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "any",
      parsePatterns: h,
      defaultParseWidth: "any"
    })
  }, w = y;
  e.default = w, t.exports = e.default;
})(an, an.exports);
var fv = an.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(sv), n = r(lv), o = r(dv), u = r(cv), s = r(fv), i = {
    code: "nl",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: u.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(Ja, Ja.exports);
var mv = Ja.exports;
const vv = /* @__PURE__ */ Me(mv);
var nn = { exports: {} }, on = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "menos de um segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
      one: "menos de um minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "aproximadamente 1 hora",
      other: "aproximadamente {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 dia",
      other: "{{count}} dias"
    },
    aboutXWeeks: {
      one: "aproximadamente 1 semana",
      other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "aproximadamente 1 mês",
      other: "aproximadamente {{count}} meses"
    },
    xMonths: {
      one: "1 mês",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "aproximadamente 1 ano",
      other: "aproximadamente {{count}} anos"
    },
    xYears: {
      one: "1 ano",
      other: "{{count}} anos"
    },
    overXYears: {
      one: "mais de 1 ano",
      other: "mais de {{count}} anos"
    },
    almostXYears: {
      one: "quase 1 ano",
      other: "quase {{count}} anos"
    }
  }, a = function(u, s, i) {
    var l, d = r[u];
    return typeof d == "string" ? l = d : s === 1 ? l = d.one : l = d.other.replace("{{count}}", String(s)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "daqui a " + l : "há " + l : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(on, on.exports);
var hv = on.exports, un = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, u = {
    full: "{{date}} 'às' {{time}}",
    long: "{{date}} 'às' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(un, un.exports);
var pv = un.exports, sn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: function(u) {
      var s = u.getUTCDay(), i = s === 0 || s === 6 ? "último" : "última";
      return "'" + i + "' eeee 'às' p";
    },
    yesterday: "'ontem às' p",
    today: "'hoje às' p",
    tomorrow: "'amanhã às' p",
    nextWeek: "eeee 'às' p",
    other: "P"
  }, a = function(u, s, i, l) {
    var d = r[u];
    return typeof d == "function" ? d(s) : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(sn, sn.exports);
var bv = sn.exports, ln = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ue), n = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["antes de Cristo", "depois de Cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, u = {
    narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
  }, s = {
    narrow: ["d", "s", "t", "q", "q", "s", "s"],
    short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
  }, i = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "noite",
      night: "madrugada"
    }
  }, l = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da noite",
      night: "da madrugada"
    }
  }, d = function(f, v) {
    var h = Number(f);
    return h + "º";
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(f) {
        return f - 1;
      }
    }),
    month: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = m;
  e.default = p, t.exports = e.default;
})(ln, ln.exports);
var gv = ln.exports, dn = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = r(Xe), o = /^(\d+)(º|ª)?/i, u = /\d+/i, s = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
  }, i = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
  }, f = {
    narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
    any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
  }, v = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
  }, h = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^meia/i,
      noon: /^meio/i,
      morning: /manh[ãa]/i,
      afternoon: /tarde/i,
      evening: /noite/i,
      night: /madrugada/i
    }
  }, y = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: u,
      valueCallback: function(b) {
        return parseInt(b, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(b) {
        return b + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "any",
      parsePatterns: h,
      defaultParseWidth: "any"
    })
  }, w = y;
  e.default = w, t.exports = e.default;
})(dn, dn.exports);
var yv = dn.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(hv), n = r(pv), o = r(bv), u = r(gv), s = r(yv), i = {
    code: "pt",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: u.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(nn, nn.exports);
var wv = nn.exports;
const Mv = /* @__PURE__ */ Me(wv);
var cn = { exports: {} }, fn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "menos de um segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
      one: "menos de um minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "cerca de 1 hora",
      other: "cerca de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 dia",
      other: "{{count}} dias"
    },
    aboutXWeeks: {
      one: "cerca de 1 semana",
      other: "cerca de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "cerca de 1 mês",
      other: "cerca de {{count}} meses"
    },
    xMonths: {
      one: "1 mês",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "cerca de 1 ano",
      other: "cerca de {{count}} anos"
    },
    xYears: {
      one: "1 ano",
      other: "{{count}} anos"
    },
    overXYears: {
      one: "mais de 1 ano",
      other: "mais de {{count}} anos"
    },
    almostXYears: {
      one: "quase 1 ano",
      other: "quase {{count}} anos"
    }
  }, a = function(u, s, i) {
    var l, d = r[u];
    return typeof d == "string" ? l = d : s === 1 ? l = d.one : l = d.other.replace("{{count}}", String(s)), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "em " + l : "há " + l : l;
  }, n = a;
  e.default = n, t.exports = e.default;
})(fn, fn.exports);
var _v = fn.exports, mn = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
  }, o = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, u = {
    full: "{{date}} 'às' {{time}}",
    long: "{{date}} 'às' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(mn, mn.exports);
var Ev = mn.exports, vn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: function(u) {
      var s = u.getUTCDay(), i = s === 0 || s === 6 ? "último" : "última";
      return "'" + i + "' eeee 'às' p";
    },
    yesterday: "'ontem às' p",
    today: "'hoje às' p",
    tomorrow: "'amanhã às' p",
    nextWeek: "eeee 'às' p",
    other: "P"
  }, a = function(u, s, i, l) {
    var d = r[u];
    return typeof d == "function" ? d(s) : d;
  }, n = a;
  e.default = n, t.exports = e.default;
})(vn, vn.exports);
var Pv = vn.exports, hn = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ue), n = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "depois de cristo"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  }, u = {
    narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
    wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
  }, s = {
    narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
    short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
    abbreviated: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
    wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
  }, i = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "manhã",
      afternoon: "tarde",
      evening: "tarde",
      night: "noite"
    }
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "meia-noite",
      noon: "meio-dia",
      morning: "da manhã",
      afternoon: "da tarde",
      evening: "da tarde",
      night: "da noite"
    }
  }, d = function(f, v) {
    var h = Number(f);
    return (v == null ? void 0 : v.unit) === "week" ? h + "ª" : h + "º";
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(f) {
        return f - 1;
      }
    }),
    month: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = m;
  e.default = p, t.exports = e.default;
})(hn, hn.exports);
var Ov = hn.exports, pn = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = r(Xe), o = /^(\d+)[ºªo]?/i, u = /\d+/i, s = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
  }, i = {
    any: [/^ac/i, /^dc/i],
    wide: [/^antes de cristo/i, /^depois de cristo/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
  }, c = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
  }, f = {
    short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
    narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
    any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
  }, v = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
  }, h = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn|^meia[-\s]noite/i,
      noon: /^md|^meio[-\s]dia/i,
      morning: /manhã/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noite/i
    }
  }, y = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: u,
      valueCallback: function(b) {
        return parseInt(b, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(b) {
        return b + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "any",
      parsePatterns: h,
      defaultParseWidth: "any"
    })
  }, w = y;
  e.default = w, t.exports = e.default;
})(pn, pn.exports);
var xv = pn.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_v), n = r(Ev), o = r(Pv), u = r(Ov), s = r(xv), i = {
    code: "pt-BR",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: u.default,
    match: s.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(cn, cn.exports);
var Dv = cn.exports;
const Sv = /* @__PURE__ */ Me(Dv);
var bn = { exports: {} }, gn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lessThanXSeconds: {
      one: "mindre än en sekund",
      other: "mindre än {{count}} sekunder"
    },
    xSeconds: {
      one: "en sekund",
      other: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
      one: "mindre än en minut",
      other: "mindre än {{count}} minuter"
    },
    xMinutes: {
      one: "en minut",
      other: "{{count}} minuter"
    },
    aboutXHours: {
      one: "ungefär en timme",
      other: "ungefär {{count}} timmar"
    },
    xHours: {
      one: "en timme",
      other: "{{count}} timmar"
    },
    xDays: {
      one: "en dag",
      other: "{{count}} dagar"
    },
    aboutXWeeks: {
      one: "ungefär en vecka",
      other: "ungefär {{count}} vecka"
    },
    xWeeks: {
      one: "en vecka",
      other: "{{count}} vecka"
    },
    aboutXMonths: {
      one: "ungefär en månad",
      other: "ungefär {{count}} månader"
    },
    xMonths: {
      one: "en månad",
      other: "{{count}} månader"
    },
    aboutXYears: {
      one: "ungefär ett år",
      other: "ungefär {{count}} år"
    },
    xYears: {
      one: "ett år",
      other: "{{count}} år"
    },
    overXYears: {
      one: "över ett år",
      other: "över {{count}} år"
    },
    almostXYears: {
      one: "nästan ett år",
      other: "nästan {{count}} år"
    }
  }, a = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], n = function(s, i, l) {
    var d, m = r[s];
    return typeof m == "string" ? d = m : i === 1 ? d = m.one : l && l.onlyNumeric ? d = m.other.replace("{{count}}", String(i)) : d = m.other.replace("{{count}}", i < 13 ? a[i] : String(i)), l != null && l.addSuffix ? l.comparison && l.comparison > 0 ? "om " + d : d + " sedan" : d;
  }, o = n;
  e.default = o, t.exports = e.default;
})(gn, gn.exports);
var Cv = gn.exports, yn = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(_e), n = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "y-MM-dd"
  }, o = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  }, u = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  }, s = {
    date: (0, a.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: u,
      defaultWidth: "full"
    })
  }, i = s;
  e.default = i, t.exports = e.default;
})(yn, yn.exports);
var Tv = yn.exports, wn = { exports: {} };
(function(t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'igår kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
  }, a = function(u, s, i, l) {
    return r[u];
  }, n = a;
  e.default = n, t.exports = e.default;
})(wn, wn.exports);
var kv = wn.exports, Mn = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ue), n = {
    narrow: ["f.Kr.", "e.Kr."],
    abbreviated: ["f.Kr.", "e.Kr."],
    wide: ["före Kristus", "efter Kristus"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
  }, u = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
  }, s = {
    narrow: ["S", "M", "T", "O", "T", "F", "L"],
    short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
    abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
    wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
  }, i = {
    narrow: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "morg.",
      afternoon: "efterm.",
      evening: "kväll",
      night: "natt"
    },
    abbreviated: {
      am: "f.m.",
      pm: "e.m.",
      midnight: "midnatt",
      noon: "middag",
      morning: "morgon",
      afternoon: "efterm.",
      evening: "kväll",
      night: "natt"
    },
    wide: {
      am: "förmiddag",
      pm: "eftermiddag",
      midnight: "midnatt",
      noon: "middag",
      morning: "morgon",
      afternoon: "eftermiddag",
      evening: "kväll",
      night: "natt"
    }
  }, l = {
    narrow: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morg.",
      afternoon: "på efterm.",
      evening: "på kvällen",
      night: "på natten"
    },
    abbreviated: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morg.",
      afternoon: "på efterm.",
      evening: "på kvällen",
      night: "på natten"
    },
    wide: {
      am: "fm",
      pm: "em",
      midnight: "midnatt",
      noon: "middag",
      morning: "på morgonen",
      afternoon: "på eftermiddagen",
      evening: "på kvällen",
      night: "på natten"
    }
  }, d = function(f, v) {
    var h = Number(f), y = h % 100;
    if (y > 20 || y < 10)
      switch (y % 10) {
        case 1:
        case 2:
          return h + ":a";
      }
    return h + ":e";
  }, m = {
    ordinalNumber: d,
    era: (0, a.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, a.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(f) {
        return f - 1;
      }
    }),
    month: (0, a.default)({
      values: u,
      defaultWidth: "wide"
    }),
    day: (0, a.default)({
      values: s,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, a.default)({
      values: i,
      defaultWidth: "wide",
      formattingValues: l,
      defaultFormattingWidth: "wide"
    })
  }, p = m;
  e.default = p, t.exports = e.default;
})(Mn, Mn.exports);
var Rv = Mn.exports, _n = { exports: {} };
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Ke), n = r(Xe), o = /^(\d+)(:a|:e)?/i, u = /\d+/i, s = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
  }, i = {
    any: [/^f/i, /^[ev]/i]
  }, l = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
  }, d = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, m = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
  }, p = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, c = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
  }, f = {
    any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
  }, v = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
  }, h = {
    any: {
      am: /^f/i,
      pm: /^e/i,
      midnight: /^midn/i,
      noon: /^midd/i,
      morning: /morgon/i,
      afternoon: /eftermiddag/i,
      evening: /kväll/i,
      night: /natt/i
    }
  }, y = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: u,
      valueCallback: function(b) {
        return parseInt(b, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: s,
      defaultMatchWidth: "wide",
      parsePatterns: i,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: d,
      defaultParseWidth: "any",
      valueCallback: function(b) {
        return b + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: m,
      defaultMatchWidth: "wide",
      parsePatterns: p,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: c,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: v,
      defaultMatchWidth: "any",
      parsePatterns: h,
      defaultParseWidth: "any"
    })
  }, w = y;
  e.default = w, t.exports = e.default;
})(_n, _n.exports);
var jv = _n.exports;
(function(t, e) {
  var r = L.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var a = r(Cv), n = r(Tv), o = r(kv), u = r(Rv), s = r(jv), i = {
    code: "sv",
    formatDistance: a.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: u.default,
    match: s.default,
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  }, l = i;
  e.default = l, t.exports = e.default;
})(bn, bn.exports);
var Av = bn.exports;
const Wv = /* @__PURE__ */ Me(Av), ce = {
  da: nm,
  de: cm,
  enAU: vm,
  enCA: gm,
  enGB: Mm,
  enIN: Pm,
  enNZ: Dm,
  enUS: Tm,
  enZA: jm,
  es: Hm,
  fr: Km,
  it: uv,
  nl: vv,
  pt: Mv,
  ptBR: Sv,
  sv: Wv
}, et = {
  AU: {
    countryCode: "AU",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: ce.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-AU",
    name: "AU"
  },
  BR: {
    countryCode: "BR",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "HH:mm a",
        timeDateFull: "d 'de' MMM yyyy, HH:mm",
        timeDateShort: "d 'de' MMM, HH:mm",
        timeDayDateShort: "EEE, d 'de' MMM, HH:mm"
      },
      locale: ce.ptBR,
      timezone: "America/Sao_Paulo",
      today: "Hoje"
    },
    locale: "pt-BR",
    name: "BR"
  },
  CA: {
    countryCode: "CA",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm a",
        timeDateFull: "MMMM d, yyyy, h:mm a",
        timeDateShort: "MMM d, h:mm a",
        timeDayDateShort: "EEE, MMM d, h:mm a"
      },
      locale: ce.enCA,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-CA",
    name: "CA"
  },
  CO: {
    countryCode: "CO",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.es,
      timezone: "America/Bogota",
      today: "Hoy"
    },
    locale: "es-CO",
    name: "CO"
  },
  CX: {
    countryCode: "CX",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: ce.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-CX",
    name: "CX"
  },
  DE: {
    countryCode: "DE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE, d. MMM, HH:mm"
      },
      locale: ce.de,
      timezone: "Europe/Berlin",
      today: "Heute"
    },
    locale: "de-DE",
    name: "DE"
  },
  DK: {
    countryCode: "DK",
    dateProperties: {
      format: {
        dateFull: "EEEE 'den' d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE 'den' d. MMM, HH:mm"
      },
      locale: ce.da,
      timezone: "Europe/Copenhagen",
      today: "I dag"
    },
    locale: "da-DK",
    name: "DK"
  },
  ES: {
    countryCode: "ES",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.es,
      timezone: "Europe/Madrid",
      today: "Hoy"
    },
    locale: "es-ES",
    name: "ES"
  },
  FR: {
    countryCode: "FR",
    dateProperties: {
      format: {
        dateFull: "EEEE d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.fr,
      timezone: "Europe/Paris",
      today: "Aujourd'hui"
    },
    locale: "fr-FR",
    name: "FR"
  },
  GZ: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "GZ"
  },
  IN: {
    countryCode: "IN",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.enIN,
      timezone: "Asia/Kolkata",
      today: "Today"
    },
    locale: "en-IN",
    name: "IN"
  },
  IT: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "IT"
  },
  KE: {
    countryCode: "KE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.enGB,
      timezone: "Africa/Nairobi",
      today: "Today"
    },
    locale: "en-KE",
    name: "KE"
  },
  NG: {
    countryCode: "NG",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.enGB,
      timezone: "Africa/Lagos",
      today: "Today"
    },
    locale: "en-NG",
    name: "NG"
  },
  NL: {
    countryCode: "NL",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.nl,
      timezone: "Europe/Amsterdam",
      today: "Vandaag"
    },
    locale: "nl-NL",
    name: "NL"
  },
  NZ: {
    countryCode: "NZ",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.enNZ,
      timezone: "Pacific/Auckland",
      today: "Today"
    },
    locale: "en-NZ",
    name: "NZ"
  },
  OC: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: ce.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "OC"
  },
  PT: {
    countryCode: "PT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.pt,
      timezone: "Europe/Lisbon",
      today: "Hoje"
    },
    locale: "pt-PT",
    name: "PT"
  },
  SE: {
    countryCode: "SE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.sv,
      timezone: "Europe/Stockholm",
      today: "Idag"
    },
    locale: "sv-SE",
    name: "SE"
  },
  SM: {
    countryCode: "SM",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: ce.it,
      timezone: "Europe/San_Marino",
      today: "Oggi"
    },
    locale: "it-SM",
    name: "SM"
  },
  US: {
    countryCode: "US",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm aa zzz",
        timeDateFull: "MMMM d, yyyy, h:mm aa zzz",
        timeDateShort: "MM/dd h:mm aa",
        timeDayDateShort: "EEE MMM d, h:mm aa zzz"
      },
      locale: ce.enUS,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-US",
    name: "US"
  },
  WS: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: ce.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "WS"
  },
  XX: {
    countryCode: "XX",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.enUS,
      // Placeholder locale
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "xx-XX",
    name: "XX"
  },
  ZA: {
    countryCode: "ZA",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ce.enZA,
      timezone: "Africa/Johannesburg",
      today: "Today"
    },
    locale: "en-ZA",
    name: "ZA"
  }
}, Iv = [et.IT.name, et.ES.name, et.BR.name], su = [
  { id: 18, name: "AMERICAN FOOTBALL", translationFile: "american_football" },
  { id: 11, name: "ATHLETICS", translationFile: "athletics" },
  { id: 23, name: "AUSSIE RULES", translationFile: "aussie_rules" },
  { id: 32, name: "BADMINTON", translationFile: "badminton" },
  { id: 48, name: "BANDY", translationFile: "bandy" },
  { id: 46, name: "BASEBALL", translationFile: "baseball" },
  { id: 47, name: "BASKETBALL", translationFile: "basketball" },
  { id: 28, name: "BETTYPE", translationFile: "bettype" },
  { id: 31, name: "BOWLS", translationFile: "bowls" },
  { id: 10, name: "BOXING", translationFile: "boxing" },
  { id: 76, name: "CASINO", translationFile: "casino" },
  { id: 19, name: "CRICKET", translationFile: "cricket" },
  { id: 14, name: "CYCLING", translationFile: "cycling" },
  { id: 21, name: "DARTS", translationFile: "darts" },
  { id: 49, name: "DUMMY", translationFile: "dummy" },
  { id: 33, name: "EQUESTRIAN", translationFile: "equestrian" },
  { id: 34, name: "FINANCIAL", translationFile: "financial" },
  { id: 29, name: "FLOORBALL", translationFile: "floorball" },
  { id: 2, name: "FOOTBALL", translationFile: "football" },
  { id: 24, name: "GAELIC SPORTS", translationFile: "gaelic_sports" },
  { id: 6, name: "GOLF", translationFile: "golf" },
  { id: 5, name: "GREYHOUNDS", translationFile: "greyhounds" },
  { id: 35, name: "HANDBALL", translationFile: "handball" },
  { id: 74, name: "HARNESS RACING", translationFile: "harness_racing" },
  { id: 36, name: "HOCKEY", translationFile: "hockey" },
  { id: 3, name: "HORSE RACING", translationFile: "horse_racing" },
  { id: 45, name: "ICE HOCKEY", translationFile: "ice_hockey" },
  { id: 0, name: "LABEL", translationFile: "label" },
  { id: 27, name: "MENU", translationFile: "menu" },
  { id: 17, name: "MOTOR SPORT", translationFile: "motor_sport" },
  { id: 37, name: "NETBALL", translationFile: "netball" },
  { id: 62, name: "OLYMPICS", translationFile: "olympics" },
  { id: 26, name: "OTHER SPORTS", translationFile: "other_sports" },
  { id: 25, name: "POKER", translationFile: "poker" },
  { id: 68, name: "POLITICS", translationFile: "politics" },
  { id: 20, name: "POOL", translationFile: "pool" },
  { id: 22, name: "ROWING", translationFile: "rowing" },
  { id: 30, name: "RUGBY LEAGUE", translationFile: "rugby_league" },
  { id: 9, name: "RUGBY UNION", translationFile: "rugby_union" },
  { id: 8, name: "SNOOKER", translationFile: "snooker" },
  { id: 15, name: "SPECIALS", translationFile: "specials" },
  { id: 38, name: "SWIMMING", translationFile: "swimming" },
  { id: 39, name: "TABLE TENNIS", translationFile: "table_tennis" },
  { id: 7, name: "TENNIS", translationFile: "tennis" },
  { id: 40, name: "TROTTING", translationFile: "trotting" },
  { id: 71, name: "TV", translationFile: "tv" },
  { id: 61, name: "VIRTUAL FOOTBALL", translationFile: "virtual_football" },
  { id: 58, name: "VIRTUAL MOTORSPORT", translationFile: "virtual_motorsport" },
  { id: 41, name: "VOLLEYBALL", translationFile: "volleyball" },
  { id: 42, name: "WATER POLO", translationFile: "water_polo" },
  { id: 43, name: "WINTER SPORTS", translationFile: "winter_sports" },
  { id: 44, name: "YACHTING", translationFile: "yachting" }
], Nv = (t) => {
  var e;
  return (e = su.find((r) => r.id === t)) == null ? void 0 : e.translationFile;
};
/*! js-cookie v3.0.8 | MIT */
function ur(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var a in r)
      a !== "__proto__" && (t[a] = r[a]);
  }
  return t;
}
var Fv = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function En(t, e) {
  function r(n, o, u) {
    if (!(typeof document > "u")) {
      u = ur({}, e, u), typeof u.expires == "number" && (u.expires = new Date(Date.now() + u.expires * 864e5)), u.expires && (u.expires = u.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var i in u)
        u[i] && (s += "; " + i, u[i] !== !0 && (s += "=" + u[i].split(";")[0]));
      return document.cookie = n + "=" + t.write(o, n) + s;
    }
  }
  function a(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], u = {}, s = 0; s < o.length; s++) {
        var i = o[s].split("="), l = i.slice(1).join("=");
        try {
          var d = decodeURIComponent(i[0]);
          if (d in u || (u[d] = t.read(l, d)), n === d)
            break;
        } catch {
        }
      }
      return n ? u[n] : u;
    }
  }
  return Object.create(
    {
      set: r,
      get: a,
      remove: function(n, o) {
        r(
          n,
          "",
          ur({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return En(this.converter, ur({}, this.attributes, n));
      },
      withConverter: function(n) {
        return En(ur({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
En(Fv, { path: "/" });
nt(void 0);
const Lv = () => `${typeof window < "u" ? window.location.origin : ""}/api/cx/sports-catalogue`;
function Ko(t) {
  const e = [" v ", " at "];
  for (const r of e) {
    const a = t.split(r);
    if (a.length === 2) {
      const [n, o] = a.map((u) => u.trim());
      return r === " v " ? { away: o, first: n, home: n, second: o, separator: r, success: !0 } : { away: n, first: n, home: o, second: o, separator: r, success: !0 };
    }
  }
  return {
    away: "",
    first: "",
    home: "",
    second: "",
    separator: "",
    success: !1
  };
}
const Hv = [
  // GTM/Google Debug
  "gtm_debug",
  "debug",
  // Cache bypass
  "nocache",
  // Google Ads/Analytics
  "gclid",
  "gclsrc",
  "_gl",
  // UTM Campaign Tracking
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id"
];
function lu(t, e) {
  if (!e && typeof window > "u")
    return t;
  try {
    const r = new URL(e || window.location.href), a = new URLSearchParams(r.search), n = [];
    for (const s of Hv) {
      const i = a.get(s);
      i !== null && n.push([s, i]);
    }
    if (n.length === 0)
      return t;
    const o = t.startsWith("http://") || t.startsWith("https://"), u = o ? new URL(t) : new URL(t, r.origin);
    for (const [s, i] of n)
      u.searchParams.has(s) || u.searchParams.set(s, i);
    return o ? u.toString() : u.pathname + u.search + u.hash;
  } catch {
    return t;
  }
}
const $v = "application/json", du = "Content-Type", Mt = Symbol(), cu = Symbol();
function Xo(t = {}) {
  var e;
  const r = t instanceof Array ? Object.fromEntries(t) : t;
  return (e = Object.entries(r).find(([a]) => a.toLowerCase() === du.toLowerCase())) === null || e === void 0 ? void 0 : e[1];
}
function Vo(t) {
  return /^application\/.*json.*/.test(t);
}
const ct = function(t, e, r = !1) {
  return Object.entries(e).reduce((a, [n, o]) => {
    const u = t[n];
    return Array.isArray(u) && Array.isArray(o) ? a[n] = r ? [...u, ...o] : o : typeof u == "object" && typeof o == "object" ? a[n] = ct(u, o, r) : a[n] = o, a;
  }, { ...t });
}, Tt = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(t, e = !0, r = !1, ...a) {
    const n = this.polyfills[t] || (typeof self < "u" ? self[t] : null) || (typeof global < "u" ? global[t] : null);
    if (e && !n)
      throw new Error(t + " is not defined");
    return r && n ? new n(...a) : n;
  }
};
function zv(t, e = !1) {
  Tt.options = e ? t : ct(Tt.options, t);
}
function Yv(t, e = !1) {
  Tt.polyfills = e ? t : ct(Tt.polyfills, t);
}
function Bv(t) {
  Tt.errorType = t;
}
const qv = (t) => (e) => t.reduceRight((r, a) => a(r), e) || e;
class fu extends Error {
}
const Uv = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  t = t._addons.reduce((g, b) => b.beforeRequest && b.beforeRequest(g, t._options, e) || g, t);
  const { _url: r, _options: a, _config: n, _catchers: o, _resolvers: u, _middlewares: s, _addons: i } = t, l = new Map(o), d = ct(n.options, a);
  let m = r;
  const p = qv(s)((g, b) => (m = g, n.polyfill("fetch")(g, b)))(r, d), c = new Error(), f = p.catch((g) => {
    throw { [Mt]: g };
  }).then((g) => {
    var b;
    if (!g.ok) {
      const E = new fu();
      if (E.cause = c, E.stack = E.stack + `
CAUSE: ` + c.stack, E.response = g, E.status = g.status, E.url = m, g.type === "opaque")
        throw E;
      const O = n.errorType === "json" || ((b = g.headers.get("Content-Type")) === null || b === void 0 ? void 0 : b.split(";")[0]) === "application/json";
      return (n.errorType ? O ? g.text() : g[n.errorType]() : Promise.resolve(g.body)).then((S) => {
        if (E.message = typeof S == "string" ? S : g.statusText, S)
          if (O && typeof S == "string") {
            E.text = S;
            try {
              E.json = JSON.parse(S);
            } catch {
            }
          } else
            E[n.errorType] = S;
        throw E;
      });
    }
    return g;
  }), v = (g) => g.catch((b) => {
    const E = Object.prototype.hasOwnProperty.call(b, Mt), O = E ? b[Mt] : b, T = (O == null ? void 0 : O.status) && l.get(O.status) || l.get(O == null ? void 0 : O.name) || E && l.has(Mt) && l.get(Mt);
    if (T)
      return T(O, t);
    const S = l.get(cu);
    if (S)
      return S(O, t);
    throw O;
  }), h = (g) => (b) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ v(g ? f.then((E) => E && E[g]()).then((E) => b ? b(E) : E) : f.then((E) => b ? b(E) : E)), y = {
    _wretchReq: t,
    _fetchReq: p,
    _sharedState: e,
    res: h(null),
    json: h("json"),
    blob: h("blob"),
    formData: h("formData"),
    arrayBuffer: h("arrayBuffer"),
    text: h("text"),
    error(g, b) {
      return l.set(g, b), this;
    },
    badRequest(g) {
      return this.error(400, g);
    },
    unauthorized(g) {
      return this.error(401, g);
    },
    forbidden(g) {
      return this.error(403, g);
    },
    notFound(g) {
      return this.error(404, g);
    },
    timeout(g) {
      return this.error(408, g);
    },
    internalError(g) {
      return this.error(500, g);
    },
    fetchError(g) {
      return this.error(Mt, g);
    }
  }, w = i.reduce((g, b) => ({
    ...g,
    ...typeof b.resolver == "function" ? b.resolver(g) : b.resolver
  }), y);
  return u.reduce((g, b) => b(g, t), w);
}, Kv = {
  _url: "",
  _options: {},
  _config: Tt,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(t) {
    return { ...this, _addons: [...this._addons, t], ...t.wretch };
  },
  errorType(t) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: t
      }
    };
  },
  polyfills(t, e = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: e ? t : ct(this._config.polyfills, t)
      }
    };
  },
  url(t, e = !1) {
    if (e)
      return { ...this, _url: t };
    const r = this._url.split("?");
    return {
      ...this,
      _url: r.length > 1 ? r[0] + t + "?" + r[1] : this._url + t
    };
  },
  options(t, e = !1) {
    return { ...this, _options: e ? t : ct(this._options, t) };
  },
  headers(t) {
    const e = t ? Array.isArray(t) ? Object.fromEntries(t) : "entries" in t ? Object.fromEntries(t.entries()) : t : {};
    return { ...this, _options: ct(this._options, { headers: e }) };
  },
  accept(t) {
    return this.headers({ Accept: t });
  },
  content(t) {
    return this.headers({ [du]: t });
  },
  auth(t) {
    return this.headers({ Authorization: t });
  },
  catcher(t, e) {
    const r = new Map(this._catchers);
    return r.set(t, e), { ...this, _catchers: r };
  },
  catcherFallback(t) {
    return this.catcher(cu, t);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(t, e = !1) {
    return { ...this, _resolvers: e ? [t] : [...this._resolvers, t] };
  },
  defer(t, e = !1) {
    return {
      ...this,
      _deferred: e ? [t] : [...this._deferred, t]
    };
  },
  middlewares(t, e = !1) {
    return {
      ...this,
      _middlewares: e ? t : [...this._middlewares, ...t]
    };
  },
  fetch(t = this._options.method, e = "", r = null) {
    let a = this.url(e).options({ method: t });
    const n = Xo(a._options.headers), o = this._config.polyfill("FormData", !1), u = typeof r == "object" && !(o && r instanceof o) && (!a._options.headers || !n || Vo(n));
    return a = r ? u ? a.json(r, n) : a.body(r) : a, Uv(a._deferred.reduce((s, i) => i(s, s._url, s._options), a));
  },
  get(t = "") {
    return this.fetch("GET", t);
  },
  delete(t = "") {
    return this.fetch("DELETE", t);
  },
  put(t, e = "") {
    return this.fetch("PUT", e, t);
  },
  post(t, e = "") {
    return this.fetch("POST", e, t);
  },
  patch(t, e = "") {
    return this.fetch("PATCH", e, t);
  },
  head(t = "") {
    return this.fetch("HEAD", t);
  },
  opts(t = "") {
    return this.fetch("OPTIONS", t);
  },
  body(t) {
    return { ...this, _options: { ...this._options, body: t } };
  },
  json(t, e) {
    const r = Xo(this._options.headers);
    return this.content(e || Vo(r) && r || $v).body(JSON.stringify(t));
  }
};
function vt(t = "", e = {}) {
  return { ...Kv, _url: t, _options: e };
}
vt.default = vt;
vt.options = zv;
vt.errorType = Bv;
vt.polyfills = Yv;
vt.WretchError = fu;
class Xv extends Error {
  constructor(r, a, n, o, u) {
    super(r);
    Ve(this, "statusCode");
    Ve(this, "endpoint");
    Ve(this, "args");
    Ve(this, "response");
    this.name = "ApiError", this.statusCode = a, this.endpoint = n, this.args = o, this.response = u;
  }
}
class Yn extends Xv {
  constructor(e, r, a, n) {
    super(`Client error ${e} occurred while fetching ${r}`, e, r, a, n), this.name = "Api4xxError";
  }
}
class Vv extends Yn {
  constructor(e, r, a) {
    super(404, e, r, a), this.name = "Api404Error";
  }
}
class Qv extends Yn {
  constructor(e, r, a) {
    super(400, e, r, a), this.name = "Api400Error";
  }
}
class Gv {
  constructor(e = {}) {
    Ve(this, "logger");
    Ve(this, "notFoundLogLevel");
    Ve(this, "badRequestLogLevel");
    Ve(this, "other4xxLogLevel");
    this.logger = e.logger, this.notFoundLogLevel = e.notFoundLogLevel || "info", this.badRequestLogLevel = e.badRequestLogLevel || "warn", this.other4xxLogLevel = e.other4xxLogLevel || "warn";
  }
  log(e, r, a) {
    this.logger && this.logger[e](r, a);
  }
  async handleApiError(e, r, a) {
    if (!(e instanceof Response))
      throw e;
    const { status: n } = e;
    if (n === 404) {
      const o = new Vv(r, a, e);
      return this.log(this.notFoundLogLevel, o.message, {
        args: a,
        endpoint: r,
        statusCode: n
      }), null;
    }
    if (n === 400) {
      const o = new Qv(r, a, e);
      return this.log(this.badRequestLogLevel, o.message, {
        args: a,
        endpoint: r,
        statusCode: n
      }), null;
    }
    if (n >= 400 && n < 500) {
      const o = new Yn(n, r, a, e);
      return this.log(this.other4xxLogLevel, o.message, {
        args: a,
        endpoint: r,
        statusCode: n
      }), null;
    }
    throw e;
  }
}
const Jv = (t, e) => {
  const r = new Gv(e);
  return t.catcher(404, async (a) => (await r.handleApiError(a.response, a.url), null)).catcher(400, async (a) => (await r.handleApiError(a.response, a.url), null)).catcher(401, async (a) => (await r.handleApiError(a.response, a.url), null)).catcher(403, async (a) => (await r.handleApiError(a.response, a.url), null)).catcherFallback(async (a) => {
    if (a.status >= 400 && a.status < 500)
      return await r.handleApiError(a.response, a.url), null;
    throw a;
  });
}, mu = async (t = Lv(), e, r) => {
  const { repub: a, subeventId: n } = e, o = new URL(`${t}/v1/subevent-header/${n}`);
  return Jv(
    vt(o.toString(), {
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        repub: a,
        ...(r == null ? void 0 : r.nocache) && { "Cache-Control": "no-cache" }
      }
    }),
    r
  ).get().json();
}, vu = ({ repub: t, subeventId: e }) => [
  "subevent-header",
  t,
  e
], Zv = () => /* @__PURE__ */ $(
  "svg",
  {
    fill: "currentColor",
    height: "100%",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 24 24",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ $(
      "path",
      {
        d: "M12 10.545l5.818-5.818c.402-.401 1.053-.401 1.455 0 .401.402.401 1.053 0 1.455L13.455 12l5.818 5.818c.401.402.401 1.053 0 1.455-.402.401-1.053.401-1.455 0L12 13.455l-5.818 5.818c-.402.401-1.053.401-1.455 0-.401-.402-.401-1.053 0-1.455L10.545 12 4.727 6.182c-.401-.402-.401-1.053 0-1.455.402-.401 1.053-.401 1.455 0L12 10.545z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  }
), eh = "_dropdownPillButton_g7z5b_1", th = "_dropdownPillIconWrapper_g7z5b_22", rh = "_dropdownPanel_g7z5b_31", ah = "_dropdownTitleWrapper_g7z5b_41", nh = "_dropdownTitle_g7z5b_41", oh = "_dropdownItem_g7z5b_56", ih = "_dropdownItemActive_g7z5b_68", uh = "_dropdownCloseButton_g7z5b_77", sh = "_dropdownMenuSeparator_g7z5b_84", ze = {
  dropdownPillButton: eh,
  dropdownPillIconWrapper: th,
  dropdownPanel: rh,
  dropdownTitleWrapper: ah,
  dropdownTitle: nh,
  dropdownItem: oh,
  dropdownItemActive: ih,
  dropdownCloseButton: uh,
  dropdownMenuSeparator: sh
}, hu = Go(
  ({ disclosure: t, menu: e, menuItems: r, menuProps: a, title: n, ...o }, u) => {
    const s = () => /* @__PURE__ */ $(tc, { ref: u, ...e, ...o, ...t.props, children: (d) => Mr(t, {
      ...d,
      id: "menu-button",
      key: "menu-button"
    }) }), i = /* @__PURE__ */ Re(Bn, { children: [
      /* @__PURE__ */ Re("div", { className: ze.dropdownTitleWrapper, children: [
        /* @__PURE__ */ $("h4", { className: ze.dropdownTitle, "data-testid": "dropdown-title", children: n }),
        /* @__PURE__ */ $("button", { className: ze.dropdownCloseButton, onClick: e.toggle, children: /* @__PURE__ */ $(Zv, {}) })
      ] }),
      /* @__PURE__ */ $(So, { className: ze.dropdownMenuSeparator })
    ] }), l = () => /* @__PURE__ */ Re(Gd, { ...e, ...a, ref: u, children: [
      i,
      r.map((d, m) => d.type === So ? Mr(d, {
        ...e,
        ...d.props,
        id: "menu-separator",
        key: `menu-separator-${m}`
      }) : /* @__PURE__ */ Le(lc, { ...e, ...d.props, id: m, key: d.key || m, ref: u }, (p) => Mr(d, {
        ...p,
        id: `menu-item-${m}`,
        key: `menu-item-${m}`
      })))
    ] });
    return /* @__PURE__ */ Re(Bn, { children: [
      s(),
      l()
    ] });
  }
);
hu.displayName = "Dropdown";
const lh = (t) => {
  const e = ee(!0);
  ie(() => {
    if (e.current) {
      e.current = !1;
      return;
    }
    t();
  }, [t]);
};
var dh = typeof Ft == "object" && Ft && Ft.Object === Object && Ft, ch = typeof self == "object" && self && self.Object === Object && self;
dh || ch || Function("return this")();
nt({
  pageUrl: ""
});
function Qo({
  ariaLabel: t,
  baseId: e,
  button: r,
  buttonText: a,
  items: n,
  onClick: o,
  onHide: u,
  onShow: s,
  placement: i,
  renderItem: l,
  title: d
}) {
  const m = fc({
    baseId: e || void 0,
    gutter: 7,
    placement: i || "bottom"
  }), { visible: p } = m, c = N(() => {
    p && s ? s() : !p && u && u();
  }, [u, s, p]);
  lh(c);
  const f = Fe(() => r || /* @__PURE__ */ $("button", { className: ze.dropdownPillButton, children: a }), [r, a]), v = Fe(() => n.map((y, w) => {
    const g = w === 0, b = {
      ...g ? {} : { onClick: () => o(y) }
    };
    return (
      // Key is applied by Reakit in <Dropdown /> component so we can
      // ignore here:
      // eslint-disable-next-line react/jsx-key
      /* @__PURE__ */ $(
        "div",
        {
          className: `${ze.dropdownItem}${g ? ` ${ze.dropdownItemActive}` : ""}`,
          ...b,
          "data-testid": "dropdown-item",
          children: l(y, w)
        }
      )
    );
  }), [n, o, l]);
  return /* @__PURE__ */ $(
    hu,
    {
      "data-testid": "dropdown-menu",
      disclosure: f,
      menu: m,
      menuItems: v,
      menuProps: {
        "aria-label": t,
        className: ze.dropdownPanel
      },
      title: d
    }
  );
}
const jr = () => /* @__PURE__ */ $(
  "svg",
  {
    fill: "currentColor",
    height: "100%",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 6 12",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ $(
      "path",
      {
        clipRule: "evenodd",
        d: "M0.409017 6.69364C0.0361104 6.30639 0.0361104 5.6936 0.409017 5.30635L4.4669 1.09239C4.69078 0.859913 5.06296 0.859913 5.28683 1.09239C5.49907 1.31279 5.49907 1.66156 5.28683 1.88196L1.32131 6L5.28683 10.118C5.49907 10.3384 5.49907 10.6872 5.28683 10.9076C5.06296 11.1401 4.69078 11.1401 4.4669 10.9076L0.409017 6.69364Z",
        fillRule: "evenodd"
      }
    )
  }
), fh = "_subeventHeaderWrapper_1s8el_1", mh = "_subeventHeaderInnerWrapper_1s8el_6", vh = "_breadcrumbIcon_1s8el_19", hh = "_subeventEventLinkWrapper_1s8el_27", ph = "_subeventEventLink_1s8el_27", bh = "_subeventHeaderContentContainer_1s8el_61", gh = "_subeventTitle_1s8el_79", yh = "_subeventTitleMobileDropdown_1s8el_89", wh = "_subeventTitleMobile_1s8el_89", Mh = "_dropdownButtonWrapper_1s8el_111", _h = "_dropdownIcon_1s8el_118", Eh = "_subeventMenuWrapper_1s8el_127", Ph = "_relatedSubeventContainer_1s8el_136", Oh = "_relatedSubeventDatetime_1s8el_142", xh = "_relatedSubeventNameContainer_1s8el_151", Dh = "_relatedSubeventName_1s8el_151", Sh = "_subeventHeaderTextWrapper_1s8el_168", Ch = "_subeventDatetime_1s8el_190", Th = "_subeventDatetimeWrapper_1s8el_205", kh = "_offersPresentIcon_1s8el_216", Rh = "_matchStatsNewIcon_1s8el_223", jh = "_inPlayIcon_1s8el_231", Ah = "_menuDivider_1s8el_246", Wh = "_liveStatsHeaderFallback_1s8el_258", Ih = "_desktopOnly_1s8el_267", Nh = "_mobileOnly_1s8el_276", fe = {
  subeventHeaderWrapper: fh,
  subeventHeaderInnerWrapper: mh,
  breadcrumbIcon: vh,
  subeventEventLinkWrapper: hh,
  subeventEventLink: ph,
  subeventHeaderContentContainer: bh,
  subeventTitle: gh,
  subeventTitleMobileDropdown: yh,
  subeventTitleMobile: wh,
  dropdownButtonWrapper: Mh,
  dropdownIcon: _h,
  subeventMenuWrapper: Eh,
  relatedSubeventContainer: Ph,
  relatedSubeventDatetime: Oh,
  relatedSubeventNameContainer: xh,
  relatedSubeventName: Dh,
  subeventHeaderTextWrapper: Sh,
  "change-match-dropdown": "_change-match-dropdown_1s8el_1",
  subeventDatetime: Ch,
  subeventDatetimeWrapper: Th,
  offersPresentIcon: kh,
  matchStatsNewIcon: Rh,
  inPlayIcon: jh,
  menuDivider: Ah,
  liveStatsHeaderFallback: Wh,
  desktopOnly: Ih,
  mobileOnly: Nh
}, Fh = ({ breadcrumb: t, categoryGroupId: e, eventName: r, requestUrl: a }) => {
  const n = Nv(e), { t: o } = Hn([n ?? "label"]);
  return /* @__PURE__ */ $(
    "a",
    {
      className: `${fe.subeventEventLink} ogm-subevent-header__breadcrumb`,
      "data-testid": "event-name",
      href: lu(t.url, a),
      title: t.name,
      children: o(r, { ns: n })
    }
  );
}, Lh = ({ dataApiEndpoint: t, i18n: e, ...r }) => {
  const { data: a } = ju({
    queryFn: () => mu(t, r, {
      logger: console
    }),
    queryKey: vu(r)
  }), { dropdownText: n, overrideTitle: o, repub: u, requestUrl: s, timeZone: i } = r, {
    breadcrumbs: l = [],
    eventName: d = "",
    inRunning: m = !1,
    relatedSubevents: p = [],
    subeventName: c = "",
    subeventStartTime: f = ""
  } = a || {}, v = i ?? et[u].dateProperties.timezone, h = su.find((F) => F.id === (a == null ? void 0 : a.categoryGroupId)), w = [(h == null ? void 0 : h.translationFile) || "", "label", "bettype"], { t: g } = Hn(w), b = N(
    (F) => {
      const B = Ko(F);
      return B.success ? `${g(B.first)}${B.separator}${g(B.second)}`.trim() : g(F);
    },
    [g]
  ), E = Ko(c), O = e == null ? void 0 : e.exists("CX_SUBEVENT_HEADER_PREFIX", { fallbackLng: [], ns: "label" }), T = E.success && O ? g("CX_SUBEVENT_HEADER_PREFIX", { ns: "label" }) : "", S = Iv.includes(u), P = o && o !== c, _ = S ? b(c) : c, x = `${T} ${P ? o : _}`.trim(), D = Fe(
    () => [
      {
        subeventName: c,
        subeventStartTime: f,
        subeventUrl: ""
      },
      ...p.map((F) => ({
        subeventName: F.subeventName || F.name,
        subeventStartTime: F.subeventStartTime || F.startTime,
        subeventUrl: F.subeventUrl || F.url
      }))
    ].map((F) => ({
      ...F,
      id: F.subeventName
    })),
    [p, c, f]
  ), I = l[l.length - 2], C = (F) => {
    const B = "subeventUrl" in F ? F.subeventUrl : F.url;
    window.location.href = lu(B);
  }, A = N((F) => {
    document.body.style.overflow = F ? "hidden" : "visible";
  }, []), V = N(() => {
    A(!1);
  }, [A]), J = N(() => {
    A(!0);
  }, [A]), Z = N(
    (F) => F ? Uo(F, v, et[u].dateProperties.format.timeDateShort, {
      locale: et[u].dateProperties.locale
    }) : "",
    [v, u]
  ), de = N(
    (F) => F ? Uo(F, v, et[u].dateProperties.format.timeDateFull, {
      locale: et[u].dateProperties.locale
    }) : "",
    [v, u]
  ), ae = Fe(
    () => /* @__PURE__ */ Re("button", { className: ze.dropdownPillButton, "data-label": n, children: [
      n,
      /* @__PURE__ */ $("span", { className: ze.dropdownPillIconWrapper, children: /* @__PURE__ */ $(jr, {}) })
    ] }),
    [n]
  ), ne = Fe(
    () => /* @__PURE__ */ Re("h1", { className: fe.subeventTitleMobile, "data-label": n, children: [
      `${x} `,
      /* @__PURE__ */ $("span", { className: fe.dropdownButtonWrapper, children: /* @__PURE__ */ $("span", { className: fe.dropdownIcon, children: /* @__PURE__ */ $(jr, {}) }) })
    ] }),
    [x, n]
  ), ve = N(
    (F) => {
      const B = "subeventStartTime" in F ? F.subeventStartTime : F.startTime, Q = "subeventName" in F ? F.subeventName : F.name, be = S ? b(Q) : Q;
      return /* @__PURE__ */ Re("div", { className: fe.relatedSubeventContainer, children: [
        /* @__PURE__ */ $("span", { className: fe.relatedSubeventDatetime, children: Z(B) }),
        /* @__PURE__ */ $("div", { className: fe.relatedSubeventNameContainer, children: /* @__PURE__ */ $("span", { className: fe.relatedSubeventName, children: be }) })
      ] });
    },
    [S, b, Z]
  );
  return a ? /* @__PURE__ */ $(Gi, { i18nInstance: e, children: /* @__PURE__ */ $(Qi, { children: /* @__PURE__ */ $("div", { className: fe.subeventHeaderWrapper, "data-testid": "subevent-header", children: /* @__PURE__ */ Re("div", { className: fe.subeventHeaderInnerWrapper, children: [
    !!I && /* @__PURE__ */ Re("div", { className: fe.subeventEventLinkWrapper, children: [
      /* @__PURE__ */ $("span", { className: fe.breadcrumbIcon, children: /* @__PURE__ */ $(jr, {}) }),
      /* @__PURE__ */ $(
        Fh,
        {
          breadcrumb: I,
          categoryGroupId: a.categoryGroupId,
          eventName: d,
          requestUrl: s
        }
      )
    ] }),
    /* @__PURE__ */ $("div", { className: fe.subeventBodyWrapper, id: "subevent-header", children: /* @__PURE__ */ Re("div", { className: fe.subeventHeaderContentContainer, children: [
      /* @__PURE__ */ Re("div", { className: `${fe.subeventHeaderTextWrapper} ogm-subevent-header__title`, children: [
        /* @__PURE__ */ $("div", { className: fe.desktopOnly, children: /* @__PURE__ */ Re("h1", { className: fe.subeventTitle, "data-testid": "subevent-title", children: [
          x,
          m && /* @__PURE__ */ $("span", { className: fe.inPlayIcon, children: g("CX_MATCHES_COUPON_LIVE", { ns: "label" }) })
        ] }) }),
        /* @__PURE__ */ $("div", { className: fe.desktopOnly, children: /* @__PURE__ */ $(
          Qo,
          {
            ariaLabel: n,
            baseId: "change-match-dropdown-desktop",
            button: ae,
            buttonText: n,
            items: D,
            onClick: C,
            onHide: V,
            onShow: J,
            placement: "bottom",
            renderItem: ve,
            title: d
          }
        ) }),
        /* @__PURE__ */ $("div", { className: fe.mobileOnly, children: /* @__PURE__ */ $(
          Qo,
          {
            ariaLabel: n,
            baseId: "change-match-dropdown-mobile",
            button: ne,
            buttonText: n,
            items: D,
            onClick: C,
            onHide: V,
            onShow: J,
            placement: "bottom-start",
            renderItem: ve,
            title: d
          }
        ) })
      ] }),
      /* @__PURE__ */ $("div", { className: fe.subeventDatetimeWrapper, children: /* @__PURE__ */ $(
        "time",
        {
          className: fe.subeventDatetime,
          "data-testid": "subevent-date",
          dateTime: de(f),
          children: de(f)
        }
      ) })
    ] }) })
  ] }) }) }) }) : null;
}, Ar = {
  desktop: 1024,
  desktopLg: 1360,
  desktopMd: 1200,
  phoneLg: 600,
  phoneSm: 320,
  tablet: 768
};
function Hh(t = {}) {
  var e;
  return new Ru.QueryClient({
    ...t,
    defaultOptions: {
      ...t.defaultOptions,
      queries: {
        retry: 3,
        retryDelay(r) {
          return r * 100;
        },
        ...(e = t.defaultOptions) == null ? void 0 : e.queries
      }
    }
  });
}
const Vh = async (t, e) => {
  const r = Hh(), { nocache: a } = t;
  try {
    await r.prefetchQuery({
      queryFn: () => mu(e, t, { nocache: a }),
      queryKey: vu(t)
    });
  } catch {
  }
  return {
    dehydratedState: Au(r)
  };
}, $h = (t) => new Nu({
  defaultOptions: {
    queries: {
      gcTime: t ? 0 : void 0,
      refetchOnMount: !!t,
      staleTime: t ? 0 : 1 / 0
    }
  }
});
function Qh({ dehydratedState: t, deviceType: e, nocache: r, ...a }) {
  const [n] = le(() => {
    const s = $h(r);
    return Wu(s, t), s;
  }), o = /* @__PURE__ */ $(Qi, { children: /* @__PURE__ */ $(Iu, { client: n, children: /* @__PURE__ */ $(Gi, { i18nInstance: a.i18n, children: /* @__PURE__ */ $(ku, { fallback: /* @__PURE__ */ $(hc, {}), children: /* @__PURE__ */ $(Lh, { ...a }) }) }) }) });
  if (typeof window < "u")
    return o;
  const u = e === "MOBILE" ? Ar.phoneSm : e === "TABLET" ? Ar.tablet : Ar.desktop;
  return /* @__PURE__ */ $($u.Context.Provider, { value: { width: u }, children: o });
}
export {
  Qh as SubeventHeaderWithQuery,
  Vh as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
